/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

export type AddHostingResult = {
  __typename?: 'AddHostingResult';
  show?: Maybe<Podcast>;
  subscription?: Maybe<Subscription>;
};

export type AdditionalFile = {
  __typename?: 'AdditionalFile';
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdditionalFileInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalInput = {
  artist?: InputMaybe<Scalars['String']['input']>;
  artwork_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  episode_number?: InputMaybe<Scalars['String']['input']>;
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  publish_now?: InputMaybe<Scalars['Boolean']['input']>;
  season_number?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AdminFile = {
  __typename?: 'AdminFile';
  audioJobId?: Maybe<Scalars['ID']['output']>;
  bucket: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type AlituCancelSchedulePublishResponse = {
  __typename?: 'AlituCancelSchedulePublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituPublishResponse = {
  __typename?: 'AlituPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituPublishedEpisodes = {
  __typename?: 'AlituPublishedEpisodes';
  episodes: Array<Episode>;
  total: Scalars['Int']['output'];
};

export type AlituUnpublishResponse = {
  __typename?: 'AlituUnpublishResponse';
  success: Scalars['Boolean']['output'];
};

export type AlituUpdatePublishedDate = {
  __typename?: 'AlituUpdatePublishedDate';
  success: Scalars['Boolean']['output'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  apiKeyId: Scalars['String']['output'];
  apiKeyValue: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type ApiKeyUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppStat = {
  __typename?: 'AppStat';
  appName: Scalars['String']['output'];
  downloads: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

export type AppleShowStatus = {
  __typename?: 'AppleShowStatus';
  exists: Scalars['Boolean']['output'];
};

export type ArtworkInput = {
  artworkUploadKey?: InputMaybe<Scalars['String']['input']>;
  deleteArtwork?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssumeUser = {
  __typename?: 'AssumeUser';
  sessionId: Scalars['ID']['output'];
  user: User;
};

export type AudioItem = {
  __typename?: 'AudioItem';
  end: Scalars['Float']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type BackgroundItem = {
  __typename?: 'BackgroundItem';
  end: Scalars['Float']['output'];
  fadeInDuration: Scalars['Float']['output'];
  fadeOutDuration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
  volume: Scalars['Float']['output'];
};

export type BleepItem = {
  __typename?: 'BleepItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type BuzzsproutPublishResponse = {
  __typename?: 'BuzzsproutPublishResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Call = {
  __typename?: 'Call';
  createdAt: Scalars['String']['output'];
  creator: User;
  creatorTwilioId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  ongoing: Scalars['Boolean']['output'];
  room: Scalars['ID']['output'];
  solo: Scalars['Boolean']['output'];
};

export type Captivate = {
  __typename?: 'Captivate';
  token?: Maybe<Scalars['JSON']['output']>;
};

export type CaptivatePublishResponse = {
  __typename?: 'CaptivatePublishResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CaptivateShow = {
  id: Scalars['ID']['input'];
  timeZone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CaptivateShows = {
  __typename?: 'CaptivateShows';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CastosLoginResponse = {
  __typename?: 'CastosLoginResponse';
  isTokenValid: Scalars['Boolean']['output'];
};

export type CastosPodcast = {
  __typename?: 'CastosPodcast';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CastosPublishResponse = {
  __typename?: 'CastosPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type CelloTokenResponse = {
  __typename?: 'CelloTokenResponse';
  productId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Chapter = {
  __typename?: 'Chapter';
  start: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ChapterInput = {
  start: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ClipTimingsInput = {
  duration: Scalars['Float']['input'];
  timelineStart: Scalars['Float']['input'];
};

export type CodecFormat = {
  __typename?: 'CodecFormat';
  duration: Scalars['String']['output'];
};

export type CodecImage = {
  __typename?: 'CodecImage';
  format?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CodecInformation = {
  __typename?: 'CodecInformation';
  format?: Maybe<CodecFormat>;
  image?: Maybe<CodecImage>;
};

export type Company = {
  isVatIdValid?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

export type ConfirmationSecret = {
  __typename?: 'ConfirmationSecret';
  client_secret: Scalars['String']['output'];
};

export type ConnectAlituHostResponse = {
  __typename?: 'ConnectAlituHostResponse';
  show: Podcast;
  success: Scalars['Boolean']['output'];
};

export enum ContentType {
  Audio = 'audio',
  Video = 'video'
}

export type Countries = {
  __typename?: 'Countries';
  alpha2Code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: Scalars['String']['output'];
  regionalBlocs?: Maybe<Array<Maybe<RegionalBlocs>>>;
};

export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percent_off?: Maybe<Scalars['Float']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
};

export type CreateFileResponse = {
  __typename?: 'CreateFileResponse';
  fileId: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
};

export type CreateRecordingResponse = {
  __typename?: 'CreateRecordingResponse';
  fileId?: Maybe<Scalars['ID']['output']>;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  session: Scalars['ID']['output'];
  show: Podcast;
  user: User;
};

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<StripeAddress>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type CustomerTaxId = {
  __typename?: 'CustomerTaxId';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DeleteSubdomainResponse = {
  __typename?: 'DeleteSubdomainResponse';
  success: Scalars['Boolean']['output'];
};

export type DeletedEpisodeResponse = {
  __typename?: 'DeletedEpisodeResponse';
  deletedEpisodeId: Scalars['ID']['output'];
};

export type DemoAndTranscript = {
  __typename?: 'DemoAndTranscript';
  demoFile: File;
  transcript: Transcription;
};

export type Discount = {
  __typename?: 'Discount';
  coupon?: Maybe<Coupon>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Episode = {
  __typename?: 'Episode';
  artworkUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  file?: Maybe<File>;
  guid?: Maybe<Scalars['String']['output']>;
  hasArtwork?: Maybe<Scalars['Boolean']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchivedVersion?: Maybe<Scalars['Boolean']['output']>;
  metaData: EpisodeMetaData;
  metaDataNeedsReprocessing?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  schedulePublishAt?: Maybe<Scalars['String']['output']>;
  shouldIncludeTranscriptInRss?: Maybe<Scalars['Boolean']['output']>;
  shouldSuggestDescription?: Maybe<Scalars['Boolean']['output']>;
  shouldSuggestTitle?: Maybe<Scalars['Boolean']['output']>;
  timeline: Array<EpisodeFile>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
  videoMode: Scalars['Boolean']['output'];
};

export type EpisodeFile = {
  __typename?: 'EpisodeFile';
  additionalFiles?: Maybe<Array<AdditionalFile>>;
  audioTimeline?: Maybe<Array<TimelineItem>>;
  bucket?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  fade: EpisodeFileFade;
  hasVideo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  name: Scalars['String']['output'];
  overlapDuration?: Maybe<Scalars['Float']['output']>;
  tags: Array<Scalars['String']['output']>;
  trimSource?: Maybe<EpisodeFileTrimSource>;
  trimmedDuration?: Maybe<Scalars['Float']['output']>;
  type: EpisodeFileType;
  uniqueId: Scalars['ID']['output'];
  visual?: Maybe<EpisodeFileVisual>;
};

export type EpisodeFileFade = {
  __typename?: 'EpisodeFileFade';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingIn?: Maybe<Scalars['Boolean']['output']>;
  isFadingOut?: Maybe<Scalars['Boolean']['output']>;
};

export type EpisodeFileInput = {
  additionalFiles?: InputMaybe<Array<AdditionalFileInput>>;
  audioTimeline?: InputMaybe<Array<TimelineItemInput>>;
  fade?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  overlapDuration?: InputMaybe<Scalars['Float']['input']>;
  trimSource?: InputMaybe<EpisodeFileTrimSourceInput>;
  trimmedDuration?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['ID']['input']>;
  visual?: InputMaybe<EpisodeFileVisualInput>;
};

export type EpisodeFileJob = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type EpisodeFileTrimSource = {
  __typename?: 'EpisodeFileTrimSource';
  inPoint?: Maybe<Scalars['Float']['output']>;
  outPoint?: Maybe<Scalars['Float']['output']>;
};

export type EpisodeFileTrimSourceInput = {
  inPoint?: InputMaybe<Scalars['Float']['input']>;
  outPoint?: InputMaybe<Scalars['Float']['input']>;
};

export enum EpisodeFileType {
  Intro = 'intro',
  Outro = 'outro',
  Timeline = 'timeline'
}

export type EpisodeFileVisual = {
  __typename?: 'EpisodeFileVisual';
  customImageFileId?: Maybe<Scalars['ID']['output']>;
  layout: EpisodeFileVisualLayout;
  replaceVideo?: Maybe<Scalars['Boolean']['output']>;
  source: EpisodeFileVisualSource;
};

export type EpisodeFileVisualInput = {
  customImageFileId?: InputMaybe<Scalars['ID']['input']>;
  layout?: InputMaybe<EpisodeFileVisualLayoutInput>;
  replaceVideo?: InputMaybe<Scalars['Boolean']['input']>;
  source: EpisodeFileVisualSource;
};

export type EpisodeFileVisualLayout = {
  __typename?: 'EpisodeFileVisualLayout';
  blurredBackground: Scalars['Boolean']['output'];
  mode: EpisodeFileVisualLayoutMode;
};

export type EpisodeFileVisualLayoutInput = {
  blurredBackground?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<EpisodeFileVisualLayoutMode>;
};

export enum EpisodeFileVisualLayoutMode {
  Center = 'center',
  Cover = 'cover',
  Fit = 'fit',
  Stretch = 'stretch'
}

export enum EpisodeFileVisualSource {
  Blank = 'blank',
  CustomImage = 'customImage',
  EpisodeArtwork = 'episodeArtwork',
  ShowArtwork = 'showArtwork'
}

export type EpisodeMetaData = {
  __typename?: 'EpisodeMetaData';
  description?: Maybe<Scalars['String']['output']>;
  episodeNumber?: Maybe<Scalars['Float']['output']>;
  hostNames?: Maybe<Scalars['String']['output']>;
  isExplicit?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  seasonNumber?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EpisodeType>;
};

export type EpisodeMetaDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  episodeNumber?: InputMaybe<Scalars['Float']['input']>;
  hostNames?: InputMaybe<Scalars['String']['input']>;
  isExplicit?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  seasonNumber?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EpisodeType>;
};

export type EpisodeSocialClip = {
  __typename?: 'EpisodeSocialClip';
  createdAt: Scalars['String']['output'];
  episodeId: Scalars['ID']['output'];
  file?: Maybe<File>;
  generatedSchemaHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGeneratedFileStale: Scalars['Boolean']['output'];
  job?: Maybe<Job>;
  name: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
  schemaHash: Scalars['String']['output'];
  sourceFileId?: Maybe<Scalars['ID']['output']>;
  state: SocialClipState;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type EpisodeStats = {
  __typename?: 'EpisodeStats';
  deletedAt?: Maybe<Scalars['Date']['output']>;
  episodeId: Scalars['ID']['output'];
  episodeNumber?: Maybe<Scalars['String']['output']>;
  forever: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  quarter: Scalars['Int']['output'];
  today: Scalars['Int']['output'];
  week: Scalars['Int']['output'];
  yesterday: Scalars['Int']['output'];
};

export enum EpisodeType {
  Bonus = 'bonus',
  Full = 'full',
  Trailer = 'trailer'
}

/** Personalisation Question asked during signup: How experienced are you with podcasting? */
export enum ExperienceLevel {
  Experienced = 'experienced',
  New = 'new'
}

export type FailedRssFeed = {
  __typename?: 'FailedRssFeed';
  error?: Maybe<Scalars['String']['output']>;
  showId: Scalars['ID']['output'];
};

export type File = {
  __typename?: 'File';
  aiJob?: Maybe<Job>;
  audioJob?: Maybe<Job>;
  bucket: Scalars['String']['output'];
  chapters?: Maybe<Array<Chapter>>;
  codecInformation: CodecInformation;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageJob?: Maybe<Job>;
  job?: Maybe<Job>;
  metaDataJob?: Maybe<Job>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  transcriptionJob?: Maybe<Job>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<UserFile>>;
  videoJob?: Maybe<Job>;
};

export type FileListItem = {
  __typename?: 'FileListItem';
  audioJob?: Maybe<FileListItemJobStatus>;
  bookmarked?: Maybe<Scalars['Boolean']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  codecInformation?: Maybe<CodecInformation>;
  createdAt: Scalars['String']['output'];
  fileCount: Scalars['Int']['output'];
  fileId?: Maybe<Scalars['ID']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageJob?: Maybe<FileListItemJobStatus>;
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type FileListItemJobStatus = {
  __typename?: 'FileListItemJobStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export enum FileType {
  Audio = 'audio',
  Image = 'image',
  Video = 'video'
}

export type FilteredProjectFiles = {
  __typename?: 'FilteredProjectFiles';
  files?: Maybe<Array<File>>;
  total: Scalars['Int']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type GenerateTitlesAndSummariesResponse = {
  __typename?: 'GenerateTitlesAndSummariesResponse';
  episode: Episode;
  jobId: Scalars['ID']['output'];
};

export enum Host {
  Alitu = 'alitu',
  Buzzsprout = 'buzzsprout',
  Captivate = 'captivate',
  Castos = 'castos',
  Libsyn = 'libsyn',
  Podbean = 'podbean',
  Spreaker = 'spreaker',
  Transistor = 'transistor'
}

export type HostInput = {
  host: Host;
};

export type HostTokenResponse = {
  __typename?: 'HostTokenResponse';
  createdAt?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type HostUploadResponse = {
  __typename?: 'HostUploadResponse';
  progressKey: Scalars['ID']['output'];
  uploading: Scalars['Boolean']['output'];
};

export type HostedShow = {
  __typename?: 'HostedShow';
  hostingSuspended?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rssFeedUrl: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type HostedShowsResponse = {
  __typename?: 'HostedShowsResponse';
  shows?: Maybe<Array<Maybe<HostedShow>>>;
  total: Scalars['Int']['output'];
};

export type HostingAveragesStatsResponse = {
  __typename?: 'HostingAveragesStatsResponse';
  dailyAverage?: Maybe<Scalars['Float']['output']>;
  monthlyAverage?: Maybe<Scalars['Float']['output']>;
  weeklyAverage?: Maybe<Scalars['Float']['output']>;
};

export type HostingCountriesResponse = {
  __typename?: 'HostingCountriesResponse';
  countriesStats?: Maybe<Scalars['JSON']['output']>;
};

export type HostingDevicesResponse = {
  __typename?: 'HostingDevicesResponse';
  allDownloads?: Maybe<Scalars['Int']['output']>;
  mobileDownloads?: Maybe<Scalars['Int']['output']>;
};

export type HostingEpisodeStatsOverviewResponse = {
  __typename?: 'HostingEpisodeStatsOverviewResponse';
  downloadsForever?: Maybe<Scalars['Int']['output']>;
  downloadsLastMonth?: Maybe<Scalars['Int']['output']>;
  downloadsLastQuarter?: Maybe<Scalars['Int']['output']>;
  downloadsLastWeek?: Maybe<Scalars['Int']['output']>;
  downloadsToday?: Maybe<Scalars['Int']['output']>;
  downloadsYesterday?: Maybe<Scalars['Int']['output']>;
};

export type HostingLimitOffender = {
  __typename?: 'HostingLimitOffender';
  hostingLimit: Scalars['Int']['output'];
  prevMonth1?: Maybe<Scalars['Int']['output']>;
  prevMonth2?: Maybe<Scalars['Int']['output']>;
  prevMonth3?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['Int']['output'];
};

export type HostingOsStatsResponse = {
  __typename?: 'HostingOSStatsResponse';
  androidDownloads?: Maybe<Scalars['Int']['output']>;
  iosDownloads?: Maybe<Scalars['Int']['output']>;
  linuxDownloads?: Maybe<Scalars['Int']['output']>;
  macosDownloads?: Maybe<Scalars['Int']['output']>;
  others?: Maybe<Scalars['Int']['output']>;
  windowsDownloads?: Maybe<Scalars['Int']['output']>;
};

export type HostingStatsResponse = {
  __typename?: 'HostingStatsResponse';
  downloadsAllTime?: Maybe<Scalars['Int']['output']>;
  downloadsLastMonth?: Maybe<Scalars['Int']['output']>;
  downloadsLastQuarter?: Maybe<Scalars['Int']['output']>;
  downloadsLastWeek?: Maybe<Scalars['Int']['output']>;
  downloadsToday?: Maybe<Scalars['Int']['output']>;
  downloadsYesterday?: Maybe<Scalars['Int']['output']>;
};

export type ImportPodcastRssResponse = {
  __typename?: 'ImportPodcastRssResponse';
  success: Scalars['Boolean']['output'];
  url: PodcastUrl;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount_due: Scalars['Int']['output'];
  confirmation_secret?: Maybe<ConfirmationSecret>;
  currency: Scalars['String']['output'];
  customer_address?: Maybe<StripeAddress>;
  customer_tax_ids?: Maybe<Array<CustomerTaxId>>;
  discount?: Maybe<Discount>;
  id: Scalars['ID']['output'];
  lines: InvoiceLines;
};

export type InvoiceLineData = {
  __typename?: 'InvoiceLineData';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InvoiceLines = {
  __typename?: 'InvoiceLines';
  data?: Maybe<Array<InvoiceLineData>>;
};

export type Job = {
  __typename?: 'Job';
  createdAt: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  progress: Scalars['Float']['output'];
  schema: Scalars['JSON']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type JobSpec = {
  __typename?: 'JobSpec';
  assets?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  episodeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  jobSpecHash: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  queue?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  storeAssets?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  userId: Scalars['ID']['output'];
};

export type JoinCallResponse = {
  __typename?: 'JoinCallResponse';
  id: Scalars['ID']['output'];
  participant: RecorderParticipant;
  room: Scalars['ID']['output'];
  token: Scalars['ID']['output'];
};

/** The order of items in the Library */
export enum LibrarySortOrder {
  Alphabetical = 'alphabetical',
  Recent = 'recent'
}

export type LibsynPublishResponse = {
  __typename?: 'LibsynPublishResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LibsynShow = {
  __typename?: 'LibsynShow';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type LibsynTokenRespose = {
  __typename?: 'LibsynTokenRespose';
  deleted: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['ID']['output']>;
};

export type LibsynUploadAdditional = {
  is_draft: Scalars['Boolean']['input'];
  item_body?: InputMaybe<Scalars['String']['input']>;
  item_title: Scalars['String']['input'];
  release_date: Scalars['String']['input'];
  show_id: Scalars['ID']['input'];
};

export type License = {
  __typename?: 'License';
  slug?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LicenseInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum LifecycleState {
  Draft = 'draft',
  Published = 'published',
  Ready = 'ready',
  Scheduled = 'scheduled'
}

export type Location = {
  __typename?: 'Location';
  country?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Log = {
  __typename?: 'Log';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  session: Scalars['ID']['output'];
  show: Podcast;
  subscription?: Maybe<Subscription>;
  user: User;
};

export enum MagicFilter {
  Fillers = 'fillers',
  Silences = 'silences'
}

export type MarkerItem = {
  __typename?: 'MarkerItem';
  id: Scalars['String']['output'];
  parentRegion?: Maybe<Scalars['String']['output']>;
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  addAuphonicMetadata: Scalars['String']['output'];
  addCallRecordingDuration: Scalars['Boolean']['output'];
  addCallRecordingTrack: Scalars['JSON']['output'];
  addCallRecordingType: Scalars['Boolean']['output'];
  addFileToFolder?: Maybe<Scalars['Boolean']['output']>;
  addHosting: AddHostingResult;
  addShow: Scalars['ID']['output'];
  adminAddSubscriptionToUser?: Maybe<Scalars['Boolean']['output']>;
  adminDeleteAllUserData: Scalars['Boolean']['output'];
  adminRecoverDeletedFile: RecoverDeletedFileResponse;
  adminRerunJob: JobSpec;
  adminRevokeSessions: Scalars['Boolean']['output'];
  adminSetHasAlreadyPaused: Scalars['Boolean']['output'];
  adminSuspendHosting: SuspendHostingResponse;
  adminUpdateContent: UpdateContentResponse;
  adminUpdateUser: User;
  alituCancelSchedulePublish: AlituCancelSchedulePublishResponse;
  alituPublish: AlituPublishResponse;
  /** Create or update scheduled publish time for an episode. */
  alituSchedulePublish: AlituPublishResponse;
  alituUnpublish: AlituUnpublishResponse;
  alituUpdatePublishedDate: AlituUpdatePublishedDate;
  bulkDeleteFiles?: Maybe<Scalars['JSON']['output']>;
  buzzsproutLogin: BuzzsproutPublishResponse;
  buzzsproutLogout: Scalars['JSON']['output'];
  buzzsproutPublish: BuzzsproutPublishResponse;
  cancelHostingSubscription: Subscription;
  captivateLogin: Captivate;
  captivateLogout: Scalars['JSON']['output'];
  captivatePublish: CaptivatePublishResponse;
  castosLogin: CastosLoginResponse;
  castosLogout: Scalars['JSON']['output'];
  castosPublish: CastosPublishResponse;
  concatenateChunks: Scalars['JSON']['output'];
  connectAlituHost: ConnectAlituHostResponse;
  createApiKey: ApiKey;
  createCall: JoinCallResponse;
  createChunkUploadUrl: UploadUrlResponse;
  createCustomer: CreateCustomerResult;
  createEpisode: Episode;
  createEpisodeSocialClip: EpisodeSocialClip;
  createEpisodeSocialClipAudioJob: EpisodeSocialClip;
  createEpisodeSocialClipVideoJob: EpisodeSocialClip;
  createExportClipToLibraryJob: JobSpec;
  createExportJob: JobSpec;
  createFile: CreateFileResponse;
  createFolder?: Maybe<Folder>;
  createImageFile: CreateFileResponse;
  createMetaDataJob: JobSpec;
  createMusicEditorEditJob: Scalars['ID']['output'];
  createMusicEditorJob: Scalars['JSON']['output'];
  createRecording: CreateRecordingResponse;
  createRecordingUploadUrl: UploadUrlResponse;
  createSubscription: Subscription;
  createSubscriptionFromSetupIntent: Subscription;
  createUser: CreateUserResponse;
  createVideoJob: JobSpec;
  deleteApiKey: ApiKey;
  deleteEpisode: DeletedEpisodeResponse;
  deleteEpisodeSocialClip: Scalars['Boolean']['output'];
  deleteFolder?: Maybe<Scalars['Boolean']['output']>;
  deleteHostToken: Podcast;
  deleteRecording?: Maybe<Scalars['Boolean']['output']>;
  deleteShowColorSwatch: Podcast;
  deleteSubdomain: DeleteSubdomainResponse;
  deleteSubscription: Subscription;
  duplicateEpisode: Episode;
  duplicateEpisodeSocialClip: EpisodeSocialClip;
  generateTitlesAndSummaries: GenerateTitlesAndSummariesResponse;
  generateTranscription: Scalars['String']['output'];
  getRssAndPopulateBuzzsproutShowDetails: Podcast;
  getRssAndPopulatePodbeanShowDetails: Podcast;
  importPodcastRss: ImportPodcastRssResponse;
  joinCall: JoinCallResponse;
  libsynLogout: Scalars['JSON']['output'];
  libsynPublish: LibsynPublishResponse;
  linkFile: Scalars['JSON']['output'];
  login: LoginResponse;
  logout: Scalars['JSON']['output'];
  pauseRecording?: Maybe<Scalars['Boolean']['output']>;
  pauseSubscription: Subscription;
  podbeanLogout: Scalars['JSON']['output'];
  podbeanPublish: PodbeanPublishResponse;
  populateAppleClaimToken: Podcast;
  populateShowDetailsFromRss: Podcast;
  redirectRss: RedirectRssResponse;
  regenerateAllRssFeeds: RegenerateAllRssFeedsResponse;
  regenerateRss: RegenerateRssResponse;
  removeFile: Scalars['Boolean']['output'];
  removeFileFromFolder?: Maybe<Scalars['Boolean']['output']>;
  removeShow: RemoveShowResponse;
  renewAlituHosting: Podcast;
  renewShow: RenewShowResponse;
  renewSubscription: Subscription;
  requestResetPassword: ResetPasswordResponse;
  rerunJob: JobSpec;
  resetPassword: ChangePasswordResponse;
  saveShowColorSwatch: Podcast;
  splitEpisodeClip: Episode;
  spreakerLogout: Scalars['JSON']['output'];
  spreakerPublish: SpreakerPublishResponse;
  /**
   * Async RSS import: validates the feed, enqueues one processor job per episode,
   * and returns immediately. Poll activeShowImport for progress.
   */
  startPodcastImport: ShowImport;
  submitShowToApple?: Maybe<Podcast>;
  /** Switches the subscription plan billing interval between monthly and yearly */
  switchPlanType: Subscription;
  transistorLogin: TransistorResponse;
  transistorLogout: Scalars['JSON']['output'];
  transistorPublish: TransistorPublishResponse;
  unlinkFile: Scalars['Boolean']['output'];
  unpauseSubscription: Subscription;
  updateApiKey: ApiKey;
  updateCallLock?: Maybe<Scalars['Boolean']['output']>;
  updateEpisode: Episode;
  updateEpisodeSocialClip: EpisodeSocialClip;
  updateFile: Scalars['Boolean']['output'];
  updateFolder?: Maybe<Scalars['Boolean']['output']>;
  updatePodcast: Podcast;
  updateRecordingRules: Scalars['JSON']['output'];
  updateTranscription?: Maybe<Transcription>;
  updateTransitionDefaults: Podcast;
  updateUser: User;
  updateUserFile: Scalars['Boolean']['output'];
  /** Tells Stripe to immediately end trial */
  upgradeFromTrial: Subscription;
  /** Upgrades or downgrades the subscription between audio and video plans */
  upgradePlan: Subscription;
  uploadUrls: Array<UploadUrl>;
  validatePassword: ValidatePasswordResponse;
};


export type MutationAddAuphonicMetadataArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationAddCallRecordingDurationArgs = {
  duration: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAddCallRecordingTrackArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  participantToken?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['Date']['input'];
};


export type MutationAddCallRecordingTypeArgs = {
  id: Scalars['ID']['input'];
  type: RecordingType;
};


export type MutationAddFileToFolderArgs = {
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddHostingArgs = {
  hostingPlan: Scalars['String']['input'];
};


export type MutationAddShowArgs = {
  name: Scalars['String']['input'];
};


export type MutationAdminAddSubscriptionToUserArgs = {
  customerId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeleteAllUserDataArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAdminRecoverDeletedFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationAdminRerunJobArgs = {
  jobId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAdminRevokeSessionsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationAdminSetHasAlreadyPausedArgs = {
  hasAlreadyPaused: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminSuspendHostingArgs = {
  suspensionType?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdminUpdateContentArgs = {
  content: Scalars['JSON']['input'];
  section: Scalars['String']['input'];
};


export type MutationAdminUpdateUserArgs = {
  input?: InputMaybe<UserInput>;
  userId: Scalars['ID']['input'];
};


export type MutationAlituCancelSchedulePublishArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationAlituPublishArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationAlituSchedulePublishArgs = {
  episodeId: Scalars['ID']['input'];
  schedulePublishAt?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAlituUnpublishArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationAlituUpdatePublishedDateArgs = {
  episodeId: Scalars['ID']['input'];
  publishedAt: Scalars['String']['input'];
};


export type MutationBulkDeleteFilesArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationBuzzsproutLoginArgs = {
  podcastId: Scalars['ID']['input'];
  token: Scalars['ID']['input'];
};


export type MutationBuzzsproutPublishArgs = {
  additional: AdditionalInput;
  episodeId: Scalars['ID']['input'];
};


export type MutationCaptivateLoginArgs = {
  apiKey: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCaptivatePublishArgs = {
  captivateShow: CaptivateShow;
  episodeId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
};


export type MutationCastosLoginArgs = {
  token: Scalars['ID']['input'];
};


export type MutationCastosPublishArgs = {
  episodeId: Scalars['ID']['input'];
  podcastId: Scalars['ID']['input'];
};


export type MutationConcatenateChunksArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
};


export type MutationCreateApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCallArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  isSolo?: InputMaybe<Scalars['Boolean']['input']>;
  recordOnConnect: Scalars['Boolean']['input'];
  twilioId: Scalars['String']['input'];
};


export type MutationCreateChunkUploadUrlArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
  participantToken?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['Date']['input'];
};


export type MutationCreateCustomerArgs = {
  address?: InputMaybe<StripeAddressParam>;
  celloUcc?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company>;
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  stripeTestClock?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEpisodeArgs = {
  metaData: EpisodeMetaDataInput;
};


export type MutationCreateEpisodeSocialClipArgs = {
  episodeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
};


export type MutationCreateEpisodeSocialClipAudioJobArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationCreateEpisodeSocialClipVideoJobArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationCreateExportClipToLibraryJobArgs = {
  addToEpisode?: InputMaybe<Scalars['Boolean']['input']>;
  clipTimings?: InputMaybe<ClipTimingsInput>;
  episodeId: Scalars['ID']['input'];
  exportedFilename: Scalars['String']['input'];
  uniqueId: Scalars['ID']['input'];
};


export type MutationCreateExportJobArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationCreateFileArgs = {
  duration: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  keys: Array<Scalars['ID']['input']>;
  skipAuphonic?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};


export type MutationCreateFolderArgs = {
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateImageFileArgs = {
  filename: Scalars['String']['input'];
  key: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateMetaDataJobArgs = {
  episodeId: Scalars['ID']['input'];
  metaData: EpisodeMetaDataInput;
};


export type MutationCreateMusicEditorEditJobArgs = {
  fileId: Scalars['ID']['input'];
  timeline: Scalars['JSON']['input'];
};


export type MutationCreateMusicEditorJobArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  introDuration?: InputMaybe<Scalars['Float']['input']>;
  music: Scalars['JSON']['input'];
  musicVolume?: InputMaybe<Scalars['Float']['input']>;
  outroDuration?: InputMaybe<Scalars['Float']['input']>;
  voice: Scalars['JSON']['input'];
};


export type MutationCreateRecordingArgs = {
  callId: Scalars['ID']['input'];
  duration: Scalars['Float']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRecordingUploadUrlArgs = {
  callId: Scalars['ID']['input'];
  instanceId: Scalars['String']['input'];
};


export type MutationCreateSubscriptionArgs = {
  address?: InputMaybe<StripeAddressParam>;
  company?: InputMaybe<Company>;
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  isEuropeanUnion: Scalars['Boolean']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  withTrial?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateSubscriptionFromSetupIntentArgs = {
  setupIntentId: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  email: Scalars['String']['input'];
  emailOptIn: Scalars['Boolean']['input'];
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  marketingData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  tempaAttribution?: InputMaybe<Scalars['JSON']['input']>;
  token: Scalars['String']['input'];
  wbraid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateVideoJobArgs = {
  episodeId: Scalars['ID']['input'];
  waveform?: InputMaybe<VideoWaveformInput>;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEpisodeSocialClipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteHostTokenArgs = {
  input: HostInput;
};


export type MutationDeleteRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShowColorSwatchArgs = {
  color: Scalars['String']['input'];
  showId: Scalars['ID']['input'];
};


export type MutationDeleteSubdomainArgs = {
  id: Scalars['ID']['input'];
  subdomain: Scalars['String']['input'];
};


export type MutationDeleteSubscriptionArgs = {
  isPausing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDuplicateEpisodeArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDuplicateEpisodeSocialClipArgs = {
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  platformPreset?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateTitlesAndSummariesArgs = {
  episodeId: Scalars['ID']['input'];
};


export type MutationGenerateTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  speakersExpected?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportPodcastRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationJoinCallArgs = {
  callPermalink: Scalars['ID']['input'];
  twilioId: Scalars['String']['input'];
};


export type MutationLibsynPublishArgs = {
  additional: LibsynUploadAdditional;
  episodeId: Scalars['ID']['input'];
};


export type MutationLinkFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPauseRecordingArgs = {
  id: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
};


export type MutationPauseSubscriptionArgs = {
  typeformFormId: Scalars['String']['input'];
  typeformResponseId: Scalars['String']['input'];
};


export type MutationPodbeanPublishArgs = {
  additional: PodbeanAdditional;
  episodeId: Scalars['ID']['input'];
};


export type MutationPopulateAppleClaimTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationPopulateShowDetailsFromRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationRedirectRssArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationRegenerateRssArgs = {
  showId: Scalars['ID']['input'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFileFromFolderArgs = {
  fileId: Scalars['ID']['input'];
  folderId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewAlituHostingArgs = {
  showId: Scalars['ID']['input'];
};


export type MutationRenewShowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewSubscriptionArgs = {
  paymentMethod: Scalars['String']['input'];
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationRerunJobArgs = {
  jobId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveShowColorSwatchArgs = {
  color: Scalars['String']['input'];
  showId: Scalars['ID']['input'];
};


export type MutationSplitEpisodeClipArgs = {
  firstFileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  secondFileName: Scalars['String']['input'];
  splitTime: Scalars['Float']['input'];
  uniqueId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSpreakerPublishArgs = {
  additional: SpreakerAdditionalInput;
  episodeId: Scalars['ID']['input'];
};


export type MutationStartPodcastImportArgs = {
  rssFeedUrl: Scalars['String']['input'];
};


export type MutationTransistorLoginArgs = {
  token: Scalars['ID']['input'];
};


export type MutationTransistorPublishArgs = {
  episodeId: Scalars['ID']['input'];
  isDraft: Scalars['Boolean']['input'];
  showId: Scalars['ID']['input'];
};


export type MutationUnlinkFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateApiKeyArgs = {
  id: Scalars['ID']['input'];
  input: ApiKeyUpdateInput;
};


export type MutationUpdateCallLockArgs = {
  id: Scalars['ID']['input'];
  locked: Scalars['Boolean']['input'];
};


export type MutationUpdateEpisodeArgs = {
  artwork?: InputMaybe<ArtworkInput>;
  clearFileField?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  metaData?: InputMaybe<EpisodeMetaDataInput>;
  metaDataNeedsReprocessing?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeTranscriptInRss?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuggestDescription?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSuggestTitle?: InputMaybe<Scalars['Boolean']['input']>;
  timeline?: InputMaybe<Array<EpisodeFileInput>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  videoMode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateEpisodeSocialClipArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateFileArgs = {
  id: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateFile>;
  removeData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateFolderArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePodcastArgs = {
  adobeArtwork?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  podcast: PodcastInput;
  shouldRegenerateRssFeed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateRecordingRulesArgs = {
  callPermalink: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type MutationUpdateTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
  speakerNames: Array<Scalars['String']['input']>;
};


export type MutationUpdateTransitionDefaultsArgs = {
  data: TransitionDefaultsInput;
};


export type MutationUpdateUserArgs = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UserInput>;
};


export type MutationUpdateUserFileArgs = {
  fileId: Scalars['ID']['input'];
  newData?: InputMaybe<UpdateUserFile>;
};


export type MutationUpgradePlanArgs = {
  planType: Scalars['String']['input'];
};


export type MutationUploadUrlsArgs = {
  numberOfFiles: Scalars['Int']['input'];
};


export type MutationValidatePasswordArgs = {
  password: Scalars['String']['input'];
};

export type MuteItem = {
  __typename?: 'MuteItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type PauseCollection = {
  __typename?: 'PauseCollection';
  behaviour?: Maybe<Scalars['String']['output']>;
  resumes_at?: Maybe<Scalars['Int']['output']>;
};

export type Payload = {
  __typename?: 'Payload';
  message: Scalars['String']['output'];
  progressKey: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  failureMessage?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type Permissions = {
  __typename?: 'Permissions';
  episodeLimit?: Maybe<Scalars['Int']['output']>;
  tier: Tier;
};

export type PodbeanAdditional = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PodbeanPublishResponse = {
  __typename?: 'PodbeanPublishResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Podcast = {
  __typename?: 'Podcast';
  appleClaimToken?: Maybe<Scalars['String']['output']>;
  artworkUrl?: Maybe<Scalars['String']['output']>;
  autoCenterPreference?: Maybe<Scalars['Boolean']['output']>;
  autoZoomPreference?: Maybe<Scalars['Boolean']['output']>;
  bitratePreference: Scalars['Int']['output'];
  categories?: Maybe<PodcastCategories>;
  contentType?: Maybe<ContentType>;
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feedLimit?: Maybe<Scalars['Int']['output']>;
  hasAlituHosting: Scalars['Boolean']['output'];
  host?: Maybe<Host>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExplicit: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  license?: Maybe<License>;
  links: PodcastLinks;
  location?: Maybe<Location>;
  lockFeed: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  processingSettings: ProcessingSettings;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  rssFeedUrl?: Maybe<Scalars['String']['output']>;
  showColorSwatches: Array<Scalars['String']['output']>;
  showExpiresAt?: Maybe<Scalars['String']['output']>;
  showHostingExpiresAt?: Maybe<Scalars['String']['output']>;
  statsUrlPrefix?: Maybe<Scalars['String']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  submittedThroughAppleApi?: Maybe<Scalars['Boolean']['output']>;
  thirdPartyRssFeed?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  transcriptionPreferences: TranscriptionPreferences;
  transitionDefaults?: Maybe<TransitionDefaults>;
  txt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PodcastType>;
  updateFrequency?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  waveformPreference: WaveformPreference;
};

export type PodcastCategories = {
  __typename?: 'PodcastCategories';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thirdCategory?: Maybe<Scalars['String']['output']>;
};

/** To remove a podcast field, explicitly set it to null. */
export type PodcastInput = {
  /** Upload key passed from the presigned URL upload. This is used to identify the file in the Ingress bucket. */
  artworkUploadKey?: InputMaybe<Scalars['String']['input']>;
  autoCenterPreference?: InputMaybe<Scalars['Boolean']['input']>;
  autoZoomPreference?: InputMaybe<Scalars['Boolean']['input']>;
  bitratePreference?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  /** Pass 'true' to delete podcast artwork */
  deleteArtwork?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedLimit?: InputMaybe<Scalars['Int']['input']>;
  hostName?: InputMaybe<Scalars['String']['input']>;
  isExplicit?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<LicenseInput>;
  links?: InputMaybe<PodcastLinksInput>;
  location?: InputMaybe<LocationInput>;
  lockFeed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingSettings?: InputMaybe<ProcessingSettingsInput>;
  statsUrlPrefix?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  thirdCategory?: InputMaybe<Scalars['String']['input']>;
  thirdPartyRssFeed?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  transcriptionLanguage?: InputMaybe<Scalars['String']['input']>;
  txt?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PodcastType>;
  updateFrequency?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  waveformPreference?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastLinks = {
  __typename?: 'PodcastLinks';
  alituBadge?: Maybe<Scalars['Boolean']['output']>;
  apple?: Maybe<Scalars['String']['output']>;
  deezer?: Maybe<Scalars['String']['output']>;
  facebookGroup?: Maybe<Scalars['String']['output']>;
  facebookPage?: Maybe<Scalars['String']['output']>;
  funding?: Maybe<Scalars['String']['output']>;
  iHeartRadio?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  pandora?: Maybe<Scalars['String']['output']>;
  spotify?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type PodcastLinksInput = {
  alituBadge?: InputMaybe<Scalars['Boolean']['input']>;
  apple?: InputMaybe<Scalars['String']['input']>;
  deezer?: InputMaybe<Scalars['String']['input']>;
  facebookGroup?: InputMaybe<Scalars['String']['input']>;
  facebookPage?: InputMaybe<Scalars['String']['input']>;
  funding?: InputMaybe<Scalars['String']['input']>;
  iHeartRadio?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  pandora?: InputMaybe<Scalars['String']['input']>;
  spotify?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** Personalisation Question asked during signup: What is your podcast for? */
export enum PodcastPurpose {
  Business = 'business',
  Cause = 'cause',
  Employer = 'employer',
  Hobby = 'hobby'
}

export enum PodcastType {
  Episodic = 'episodic',
  Serial = 'serial'
}

export type PodcastUrl = {
  __typename?: 'PodcastUrl';
  rss: Scalars['String']['output'];
};

export type ProcessingSettings = {
  __typename?: 'ProcessingSettings';
  bandwidthExtension: Scalars['Boolean']['output'];
  bgNoiseRemoval: Scalars['Boolean']['output'];
  removeBreathings: Scalars['Boolean']['output'];
  voiceAutoEq: Scalars['Boolean']['output'];
};

export type ProcessingSettingsInput = {
  bandwidthExtension: Scalars['Boolean']['input'];
  bgNoiseRemoval: Scalars['Boolean']['input'];
  removeBreathings: Scalars['Boolean']['input'];
  voiceAutoEq: Scalars['Boolean']['input'];
};

export type Project = {
  __typename?: 'Project';
  categories?: Maybe<ProjectCategories>;
  contentType?: Maybe<ContentType>;
  description?: Maybe<Scalars['String']['output']>;
  feedLimit?: Maybe<Scalars['Int']['output']>;
  hasAlituHosting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isExplicit?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processingSettings: ProcessingSettings;
  showExpiresAt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['Int']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  transitionDefaults?: Maybe<TransitionDefaults>;
  type?: Maybe<ShowType>;
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type ProjectCategories = {
  __typename?: 'ProjectCategories';
  category?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  thirdCategory?: Maybe<Scalars['String']['output']>;
};

export type ProjectFilesAndFolders = {
  __typename?: 'ProjectFilesAndFolders';
  files?: Maybe<Array<FileListItem>>;
  total: Scalars['Int']['output'];
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amount_off?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  percent_off?: Maybe<Scalars['Float']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  trial_days?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Running import for the user's active show if any, else the most recent
   * finished one (so the UI can show the result after a reload). Null if the
   * show has never imported.
   */
  activeShowImport?: Maybe<ShowImport>;
  adminAssumeUser: AssumeUser;
  adminHostedShows?: Maybe<HostedShowsResponse>;
  adminHostingLimitOffenders?: Maybe<Array<Maybe<HostingLimitOffender>>>;
  adminUserFiles: Array<Maybe<AdminFile>>;
  adminUsers?: Maybe<Array<User>>;
  alituEpisodesCountPerShow: Scalars['Int']['output'];
  allJobs?: Maybe<Array<Job>>;
  billingPortal: Scalars['String']['output'];
  buzzsproutAccessToken: Scalars['JSON']['output'];
  call?: Maybe<Call>;
  callExists: Scalars['Boolean']['output'];
  captivateCredentials: Captivate;
  captivateShows?: Maybe<Array<CaptivateShows>>;
  captivateUploadProgress?: Maybe<Array<Log>>;
  castosPodcasts: Array<CastosPodcast>;
  checkAppleShowStatus?: Maybe<AppleShowStatus>;
  checkSubdomain?: Maybe<SubdomainRecord>;
  countries?: Maybe<Array<Countries>>;
  customer: Customer;
  episode: Episode;
  episodeJob: Job;
  episodeJobs?: Maybe<Array<Job>>;
  episodeSocialClip: EpisodeSocialClip;
  episodeSocialClips: Array<EpisodeSocialClip>;
  episodes: Array<Episode>;
  episodesCount: Scalars['Int']['output'];
  episodesCountPerUser: Scalars['Int']['output'];
  file?: Maybe<File>;
  getApiKeys: Array<ApiKey>;
  getAppsStats: Array<AppStat>;
  getCallCreator?: Maybe<Call>;
  getCelloToken?: Maybe<CelloTokenResponse>;
  getCountriesStats: HostingCountriesResponse;
  getDefaultMusic?: Maybe<File>;
  getDemoFileAndTranscript: DemoAndTranscript;
  getDevicesStats: HostingDevicesResponse;
  getEpisodeDownloadsOverviewStats: HostingEpisodeStatsOverviewResponse;
  getFolders?: Maybe<Array<Maybe<Folder>>>;
  getLibsynShows: Array<LibsynShow>;
  getLibsynToken: LibsynTokenRespose;
  getOSStats: HostingOsStatsResponse;
  getPaymentMethods?: Maybe<Array<Scalars['JSON']['output']>>;
  getPodbeanToken: Token;
  getPodcastAveragesStats: HostingAveragesStatsResponse;
  getPodcastStats: HostingStatsResponse;
  getProjectFiles: FilteredProjectFiles;
  getProjectFilesAndFolders: ProjectFilesAndFolders;
  getRecordingRules: Scalars['String']['output'];
  getShowDetailsStats: ShowDetailsStatsResult;
  getSpreakerShows: Array<SpreakerShow>;
  getSpreakerToken: Scalars['JSON']['output'];
  getTranscriptionUsageAndLimit?: Maybe<TranscriptionUsageAndLimitResponse>;
  host?: Maybe<Host>;
  hostToken?: Maybe<HostTokenResponse>;
  jobLogs?: Maybe<Array<Log>>;
  libsynUploadAssetProgress?: Maybe<Array<Log>>;
  permissions?: Maybe<Permissions>;
  project: Project;
  projects?: Maybe<Array<Project>>;
  promoCode?: Maybe<PromoCode>;
  show: Podcast;
  shows: Array<Podcast>;
  signupPageContent?: Maybe<SignupPageContent>;
  subscription: Subscription;
  subscriptionChangePreview: SubscriptionChangePreview;
  subscriptionPrice: SubscriptionPrice;
  tax: SubscriptionTax;
  transcription?: Maybe<Transcription>;
  transcriptionSpeakerNames?: Maybe<SpeakerNames>;
  transcriptionStatus?: Maybe<Scalars['String']['output']>;
  transistorShows?: Maybe<Array<TransistorShow>>;
  universalFile?: Maybe<File>;
  universalFiles: UniversalFilesResponse;
  upcomingInvoice?: Maybe<UpcomingInvoice>;
  uploadBuzzsproutAssetProgress: Array<Log>;
  uploadPodbeanAssetProgress: Array<Log>;
  uploadSpreakerAssetProgress?: Maybe<Array<Log>>;
  user: User;
};


export type QueryAdminAssumeUserArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminHostedShowsArgs = {
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminUserFilesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryAdminUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllJobsArgs = {
  hasFailed?: InputMaybe<Scalars['Boolean']['input']>;
  isRunning?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
};


export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallExistsArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryCaptivateUploadProgressArgs = {
  progressKey: Scalars['String']['input'];
};


export type QueryCheckAppleShowStatusArgs = {
  appleShowId: Scalars['String']['input'];
};


export type QueryCheckSubdomainArgs = {
  subdomain: Scalars['String']['input'];
};


export type QueryEpisodeArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEpisodeJobArgs = {
  episodeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryEpisodeJobsArgs = {
  episodeId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type QueryEpisodeSocialClipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEpisodeSocialClipsArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QueryEpisodesArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  lifecycleState?: InputMaybe<LifecycleState>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  showId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodesCountArgs = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  jobStatus?: InputMaybe<Scalars['String']['input']>;
  lifecycleState?: InputMaybe<LifecycleState>;
  name?: InputMaybe<Scalars['String']['input']>;
  showId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileArgs = {
  id: Scalars['ID']['input'];
  isUniversal?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryGetAppsStatsArgs = {
  start?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCallCreatorArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryGetCountriesStatsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDefaultMusicArgs = {
  type: Scalars['String']['input'];
};


export type QueryGetDevicesStatsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEpisodeDownloadsOverviewStatsArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QueryGetOsStatsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPodcastAveragesStatsArgs = {
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProjectFilesArgs = {
  limit: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProjectFilesAndFoldersArgs = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecordingRulesArgs = {
  callPermalink: Scalars['ID']['input'];
};


export type QueryGetShowDetailsStatsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order: Scalars['String']['input'];
};


export type QueryHostTokenArgs = {
  input: HostInput;
};


export type QueryJobLogsArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryLibsynUploadAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryPromoCodeArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
};


export type QueryShowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShowsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySubscriptionChangePreviewArgs = {
  changeType: Scalars['String']['input'];
  planType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionPriceArgs = {
  countryCode: Scalars['String']['input'];
  hostingPlan?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
};


export type QueryTaxArgs = {
  countryCode: Scalars['String']['input'];
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTranscriptionArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryTranscriptionSpeakerNamesArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryTranscriptionStatusArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryUniversalFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUniversalFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadBuzzsproutAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryUploadPodbeanAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};


export type QueryUploadSpreakerAssetProgressArgs = {
  progressKey: Scalars['ID']['input'];
};

/** The caller's recorder track and the token that authorizes writes to it. */
export type RecorderParticipant = {
  __typename?: 'RecorderParticipant';
  instanceId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export enum RecordingType {
  Audio = 'audio',
  AudioVideo = 'audioVideo'
}

export type RecoverDeletedFileResponse = {
  __typename?: 'RecoverDeletedFileResponse';
  success: Scalars['Boolean']['output'];
};

export type RedirectRssResponse = {
  __typename?: 'RedirectRssResponse';
  success: Scalars['Boolean']['output'];
};

export type RegenerateAllRssFeedsResponse = {
  __typename?: 'RegenerateAllRssFeedsResponse';
  failed: Array<FailedRssFeed>;
  updated: Array<UpdatedRssFeed>;
};

export type RegenerateRssResponse = {
  __typename?: 'RegenerateRssResponse';
  success: Scalars['Boolean']['output'];
};

export type RegionalBlocs = {
  __typename?: 'RegionalBlocs';
  name?: Maybe<Scalars['String']['output']>;
};

export type RemoveShowResponse = {
  __typename?: 'RemoveShowResponse';
  success: Scalars['Boolean']['output'];
};

export type RemovedAudioItem = {
  __typename?: 'RemovedAudioItem';
  duration: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  magicFilter?: Maybe<MagicFilter>;
  resource: Scalars['String']['output'];
  sourceStart: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export type RenewShowResponse = {
  __typename?: 'RenewShowResponse';
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type ShowDetailsStatsResult = {
  __typename?: 'ShowDetailsStatsResult';
  episodeStats: Array<EpisodeStats>;
  total: Scalars['Int']['output'];
};

export type ShowImport = {
  __typename?: 'ShowImport';
  completedEpisodes: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  failedEpisodeTitles: Array<Scalars['String']['output']>;
  failedEpisodes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rssFeedUrl: Scalars['String']['output'];
  rssUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalEpisodes: Scalars['Int']['output'];
};

export enum ShowType {
  Episodic = 'episodic',
  Serial = 'serial'
}

export type SignupPageContent = {
  __typename?: 'SignupPageContent';
  mainTitle?: Maybe<Scalars['String']['output']>;
  sidebarContent?: Maybe<Scalars['String']['output']>;
};

export type SilenceItem = {
  __typename?: 'SilenceItem';
  end: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  type: TimelineItemType;
};

export enum SocialClipState {
  Complete = 'complete',
  Draft = 'draft',
  Failed = 'failed',
  Processing = 'processing'
}

export type SpeakerNames = {
  __typename?: 'SpeakerNames';
  fileId?: Maybe<Scalars['ID']['output']>;
  speakerNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type SpreakerAdditionalInput = {
  showId: Scalars['ID']['input'];
};

export type SpreakerPublishResponse = {
  __typename?: 'SpreakerPublishResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SpreakerShow = {
  __typename?: 'SpreakerShow';
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StripeAddressParam = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SubdomainRecord = {
  __typename?: 'SubdomainRecord';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancel_at_period_end: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  current_period_end: Scalars['Int']['output'];
  discount?: Maybe<Discount>;
  hasAlreadyPaused: Scalars['Boolean']['output'];
  hostingExpiresAt?: Maybe<Scalars['String']['output']>;
  hostingLimit: Scalars['Int']['output'];
  hostingSuspended?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaypalSubscription: Scalars['Boolean']['output'];
  latest_invoice?: Maybe<Invoice>;
  metadata?: Maybe<SubscriptionMetaData>;
  pause_collection?: Maybe<PauseCollection>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<SubscriptionPlan>>;
  status: Scalars['String']['output'];
  trial_end?: Maybe<Scalars['Int']['output']>;
  trial_start?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionChangePreview = {
  __typename?: 'SubscriptionChangePreview';
  changeType: Scalars['String']['output'];
  creditAmount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  currentInterval?: Maybe<Scalars['String']['output']>;
  currentPlanType?: Maybe<Scalars['String']['output']>;
  immediateCharge: Scalars['Float']['output'];
  newInterval?: Maybe<Scalars['String']['output']>;
  newPlanType?: Maybe<Scalars['String']['output']>;
  nextPaymentAmount: Scalars['Float']['output'];
  nextPaymentDate: Scalars['Int']['output'];
};

export type SubscriptionMetaData = {
  __typename?: 'SubscriptionMetaData';
  countryCode?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  interval: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  tax_rates?: Maybe<Array<Maybe<SubscriptionPlanTaxRate>>>;
  trial_period_days?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionPlanTaxRate = {
  __typename?: 'SubscriptionPlanTaxRate';
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionPrice = {
  __typename?: 'SubscriptionPrice';
  currency: Scalars['String']['output'];
  price: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type SubscriptionTax = {
  __typename?: 'SubscriptionTax';
  percentage: Scalars['Float']['output'];
  taxId: Scalars['String']['output'];
};

export type SuspendHostingResponse = {
  __typename?: 'SuspendHostingResponse';
  success: Scalars['Boolean']['output'];
};

/** The status of the user account */
export enum Tier {
  /** The user is logged out */
  None = 'none',
  /** The user has supplied card details and is on a free trial */
  Trial = 'trial',
  /** The user created an account but has not yet created a subscription */
  TrialSignupIncomplete = 'trialSignupIncomplete',
  /** The user is an active paying customer */
  Unlimited = 'unlimited'
}

export type TimelineItem = AudioItem | BackgroundItem | BleepItem | MarkerItem | MuteItem | RemovedAudioItem | SilenceItem;

export type TimelineItemInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  fadeInDuration?: InputMaybe<Scalars['Float']['input']>;
  fadeOutDuration?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  magicFilter?: InputMaybe<MagicFilter>;
  parentRegion?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  sourceStart?: InputMaybe<Scalars['Float']['input']>;
  start: Scalars['Float']['input'];
  type: TimelineItemType;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export enum TimelineItemType {
  Audio = 'audio',
  Background = 'background',
  Bleep = 'bleep',
  Marker = 'marker',
  Mute = 'mute',
  RemovedAudio = 'removedAudio',
  Silence = 'silence'
}

export type Token = {
  __typename?: 'Token';
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Transcription = {
  __typename?: 'Transcription';
  createdAt: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  speakerNames?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
};

export type TranscriptionPreferences = {
  __typename?: 'TranscriptionPreferences';
  language?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionUsageAndLimitResponse = {
  __typename?: 'TranscriptionUsageAndLimitResponse';
  limit: Scalars['Float']['output'];
  usage: Scalars['Float']['output'];
};

export type TransistorPublishResponse = {
  __typename?: 'TransistorPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type TransistorResponse = {
  __typename?: 'TransistorResponse';
  isTokenValid: Scalars['Boolean']['output'];
};

export type TransistorShow = {
  __typename?: 'TransistorShow';
  description: Scalars['String']['output'];
  /** feedUrl is optional because private shows do not have feed url */
  feedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type TransitionDefaultIntro = {
  __typename?: 'TransitionDefaultIntro';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingOut?: Maybe<Scalars['Boolean']['output']>;
  overlap?: Maybe<Scalars['Float']['output']>;
};

export type TransitionDefaultIntroInput = {
  fadeVolume?: InputMaybe<Scalars['Float']['input']>;
  isFadingOut?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Float']['input']>;
};

export type TransitionDefaultOutro = {
  __typename?: 'TransitionDefaultOutro';
  fadeVolume?: Maybe<Scalars['Float']['output']>;
  isFadingIn?: Maybe<Scalars['Boolean']['output']>;
  overlap?: Maybe<Scalars['Float']['output']>;
};

export type TransitionDefaultOutroInput = {
  fadeVolume?: InputMaybe<Scalars['Float']['input']>;
  isFadingIn?: InputMaybe<Scalars['Boolean']['input']>;
  overlap?: InputMaybe<Scalars['Float']['input']>;
};

export type TransitionDefaults = {
  __typename?: 'TransitionDefaults';
  intro?: Maybe<TransitionDefaultIntro>;
  outro?: Maybe<TransitionDefaultOutro>;
};

export type TransitionDefaultsInput = {
  intro?: InputMaybe<TransitionDefaultIntroInput>;
  outro?: InputMaybe<TransitionDefaultOutroInput>;
};

export type UniversalFile = {
  __typename?: 'UniversalFile';
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAddedToLibrary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  users?: Maybe<Scalars['JSON']['output']>;
};

export type UniversalFilesCategory = {
  __typename?: 'UniversalFilesCategory';
  files: Array<UniversalFile>;
  name: Scalars['String']['output'];
  previewFile?: Maybe<Scalars['JSON']['output']>;
};

export type UniversalFilesResponse = {
  __typename?: 'UniversalFilesResponse';
  categories: Array<UniversalFilesCategory>;
  total: Scalars['Int']['output'];
};

export type UpcomingInvoice = {
  __typename?: 'UpcomingInvoice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type UpdateContentResponse = {
  __typename?: 'UpdateContentResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateFile = {
  aiJobId?: InputMaybe<Scalars['String']['input']>;
  chapters?: InputMaybe<Array<ChapterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<FileType>;
  use?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserFile = {
  bookmarked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatedRssFeed = {
  __typename?: 'UpdatedRssFeed';
  showId: Scalars['ID']['output'];
};

export type UploadUrl = {
  __typename?: 'UploadUrl';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type UploadUrlResponse = {
  __typename?: 'UploadUrlResponse';
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activeProjectId: Scalars['ID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  autoCenterPreference: Scalars['Boolean']['output'];
  autoZoomPreference: Scalars['Boolean']['output'];
  bitratePreference: Scalars['Int']['output'];
  callPermalink: Scalars['ID']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailOptIn: Scalars['Boolean']['output'];
  experienceLevel?: Maybe<ExperienceLevel>;
  firstName: Scalars['String']['output'];
  ga4ClientId?: Maybe<Scalars['String']['output']>;
  hasAlreadyPaused?: Maybe<Scalars['Boolean']['output']>;
  heardAboutFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  isTester: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  librarySortOrder: LibrarySortOrder;
  marketingData?: Maybe<Scalars['JSON']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  podcastPurpose?: Maybe<PodcastPurpose>;
  role: Scalars['String']['output'];
  session: Scalars['String']['output'];
  transcriptionPreferences: TranscriptionPreferences;
  waveformPreference: WaveformPreference;
};

export type UserFile = {
  __typename?: 'UserFile';
  userFile: Scalars['JSON']['output'];
};

export type UserInput = {
  activeProjectId?: InputMaybe<Scalars['ID']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  autoCenterPreference?: InputMaybe<Scalars['Boolean']['input']>;
  autoZoomPreference?: InputMaybe<Scalars['Boolean']['input']>;
  bitratePreference?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  ga4ClientId?: InputMaybe<Scalars['String']['input']>;
  isTester?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  librarySortOrder?: InputMaybe<LibrarySortOrder>;
  marketingData?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  transcriptionLanguage?: InputMaybe<Scalars['String']['input']>;
  waveformPreference?: InputMaybe<Scalars['String']['input']>;
};

export type UsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ValidatePasswordResponse = {
  __typename?: 'ValidatePasswordResponse';
  reason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VideoWaveformInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  opacity?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<VideoWaveformPosition>;
};

export enum VideoWaveformPosition {
  Bottom = 'bottom',
  Center = 'center'
}

/** How the waveform should be drawn in Alitu Waves */
export enum WaveformPreference {
  /** Draw the waveform in full detail */
  Pro = 'pro',
  /** Draw the waveform as simplified bars */
  Simple = 'simple'
}

export type CreateCustomerResult = {
  __typename?: 'createCustomerResult';
  clientSecret: Scalars['String']['output'];
  setupIntentId: Scalars['String']['output'];
};

export type IsAuthenticatedResponse = {
  __typename?: 'isAuthenticatedResponse';
  isAuthenticated: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type ApiKeyFragment = { id: string, name: string, createdAt: string };

export type CreatedApiKeyFragment = { id: string, apiKeyValue: string, name: string, createdAt: string };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { getApiKeys: Array<{ id: string, name: string, createdAt: string }> };

export type CreateApiKeyMutationVariables = Exact<{
  name: string;
}>;


export type CreateApiKeyMutation = { createApiKey: { id: string, apiKeyValue: string, name: string, createdAt: string } };

export type UpdateApiKeyMutationVariables = Exact<{
  id: string | number;
  input: ApiKeyUpdateInput;
}>;


export type UpdateApiKeyMutation = { updateApiKey: { id: string, name: string, createdAt: string } };

export type DeleteAPiKeyMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteAPiKeyMutation = { deleteApiKey: { id: string, name: string, createdAt: string } };

export type GetCelloTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCelloTokenQuery = { getCelloToken: { token: string | null | undefined, productId: string | null | undefined } | null | undefined };

export type CreateMetaDataJobMutationVariables = Exact<{
  episodeId: string | number;
  metaData: EpisodeMetaDataInput;
}>;


export type CreateMetaDataJobMutation = { createMetaDataJob: { id: string } };

export type ShowFragmentFragment = { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined };

export type ShowQueryVariables = Exact<{
  id: string | number;
}>;


export type ShowQuery = { show: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type UpdateTransitionDefaultsMutationVariables = Exact<{
  data: TransitionDefaultsInput;
}>;


export type UpdateTransitionDefaultsMutation = { updateTransitionDefaults: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type RenewAlituHostingMutationVariables = Exact<{
  showId: string | number;
}>;


export type RenewAlituHostingMutation = { renewAlituHosting: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { subscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } } };

export type UploadUrlsMutationVariables = Exact<{
  numberOfFiles: number;
}>;


export type UploadUrlsMutation = { uploadUrls: Array<{ id: string, url: string }> };

export type CreateFileMutationVariables = Exact<{
  keys: Array<string | number> | string | number;
  filename: string;
  type: string;
  tags?: Array<string | null | undefined> | string | null | undefined;
  skipAuphonic?: boolean | null | undefined;
  isUniversal?: boolean | null | undefined;
  duration: number;
}>;


export type CreateFileMutation = { createFile: { fileId: string, jobId: string } };

export type CreateImageFileMutationVariables = Exact<{
  key: string | number;
  filename: string;
  tags?: Array<string | null | undefined> | string | null | undefined;
}>;


export type CreateImageFileMutation = { createImageFile: { fileId: string, jobId: string } };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { permissions: { tier: Tier, episodeLimit: number | null | undefined } | null | undefined };

export type ShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowsQuery = { shows: Array<{ id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }> };

export type AddShowMutationVariables = Exact<{
  name: string;
}>;


export type AddShowMutation = { addShow: string };

export type RemoveShowMutationVariables = Exact<{
  id: string | number;
}>;


export type RemoveShowMutation = { removeShow: { success: boolean } };

export type RenewShowMutationVariables = Exact<{
  id: string | number;
}>;


export type RenewShowMutation = { renewShow: { success: boolean } };

export type CreateEpisodeMutationVariables = Exact<{
  metaData: EpisodeMetaDataInput;
}>;


export type CreateEpisodeMutation = { episode: { id: string } };

export type PopulateShowDetailsFromRssMutationVariables = Exact<{
  rssFeedUrl: string;
}>;


export type PopulateShowDetailsFromRssMutation = { populateShowDetailsFromRss: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type GetRssAndPopulateBuzzsproutShowDetailsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRssAndPopulateBuzzsproutShowDetailsMutation = { getRssAndPopulateBuzzsproutShowDetails: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type GetRssAndPopulatePodbeanShowDetailsMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRssAndPopulatePodbeanShowDetailsMutation = { getRssAndPopulatePodbeanShowDetails: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type SubmitShowToAppleMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitShowToAppleMutation = { submitShowToApple: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } | null | undefined };

export type PopulateAppleClaimTokenMutationVariables = Exact<{
  token: string;
}>;


export type PopulateAppleClaimTokenMutation = { populateAppleClaimToken: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type CheckAppleShowStatusQueryVariables = Exact<{
  appleShowId: string;
}>;


export type CheckAppleShowStatusQuery = { checkAppleShowStatus: { exists: boolean } | null | undefined };

export type AlituEpisodesCountPerShowQueryVariables = Exact<{ [key: string]: never; }>;


export type AlituEpisodesCountPerShowQuery = { alituEpisodesCountPerShow: number };

export type GetDemoFileAndTranscriptQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDemoFileAndTranscriptQuery = { getDemoFileAndTranscript: { demoFile: { id: string, name: string, bucket: string, type: string, tags: Array<string>, codecInformation: { format: { duration: string } | null | undefined }, job: { id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null | undefined }, transcript: { id: string, fileId: string | null | undefined, speakerNames: Array<string> | null | undefined, createdAt: string, status: string } } };

export type GetUniversalFileQueryVariables = Exact<{
  id: string | number;
}>;


export type GetUniversalFileQuery = { universalFile: { id: string, name: string, bucket: string, type: string, tags: Array<string>, codecInformation: { format: { duration: string } | null | undefined }, audioJob: { id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null | undefined, transcriptionJob: { id: string, schema: any, status: string, createdAt: string, hash: string, userId: string } | null | undefined } | null | undefined };

export type SubscriptionFragmentFragment = { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined };

export type SubscriptionDiscountFragmentFragment = { discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined };

export type SubscriptionInvoiceFragmentFragment = { latest_invoice: { amount_due: number, currency: string, id: string, lines: { data: Array<{ amount: number, currency: string, description: string, quantity: number }> | null | undefined }, confirmation_secret: { client_secret: string } | null | undefined } | null | undefined };

export type AddHostingMutationVariables = Exact<{
  hostingPlan: string;
}>;


export type AddHostingMutation = { addHosting: { subscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } | null | undefined, show: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } | null | undefined } };

export type DeleteSubscriptionMutationVariables = Exact<{
  isPausing?: boolean | null | undefined;
}>;


export type DeleteSubscriptionMutation = { deleteSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type PauseSubscriptionMutationVariables = Exact<{
  typeformFormId: string;
  typeformResponseId: string;
}>;


export type PauseSubscriptionMutation = { pauseSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type CancelHostingSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelHostingSubscriptionMutation = { cancelHostingSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type UnpauseSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type UnpauseSubscriptionMutation = { unpauseSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type UpgradeFromTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type UpgradeFromTrialMutation = { upgradeFromTrial: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type UpcomingInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type UpcomingInvoiceQuery = { upcomingInvoice: { amount: number, currency: string } | null | undefined };

export type SwitchPlanPreviewQueryVariables = Exact<{
  changeType: string;
  planType?: string | null | undefined;
}>;


export type SwitchPlanPreviewQuery = { subscriptionChangePreview: { immediateCharge: number, nextPaymentAmount: number, nextPaymentDate: number, creditAmount: number, currency: string, changeType: string, currentInterval: string | null | undefined, newInterval: string | null | undefined, currentPlanType: string | null | undefined, newPlanType: string | null | undefined } };

export type UserFragmentFragment = { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } };

export type LoginMutationVariables = Exact<{
  email: string;
  password: string;
}>;


export type LoginMutation = { login: { user: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } }, show: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, subscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } | null | undefined } };

export type UpdateUserMutationVariables = Exact<{
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  email?: string | null | undefined;
  password?: string | null | undefined;
  isTester?: boolean | null | undefined;
  bitratePreference?: number | null | undefined;
  waveformPreference?: string | null | undefined;
  autoZoomPreference?: boolean | null | undefined;
  autoCenterPreference?: boolean | null | undefined;
  transcriptionLanguage?: string | null | undefined;
  activeProjectId?: string | number | null | undefined;
  ga4ClientId?: string | null | undefined;
  librarySortOrder?: LibrarySortOrder | null | undefined;
}>;


export type UpdateUserMutation = { updateUser: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } } };

export type UpdateUserCredentialsMutationVariables = Exact<{
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  email?: string | null | undefined;
  password?: string | null | undefined;
  currentPassword?: string | null | undefined;
}>;


export type UpdateUserCredentialsMutation = { updateUser: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } } };

export type AdminAssumeUserQueryVariables = Exact<{
  userId: string | number;
}>;


export type AdminAssumeUserQuery = { adminAssumeUser: { user: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } } } };

export type AllJobsQueryVariables = Exact<{
  limit: number;
  hasFailed?: boolean | null | undefined;
  isRunning?: boolean | null | undefined;
}>;


export type AllJobsQuery = { allJobs: Array<{ createdAt: string, id: string, hash: string, schema: any, userId: string, status: string }> | null | undefined };

export type JobLogsQueryVariables = Exact<{
  jobId: string | number;
}>;


export type JobLogsQuery = { jobLogs: Array<{ id: string, payload: any, createdAt: string | null | undefined }> | null | undefined };

export type RerunJobMutationVariables = Exact<{
  jobId: string | number;
}>;


export type RerunJobMutation = { rerunJob: { id: string } };

export type AdminRerunJobMutationVariables = Exact<{
  jobId: string | number;
  priority?: boolean | null | undefined;
}>;


export type AdminRerunJobMutation = { adminRerunJob: { id: string } };

export type AdminUsersQueryVariables = Exact<{
  email?: string | null | undefined;
  id?: string | number | null | undefined;
}>;


export type AdminUsersQuery = { adminUsers: Array<{ id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, isTester: boolean, activeProjectId: string, hasAlreadyPaused: boolean | null | undefined }> | null | undefined };

export type SupportDashboardShowsQueryVariables = Exact<{
  userId?: string | number | null | undefined;
}>;


export type SupportDashboardShowsQuery = { shows: Array<{ id: string, description: string | null | undefined, name: string | null | undefined }> };

export type RegenerateRssMutationVariables = Exact<{
  showId: string | number;
}>;


export type RegenerateRssMutation = { regenerateRss: { success: boolean } };

export type AdminRecoverDeletedFileMutationVariables = Exact<{
  fileId: string | number;
}>;


export type AdminRecoverDeletedFileMutation = { adminRecoverDeletedFile: { success: boolean } };

export type RegenerateAllRssFeedsMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateAllRssFeedsMutation = { regenerateAllRssFeeds: { updated: Array<{ showId: string }>, failed: Array<{ showId: string, error: string | null | undefined }> } };

export type AdminHostedShowsQueryVariables = Exact<{
  limit: number;
  offset: number;
  name?: string | null | undefined;
  userId?: string | number | null | undefined;
}>;


export type AdminHostedShowsQuery = { adminHostedShows: { total: number, shows: Array<{ id: string, name: string | null | undefined, userId: string, rssFeedUrl: string, hostingSuspended: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type AdminHostingLimitOffendersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminHostingLimitOffendersQuery = { adminHostingLimitOffenders: Array<{ userId: number, hostingLimit: number, prevMonth1: number | null | undefined, prevMonth2: number | null | undefined, prevMonth3: number | null | undefined } | null | undefined> | null | undefined };

export type AdminSuspendHostingMutationVariables = Exact<{
  userId: string | number;
  suspensionType?: string | null | undefined;
}>;


export type AdminSuspendHostingMutation = { adminSuspendHosting: { success: boolean } };

export type AdminUserFilesQueryVariables = Exact<{
  userId: string | number;
  name?: string | null | undefined;
  id?: string | number | null | undefined;
}>;


export type AdminUserFilesQuery = { adminUserFiles: Array<{ id: string, name: string, bucket: string, createdAt: string, deletedAt: string | null | undefined, audioJobId: string | null | undefined, jobStatus: string | null | undefined } | null | undefined> };

export type AdminUpdateContentMutationVariables = Exact<{
  section: string;
  content: any;
}>;


export type AdminUpdateContentMutation = { adminUpdateContent: { success: boolean } };

export type SignupPageContentQueryVariables = Exact<{ [key: string]: never; }>;


export type SignupPageContentQuery = { signupPageContent: { mainTitle: string | null | undefined, sidebarContent: string | null | undefined } | null | undefined };

export type AdminUpdateUserMutationVariables = Exact<{
  userId: string | number;
  input?: UserInput | null | undefined;
}>;


export type AdminUpdateUserMutation = { adminUpdateUser: { id: string, firstName: string, lastName: string | null | undefined, email: string, isTester: boolean } };

export type AdminSetHasAlreadyPausedMutationVariables = Exact<{
  userId: string | number;
  hasAlreadyPaused: boolean;
}>;


export type AdminSetHasAlreadyPausedMutation = { adminSetHasAlreadyPaused: boolean };

export type AdminRevokeSessionsMutationVariables = Exact<{
  userId: string | number;
}>;


export type AdminRevokeSessionsMutation = { adminRevokeSessions: boolean };

export type AdminAddSubscriptionToUserMutationVariables = Exact<{
  userId: string | number;
  subscriptionId: string | number;
  customerId: string | number;
}>;


export type AdminAddSubscriptionToUserMutation = { adminAddSubscriptionToUser: boolean | null | undefined };

export type AdminDeleteAllUserDataMutationVariables = Exact<{
  userId: string | number;
}>;


export type AdminDeleteAllUserDataMutation = { adminDeleteAllUserData: boolean };

export type EpisodeMetadataQueryVariables = Exact<{
  id: string | number;
}>;


export type EpisodeMetadataQuery = { episode: { id: string, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } } };

export type UpdateEpisodeMetadataMutationVariables = Exact<{
  id: string | number;
  metaData?: EpisodeMetaDataInput | null | undefined;
  version?: number | null | undefined;
}>;


export type UpdateEpisodeMetadataMutation = { episode: { id: string, version: number | null | undefined, videoMode: boolean, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } } };

export type EditGeneratedAssetsWarningQueryVariables = Exact<{
  episodeId: string | number;
  version?: number | null | undefined;
  includeSocialClips: boolean;
}>;


export type EditGeneratedAssetsWarningQuery = { episode: { id: string, isArchivedVersion: boolean | null | undefined, file: { id: string, videoJob: { id: string, status: string } | null | undefined, transcriptionJob: { id: string, status: string } | null | undefined } | null | undefined }, episodeSocialClips?: Array<{ id: string, state: SocialClipState, isGeneratedFileStale: boolean, file: { id: string } | null | undefined }> };

export type DeleteRecordingMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRecordingMutation = { deleteRecording: boolean | null | undefined };

export type PauseRecordingMutationVariables = Exact<{
  id: string | number;
  paused: boolean;
}>;


export type PauseRecordingMutation = { pauseRecording: boolean | null | undefined };

export type CallQueryVariables = Exact<{
  id: string | number;
}>;


export type CallQuery = { call: { job: { status: string, schema: any } | null | undefined } | null | undefined };

export type CreateChunkUploadUrlMutationVariables = Exact<{
  callId: string | number;
  instanceId: string;
  timestamp: string;
  participantToken?: string | null | undefined;
}>;


export type CreateChunkUploadUrlMutation = { createChunkUploadUrl: { url: string } };

export type ConcatenateChunksMutationVariables = Exact<{
  callId: string | number;
  instanceId: string;
}>;


export type ConcatenateChunksMutation = { concatenateChunks: any };

export type CreateRecordingMutationVariables = Exact<{
  callId: string | number;
  duration: number;
  instanceId?: string | null | undefined;
  fileName?: string | null | undefined;
}>;


export type CreateRecordingMutation = { createRecording: { fileId: string | null | undefined } };

export type CreateRecordingUploadUrlMutationVariables = Exact<{
  callId: string | number;
  instanceId: string;
}>;


export type CreateRecordingUploadUrlMutation = { createRecordingUploadUrl: { url: string } };

export type AddCallRecordingTrackMutationVariables = Exact<{
  callId: string | number;
  instanceId: string;
  startTime: string;
  participantToken?: string | null | undefined;
}>;


export type AddCallRecordingTrackMutation = { addCallRecordingTrack: any };

export type ProjectFilesQueryVariables = Exact<{
  name?: string | null | undefined;
  offset: number;
  limit: number;
  tags?: string | null | undefined;
  type?: string | null | undefined;
}>;


export type ProjectFilesQuery = { projectFiles: { total: number, files: Array<{ id: string, name: string, type: string, tags: Array<string>, bucket: string, createdAt: string, codecInformation: { format: { duration: string } | null | undefined }, users: Array<{ userFile: any }> | null | undefined, audioJob: { id: string, status: string, schema: any, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, imageJob: { id: string, status: string, schema: any, progress: number, createdAt: string, hash: string, userId: string } | null | undefined }> | null | undefined } };

export type ProjectFilesAndFoldersQueryVariables = Exact<{
  name?: string | null | undefined;
  folderId?: string | number | null | undefined;
  tags?: string | null | undefined;
  type?: string | null | undefined;
  offset: number;
  limit?: number | null | undefined;
  sort?: string | null | undefined;
}>;


export type ProjectFilesAndFoldersQuery = { projectFiles: { total: number, files: Array<{ id: string, fileId: string | null | undefined, folderId: string | null | undefined, name: string, bucket: string | null | undefined, tags: Array<string>, bookmarked: boolean | null | undefined, createdAt: string, userId: string, fileCount: number, type: string, audioJob: { status: string | null | undefined } | null | undefined, imageJob: { status: string | null | undefined } | null | undefined, codecInformation: { format: { duration: string } | null | undefined } | null | undefined }> | null | undefined } };

export type GetFoldersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFoldersQuery = { getFolders: Array<{ id: string, name: string } | null | undefined> | null | undefined };

export type CreateFolderMutationVariables = Exact<{
  name: string;
}>;


export type CreateFolderMutation = { createFolder: { id: string, name: string } | null | undefined };

export type UpdateFolderMutationVariables = Exact<{
  id: string | number;
  name: string;
}>;


export type UpdateFolderMutation = { updateFolder: boolean | null | undefined };

export type DeleteFolderMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFolderMutation = { deleteFolder: boolean | null | undefined };

export type AddFileToFolderMutationVariables = Exact<{
  fileId: string | number;
  folderId: string | number;
}>;


export type AddFileToFolderMutation = { addFileToFolder: boolean | null | undefined };

export type RemoveFileFromFolderMutationVariables = Exact<{
  fileId: string | number;
  folderId: string | number;
}>;


export type RemoveFileFromFolderMutation = { removeFileFromFolder: boolean | null | undefined };

export type GenerateTranscriptionMutationVariables = Exact<{
  fileId: string | number;
  language?: string | null | undefined;
  speakersExpected?: number | null | undefined;
}>;


export type GenerateTranscriptionMutation = { generateTranscription: string };

export type CreateExportClipToLibraryJobMutationVariables = Exact<{
  episodeId: string | number;
  uniqueId: string | number;
  exportedFilename: string;
  clipTimings?: ClipTimingsInput | null | undefined;
  addToEpisode?: boolean | null | undefined;
}>;


export type CreateExportClipToLibraryJobMutation = { createExportClipToLibraryJob: { id: string } };

export type SplitEpisodeClipMutationVariables = Exact<{
  id: string | number;
  uniqueId: string | number;
  splitTime: number;
  firstFileName: string;
  secondFileName: string;
  version: number;
}>;


export type SplitEpisodeClipMutation = { splitEpisodeClip: { id: string, version: number | null | undefined, timeline: Array<{ id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
        | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number }
      > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined }> } };

export type GetRecordingRulesQueryVariables = Exact<{
  callPermalink: string | number;
}>;


export type GetRecordingRulesQuery = { getRecordingRules: string };

export type UpdateRecordingRulesMutationVariables = Exact<{
  callPermalink: string | number;
  type: string;
}>;


export type UpdateRecordingRulesMutation = { updateRecordingRules: any };

export type CreateCallMutationVariables = Exact<{
  twilioId: string;
  isSolo?: boolean | null | undefined;
  fileName?: string | null | undefined;
  recordOnConnect: boolean;
}>;


export type CreateCallMutation = { createCall: { id: string, token: string, room: string, participant: { instanceId: string, token: string } } };

export type JoinCallMutationVariables = Exact<{
  callPermalink: string | number;
  twilioId: string;
}>;


export type JoinCallMutation = { joinCall: { id: string, token: string, room: string, participant: { instanceId: string, token: string } } };

export type CallExistsQueryVariables = Exact<{
  callPermalink: string | number;
}>;


export type CallExistsQuery = { callExists: boolean };

export type UpdateCallLockMutationVariables = Exact<{
  id: string | number;
  locked: boolean;
}>;


export type UpdateCallLockMutation = { updateCallLock: boolean | null | undefined };

export type GetCallCreatorQueryVariables = Exact<{
  callPermalink: string | number;
}>;


export type GetCallCreatorQuery = { getCallCreator: { creatorTwilioId: string } | null | undefined };

export type AddCallRecordingDurationMutationVariables = Exact<{
  id: string | number;
  duration: number;
}>;


export type AddCallRecordingDurationMutation = { addCallRecordingDuration: boolean };

export type AddCallRecordingTypeMutationVariables = Exact<{
  id: string | number;
  type: RecordingType;
}>;


export type AddCallRecordingTypeMutation = { addCallRecordingType: boolean };

export type CreateMusicEditorJobMutationVariables = Exact<{
  fileName?: string | null | undefined;
  voice: any;
  music: any;
  introDuration?: number | null | undefined;
  outroDuration?: number | null | undefined;
  musicVolume?: number | null | undefined;
}>;


export type CreateMusicEditorJobMutation = { createMusicEditorJob: any };

export type CreateMusicEditorEditJobMutationVariables = Exact<{
  fileId: string | number;
  timeline: any;
}>;


export type CreateMusicEditorEditJobMutation = { createMusicEditorEditJob: string };

export type MetaDataFragment = { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined };

export type EpisodeFileFragment = { id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
    | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
    | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
    | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
    | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
    | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
    | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
    | { type: TimelineItemType, id: string, start: number, end: number }
  > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined };

export type AudioItemAllFieldsFragment = { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string };

export type RemovedAudioItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string };

export type SilenceItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, end: number };

export type MuteItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string };

export type BleepItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string };

export type BackgroundItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number };

export type MarkerItemAllFieldsFragment = { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined };

export type EpisodeAllFieldsFragment = { id: string, guid: string | null | undefined, version: number | null | undefined, isArchivedVersion: boolean | null | undefined, createdAt: string, publishedAt: string | null | undefined, host: string | null | undefined, shouldSuggestTitle: boolean | null | undefined, shouldSuggestDescription: boolean | null | undefined, shouldIncludeTranscriptInRss: boolean | null | undefined, artworkUrl: string | null | undefined, hasArtwork: boolean | null | undefined, updatedAt: string | null | undefined, videoMode: boolean, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, timeline: Array<{ id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
      | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
      | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
      | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
      | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
      | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
      | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
      | { type: TimelineItemType, id: string, start: number, end: number }
    > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined }> };

export type EpisodeQueryVariables = Exact<{
  id: string | number;
  version?: number | null | undefined;
}>;


export type EpisodeQuery = { episode: { id: string, guid: string | null | undefined, version: number | null | undefined, isArchivedVersion: boolean | null | undefined, createdAt: string, publishedAt: string | null | undefined, host: string | null | undefined, shouldSuggestTitle: boolean | null | undefined, shouldSuggestDescription: boolean | null | undefined, shouldIncludeTranscriptInRss: boolean | null | undefined, artworkUrl: string | null | undefined, hasArtwork: boolean | null | undefined, updatedAt: string | null | undefined, videoMode: boolean, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, timeline: Array<{ id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
        | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number }
      > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined }> } };

export type UpdateEpisodeMutationVariables = Exact<{
  id: string | number;
  metaData?: EpisodeMetaDataInput | null | undefined;
  timeline?: Array<EpisodeFileInput> | EpisodeFileInput | null | undefined;
  shouldSuggestTitle?: boolean | null | undefined;
  shouldSuggestDescription?: boolean | null | undefined;
  shouldIncludeTranscriptInRss?: boolean | null | undefined;
  version?: number | null | undefined;
  artwork?: ArtworkInput | null | undefined;
  videoMode?: boolean | null | undefined;
  metaDataNeedsReprocessing?: boolean | null | undefined;
}>;


export type UpdateEpisodeMutation = { episode: { id: string, guid: string | null | undefined, version: number | null | undefined, isArchivedVersion: boolean | null | undefined, createdAt: string, publishedAt: string | null | undefined, host: string | null | undefined, shouldSuggestTitle: boolean | null | undefined, shouldSuggestDescription: boolean | null | undefined, shouldIncludeTranscriptInRss: boolean | null | undefined, artworkUrl: string | null | undefined, hasArtwork: boolean | null | undefined, updatedAt: string | null | undefined, videoMode: boolean, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, timeline: Array<{ id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
        | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
        | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
        | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
        | { type: TimelineItemType, id: string, start: number, end: number }
      > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined }> } };

export type AddAuphonicMetadataMutationVariables = Exact<{
  fileId: string | number;
}>;


export type AddAuphonicMetadataMutation = { addAuphonicMetadata: string };

export type CreateExportJobMutationVariables = Exact<{
  episodeId: string | number;
}>;


export type CreateExportJobMutation = { createExportJob: { id: string } };

export type EpisodesQueryVariables = Exact<{
  name?: string | null | undefined;
  offset: number;
  limit?: number | null | undefined;
  order?: string | null | undefined;
  jobStatus?: string | null | undefined;
  lifecycleState?: LifecycleState | null | undefined;
  showId?: string | null | undefined;
}>;


export type EpisodesQuery = { host: Host | null | undefined, filteredTotal: number, all: number, draft: number, processing: number, complete: number, episodes: Array<{ id: string, version: number | null | undefined, isArchivedVersion: boolean | null | undefined, artworkUrl: string | null | undefined, createdAt: string, updatedAt: string | null | undefined, publishedAt: string | null | undefined, schedulePublishAt: string | null | undefined, host: string | null | undefined, metaDataNeedsReprocessing: boolean | null | undefined, metaData: { name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined }, timeline: Array<{ id: string, uniqueId: string }>, file: { id: string, audioJob: { id: string, createdAt: string, status: string, schema: any, progress: number } | null | undefined, videoJob: { id: string, createdAt: string, status: string, schema: any, progress: number } | null | undefined, transcriptionJob: { id: string, createdAt: string, status: string, schema: any, progress: number } | null | undefined, aiJob: { id: string, createdAt: string, status: string, schema: any, progress: number } | null | undefined, metaDataJob: { id: string, createdAt: string, status: string, schema: any, progress: number } | null | undefined } | null | undefined }> };

export type EpisodesCopyDestinationQueryVariables = Exact<{ [key: string]: never; }>;


export type EpisodesCopyDestinationQuery = { draft: Array<{ id: string, metaData: { name: string } }>, ready: Array<{ id: string, metaData: { name: string } }>, published: Array<{ id: string, metaData: { name: string } }>, scheduled: Array<{ id: string, metaData: { name: string } }> };

export type DuplicateEpisodeMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
}>;


export type DuplicateEpisodeMutation = { duplicateEpisode: { id: string } };

export type DeleteEpisodeMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteEpisodeMutation = { deleteEpisode: { deletedEpisodeId: string } };

export type EpisodesCountPerUserQueryVariables = Exact<{ [key: string]: never; }>;


export type EpisodesCountPerUserQuery = { episodesCountPerUser: number };

export type FetchProcessingFileQueryVariables = Exact<{
  id: string | number;
  projectId: string | number;
}>;


export type FetchProcessingFileQuery = { file: { codecInformation: { format: { duration: string } | null | undefined }, audioJob: { status: string } | null | undefined, imageJob: { status: string } | null | undefined } | null | undefined };

export type FetchFileQueryVariables = Exact<{
  id: string | number;
  projectId: string | number;
}>;


export type FetchFileQuery = { file: { id: string, name: string, type: string, tags: Array<string>, bucket: string, codecInformation: { format: { duration: string } | null | undefined }, users: Array<{ userFile: any }> | null | undefined, audioJob: { id: string, status: string } | null | undefined, imageJob: { id: string, status: string } | null | undefined } | null | undefined };

export type UpdateFileMutationVariables = Exact<{
  id: string | number;
  newData?: UpdateFile | null | undefined;
  removeData?: any;
}>;


export type UpdateFileMutation = { updateFile: boolean };

export type UpdateUserFileMutationVariables = Exact<{
  fileId: string | number;
  newData?: UpdateUserFile | null | undefined;
}>;


export type UpdateUserFileMutation = { updateUserFile: boolean };

export type RemoveFileMutationVariables = Exact<{
  id: string | number;
}>;


export type RemoveFileMutation = { removeFile: boolean };

export type BulkDeleteFilesMutationVariables = Exact<{
  fileIds?: Array<string> | string | null | undefined;
}>;


export type BulkDeleteFilesMutation = { bulkDeleteFiles: any };

export type RequestResetPasswordMutationVariables = Exact<{
  email: string;
}>;


export type RequestResetPasswordMutation = { requestResetPassword: { success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  password: string;
  token: string;
}>;


export type ResetPasswordMutation = { resetPassword: { success: boolean, reason: string | null | undefined } };

export type SwitchPlanTypeMutationVariables = Exact<{ [key: string]: never; }>;


export type SwitchPlanTypeMutation = { switchPlanType: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type UpgradePlanMutationVariables = Exact<{
  planType: string;
}>;


export type UpgradePlanMutation = { upgradePlan: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type SubscriptionChangePreviewQueryVariables = Exact<{
  changeType: string;
  planType?: string | null | undefined;
}>;


export type SubscriptionChangePreviewQuery = { subscriptionChangePreview: { immediateCharge: number, nextPaymentAmount: number, nextPaymentDate: number, creditAmount: number, currency: string, changeType: string, currentInterval: string | null | undefined, newInterval: string | null | undefined, currentPlanType: string | null | undefined, newPlanType: string | null | undefined } };

export type RenewSubscriptionMutationVariables = Exact<{
  paymentMethod: string;
}>;


export type RenewSubscriptionMutation = { renewSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { getPaymentMethods: Array<any> | null | undefined };

export type SocialClipDesignerClipQueryVariables = Exact<{
  id: string | number;
}>;


export type SocialClipDesignerClipQuery = { episodeSocialClip: { id: string, episodeId: string, name: string, schema: any, schemaHash: string, generatedSchemaHash: string | null | undefined, isGeneratedFileStale: boolean, state: SocialClipState, file: { id: string, name: string } | null | undefined, job: { id: string, status: string, progress: number } | null | undefined } };

export type SocialClipsForEpisodeQueryVariables = Exact<{
  episodeId: string | number;
}>;


export type SocialClipsForEpisodeQuery = { episodeSocialClips: Array<{ id: string, episodeId: string, name: string, schema: any, schemaHash: string, generatedSchemaHash: string | null | undefined, isGeneratedFileStale: boolean, state: SocialClipState, createdAt: string, updatedAt: string | null | undefined, file: { id: string, name: string, type: string } | null | undefined, job: { id: string, status: string, progress: number } | null | undefined }> };

export type DeleteEpisodeSocialClipMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteEpisodeSocialClipMutation = { deleteEpisodeSocialClip: boolean };

export type DuplicateEpisodeSocialClipMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
}>;


export type DuplicateEpisodeSocialClipMutation = { duplicateEpisodeSocialClip: { id: string } };

export type RenameEpisodeSocialClipMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
}>;


export type RenameEpisodeSocialClipMutation = { updateEpisodeSocialClip: { id: string, name: string, updatedAt: string | null | undefined } };

export type AlituSchedulePublishMutationVariables = Exact<{
  episodeId: string | number;
  schedulePublishAt?: string | null | undefined;
}>;


export type AlituSchedulePublishMutation = { alituSchedulePublish: { success: boolean } };

export type AlituCancelSchedulePublishMutationVariables = Exact<{
  episodeId: string | number;
}>;


export type AlituCancelSchedulePublishMutation = { alituCancelSchedulePublish: { success: boolean } };

export type AlituUpdatePublishedDateMutationVariables = Exact<{
  episodeId: string | number;
  publishedAt: string;
}>;


export type AlituUpdatePublishedDateMutation = { alituUpdatePublishedDate: { success: boolean } };

export type GenerateTitlesAndSummariesMutationVariables = Exact<{
  episodeId: string | number;
}>;


export type GenerateTitlesAndSummariesMutation = { generateTitlesAndSummaries: { jobId: string, episode: { id: string, guid: string | null | undefined, version: number | null | undefined, isArchivedVersion: boolean | null | undefined, createdAt: string, publishedAt: string | null | undefined, host: string | null | undefined, shouldSuggestTitle: boolean | null | undefined, shouldSuggestDescription: boolean | null | undefined, shouldIncludeTranscriptInRss: boolean | null | undefined, artworkUrl: string | null | undefined, hasArtwork: boolean | null | undefined, updatedAt: string | null | undefined, videoMode: boolean, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, timeline: Array<{ id: string, uniqueId: string, type: EpisodeFileType, name: string, bucket: string | null | undefined, duration: number | null | undefined, trimmedDuration: number | null | undefined, overlapDuration: number | null | undefined, tags: Array<string>, hasVideo: boolean, audioTimeline: Array<
          | { type: TimelineItemType, start: number, end: number, sourceStart: number, resource: string }
          | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string, volume: number, fadeInDuration: number, fadeOutDuration: number }
          | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
          | { type: TimelineItemType, id: string, start: number, parentRegion: string | null | undefined }
          | { type: TimelineItemType, id: string, start: number, end: number, sourceStart: number, resource: string }
          | { type: TimelineItemType, id: string, start: number, sourceStart: number, duration: number, magicFilter: MagicFilter | null | undefined, resource: string }
          | { type: TimelineItemType, id: string, start: number, end: number }
        > | null | undefined, fade: { isFadingIn: boolean | null | undefined, isFadingOut: boolean | null | undefined, fadeVolume: number | null | undefined }, job: { id: string, schema: any, status: string, progress: number, createdAt: string, hash: string, userId: string } | null | undefined, additionalFiles: Array<{ id: string, name: string, duration: number | null | undefined }> | null | undefined, trimSource: { inPoint: number | null | undefined, outPoint: number | null | undefined } | null | undefined, visual: { source: EpisodeFileVisualSource, customImageFileId: string | null | undefined, replaceVideo: boolean | null | undefined, layout: { mode: EpisodeFileVisualLayoutMode, blurredBackground: boolean } } | null | undefined }> } } };

export type SaveEpisodeSocialClipMutationVariables = Exact<{
  episodeId: string | number;
  name: string;
  schema: any;
}>;


export type SaveEpisodeSocialClipMutation = { createEpisodeSocialClip: { id: string } };

export type UpdateEpisodeSocialClipMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  schema?: any;
}>;


export type UpdateEpisodeSocialClipMutation = { updateEpisodeSocialClip: { id: string } };

export type CreateEpisodeSocialClipVideoJobMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  schema?: any;
}>;


export type CreateEpisodeSocialClipVideoJobMutation = { createEpisodeSocialClipVideoJob: { id: string, state: SocialClipState, job: { id: string, status: string, progress: number } | null | undefined } };

export type CreateEpisodeSocialClipAudioJobMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  schema?: any;
}>;


export type CreateEpisodeSocialClipAudioJobMutation = { createEpisodeSocialClipAudioJob: { id: string, state: SocialClipState, job: { id: string, status: string, progress: number } | null | undefined } };

export type SaveShowColorSwatchMutationVariables = Exact<{
  showId: string | number;
  color: string;
}>;


export type SaveShowColorSwatchMutation = { saveShowColorSwatch: { id: string, showColorSwatches: Array<string> } };

export type DeleteShowColorSwatchMutationVariables = Exact<{
  showId: string | number;
  color: string;
}>;


export type DeleteShowColorSwatchMutation = { deleteShowColorSwatch: { id: string, showColorSwatches: Array<string> } };

export type HostTokenQueryVariables = Exact<{
  hostTokenInput: HostInput;
}>;


export type HostTokenQuery = { hostToken: { token: string | null | undefined } | null | undefined };

export type PublishPageQueryVariables = Exact<{
  episodeId: string | number;
  projectId: string | number;
}>;


export type PublishPageQuery = { host: Host | null | undefined, episode: { id: string, guid: string | null | undefined, version: number | null | undefined, videoMode: boolean, artworkUrl: string | null | undefined, hasArtwork: boolean | null | undefined, publishedAt: string | null | undefined, schedulePublishAt: string | null | undefined, host: string | null | undefined, shouldSuggestTitle: boolean | null | undefined, shouldSuggestDescription: boolean | null | undefined, shouldIncludeTranscriptInRss: boolean | null | undefined, metaDataNeedsReprocessing: boolean | null | undefined, metaData: { __typename: 'EpisodeMetaData', name: string, summary: string | null | undefined, description: string | null | undefined, episodeNumber: number | null | undefined, seasonNumber: number | null | undefined, hostNames: string | null | undefined, isExplicit: boolean | null | undefined, type: EpisodeType | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined }, file: { id: string, chapters: Array<{ title: string, start: number }> | null | undefined, codecInformation: { format: { duration: string } | null | undefined }, audioJob: { id: string, status: string, progress: number } | null | undefined, videoJob: { id: string, status: string, progress: number } | null | undefined, transcriptionJob: { id: string, status: string, progress: number } | null | undefined, aiJob: { id: string, status: string, progress: number } | null | undefined, metaDataJob: { id: string, status: string, schema: any, progress: number } | null | undefined } | null | undefined }, show: { id: string, subdomain: string | null | undefined, redirectUrl: string | null | undefined, artworkUrl: string | null | undefined, showColorSwatches: Array<string> } };

export type AlituHostLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type AlituHostLoginMutation = { alituHostLogin: { success: boolean, show: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } } };

export type CaptivateLoginMutationVariables = Exact<{
  username: string;
  apiKey: string;
}>;


export type CaptivateLoginMutation = { captivateLogin: { token: any } };

export type TransistorLoginMutationVariables = Exact<{
  token: string | number;
}>;


export type TransistorLoginMutation = { transistorLogin: { isTokenValid: boolean } };

export type BuzzsproutLoginMutationVariables = Exact<{
  podcastId: string | number;
  token: string | number;
}>;


export type BuzzsproutLoginMutation = { buzzsproutLogin: { success: boolean } };

export type CastosLoginMutationVariables = Exact<{
  token: string | number;
}>;


export type CastosLoginMutation = { castosLogin: { isTokenValid: boolean } };

export type CaptivatePublishMutationVariables = Exact<{
  episodeId: string | number;
  isDraft: boolean;
  captivateShow: CaptivateShow;
}>;


export type CaptivatePublishMutation = { captivatePublish: { success: boolean, errorCode: string | null | undefined } };

export type CaptivateShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type CaptivateShowsQuery = { shows: Array<{ id: string, title: string, timeZone: string, feedUrl: string | null | undefined }> | null | undefined };

export type CreateVideoJobMutationVariables = Exact<{
  episodeId: string | number;
  waveform?: VideoWaveformInput | null | undefined;
}>;


export type CreateVideoJobMutation = { createVideoJob: { id: string } };

export type CastosPodcastsQueryVariables = Exact<{ [key: string]: never; }>;


export type CastosPodcastsQuery = { podcasts: Array<{ id: string, title: string, feedUrl: string | null | undefined }> };

export type CastosPublishMutationVariables = Exact<{
  episodeId: string | number;
  podcastId: string | number;
}>;


export type CastosPublishMutation = { publish: { success: boolean } };

export type TransistorShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type TransistorShowsQuery = { shows: Array<{ id: string, title: string, description: string, feedUrl: string | null | undefined }> | null | undefined };

export type TransistorPublishMutationVariables = Exact<{
  episodeId: string | number;
  showId: string | number;
  isDraft: boolean;
}>;


export type TransistorPublishMutation = { publish: { success: boolean } };

export type SpreakerShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type SpreakerShowsQuery = { shows: Array<{ id: string, title: string, feedUrl: string | null | undefined }> };

export type SpreakerPublishMutationVariables = Exact<{
  episodeId: string | number;
  additional: SpreakerAdditionalInput;
}>;


export type SpreakerPublishMutation = { publish: { success: boolean, errorCode: string | null | undefined } };

export type LibsynShowsQueryVariables = Exact<{ [key: string]: never; }>;


export type LibsynShowsQuery = { shows: Array<{ id: string, title: string, feedUrl: string | null | undefined }> };

export type LibsynPublishMutationVariables = Exact<{
  additional: LibsynUploadAdditional;
  episodeId: string | number;
}>;


export type LibsynPublishMutation = { publish: { success: boolean, errorCode: string | null | undefined } };

export type PodbeanPublishMutationVariables = Exact<{
  additional: PodbeanAdditional;
  episodeId: string | number;
}>;


export type PodbeanPublishMutation = { publish: { success: boolean, errorCode: string | null | undefined } };

export type BuzzsproutPublishMutationVariables = Exact<{
  additional: AdditionalInput;
  episodeId: string | number;
}>;


export type BuzzsproutPublishMutation = { publish: { success: boolean, errorCode: string | null | undefined } };

export type EpisodeJobStatusQueryVariables = Exact<{
  id: string | number;
}>;


export type EpisodeJobStatusQuery = { episodeJobStatus: { id: string, file: { id: string, audioJob: { id: string, status: string, schema: any, progress: number } | null | undefined, videoJob: { id: string, status: string, progress: number } | null | undefined, transcriptionJob: { id: string, status: string, progress: number } | null | undefined, aiJob: { id: string, status: string, progress: number } | null | undefined, metaDataJob: { id: string, status: string, progress: number } | null | undefined } | null | undefined } };

export type PublishToAlituMutationVariables = Exact<{
  episodeId: string | number;
}>;


export type PublishToAlituMutation = { alituPublish: { success: boolean } };

export type UnpublishFromAlituMutationVariables = Exact<{
  episodeId: string | number;
}>;


export type UnpublishFromAlituMutation = { alituUnpublish: { success: boolean } };

export type TranscriptionQueryVariables = Exact<{
  fileId: string | number;
}>;


export type TranscriptionQuery = { transcription: { id: string, fileId: string | null | undefined, speakerNames: Array<string> | null | undefined, createdAt: string, status: string } | null | undefined };

export type UpdateTranscriptionMutationVariables = Exact<{
  fileId: string | number;
  speakerNames: Array<string> | string;
}>;


export type UpdateTranscriptionMutation = { updateTranscription: { id: string, fileId: string | null | undefined, speakerNames: Array<string> | null | undefined } | null | undefined };

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = { customer: { currency: string | null | undefined, address: { country: string, postal_code: string | null | undefined } | null | undefined } };

export type DefaultMusicFieldsFragment = { id: string, name: string, type: string };

export type CheckSubdomainQueryVariables = Exact<{
  subdomain: string;
}>;


export type CheckSubdomainQuery = { checkSubdomain: { id: string | null | undefined, name: string | null | undefined } | null | undefined };

export type DeleteSubdomainMutationVariables = Exact<{
  subdomain: string;
  id: string | number;
}>;


export type DeleteSubdomainMutation = { deleteSubdomain: { success: boolean } };

export type SettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageQuery = { defaultIntroMusic: { id: string, name: string, type: string } | null | undefined, defaultOutroMusic: { id: string, name: string, type: string } | null | undefined };

export type DefaultMusicQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultMusicQuery = { defaultIntroMusic: { id: string, name: string, type: string } | null | undefined, defaultOutroMusic: { id: string, name: string, type: string } | null | undefined };

export type UpdatePodcastMutationVariables = Exact<{
  id: string | number;
  podcast: PodcastInput;
  adobeArtwork?: boolean | null | undefined;
  shouldRegenerateRssFeed?: boolean | null | undefined;
}>;


export type UpdatePodcastMutation = { updatePodcast: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, copyright: string | null | undefined, artworkUrl: string | null | undefined, subdomain: string | null | undefined, bitratePreference: number, waveformPreference: WaveformPreference, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, thirdPartyRssFeed: string | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, transcriptionPreferences: { language: string | null | undefined }, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type SetDefaultMusicMutationVariables = Exact<{
  id: string | number;
  newData?: UpdateFile | null | undefined;
  removeData?: any;
}>;


export type SetDefaultMusicMutation = { updateFile: boolean };

export type ImportPodcastRssMutationVariables = Exact<{
  rssFeedUrl: string;
}>;


export type ImportPodcastRssMutation = { importPodcastRss: { success: boolean, url: { rss: string } } };

export type RedirectRssMutationVariables = Exact<{
  url: string;
}>;


export type RedirectRssMutation = { redirectRss: { success: boolean } };

export type FetchHostQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchHostQuery = { host: Host | null | undefined };

export type DeleteHostTokenMutationVariables = Exact<{
  input: HostInput;
}>;


export type DeleteHostTokenMutation = { deleteHostToken: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } };

export type GetTranscriptionUsageAndLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranscriptionUsageAndLimitQuery = { getTranscriptionUsageAndLimit: { usage: number, limit: number } | null | undefined };

export type ShowImportFieldsFragment = { id: string, status: string, rssFeedUrl: string, totalEpisodes: number, completedEpisodes: number, failedEpisodes: number, failedEpisodeTitles: Array<string>, rssUrl: string | null | undefined, error: string | null | undefined, createdAt: string };

export type StartPodcastImportMutationVariables = Exact<{
  rssFeedUrl: string;
}>;


export type StartPodcastImportMutation = { startPodcastImport: { id: string, status: string, rssFeedUrl: string, totalEpisodes: number, completedEpisodes: number, failedEpisodes: number, failedEpisodeTitles: Array<string>, rssUrl: string | null | undefined, error: string | null | undefined, createdAt: string } };

export type ActiveShowImportQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveShowImportQuery = { activeShowImport: { id: string, status: string, rssFeedUrl: string, totalEpisodes: number, completedEpisodes: number, failedEpisodes: number, failedEpisodeTitles: Array<string>, rssUrl: string | null | undefined, error: string | null | undefined, createdAt: string } | null | undefined };

export type CreateUserMutationVariables = Exact<{
  token: string;
  email: string;
  password: string;
  name: string;
  emailOptIn: boolean;
  marketingData?: any;
  gclid?: string | null | undefined;
  gbraid?: string | null | undefined;
  wbraid?: string | null | undefined;
  tempaAttribution?: any;
}>;


export type CreateUserMutation = { createUser: { user: { id: string, firstName: string, lastName: string | null | undefined, email: string, address: string | null | undefined, phone: string | null | undefined, company: string | null | undefined, role: string, isAuthenticated: boolean | null | undefined, isTester: boolean, activeProjectId: string, callPermalink: string, emailOptIn: boolean, createdAt: string, marketingData: any, autoZoomPreference: boolean, autoCenterPreference: boolean, waveformPreference: WaveformPreference, bitratePreference: number, ga4ClientId: string | null | undefined, librarySortOrder: LibrarySortOrder, transcriptionPreferences: { language: string | null | undefined } }, show: { id: string, name: string | null | undefined, description: string | null | undefined, language: string | null | undefined, feedLimit: number | null | undefined, isExplicit: boolean, type: PodcastType | null | undefined, contentType: ContentType | null | undefined, email: string | null | undefined, hostName: string | null | undefined, timeZone: string | null | undefined, lockFeed: boolean, statsUrlPrefix: string | null | undefined, hasAlituHosting: boolean, userId: string, showExpiresAt: string | null | undefined, artworkUrl: string | null | undefined, waveformPreference: WaveformPreference, bitratePreference: number, autoZoomPreference: boolean | null | undefined, autoCenterPreference: boolean | null | undefined, copyright: string | null | undefined, subdomain: string | null | undefined, showHostingExpiresAt: string | null | undefined, rssFeedUrl: string | null | undefined, redirectUrl: string | null | undefined, host: Host | null | undefined, thirdPartyRssFeed: string | null | undefined, appleClaimToken: string | null | undefined, submittedThroughAppleApi: boolean | null | undefined, txt: string | null | undefined, updateFrequency: string | null | undefined, categories: { category: string | null | undefined, subcategory: string | null | undefined, thirdCategory: string | null | undefined } | null | undefined, transitionDefaults: { intro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingOut: boolean | null | undefined } | null | undefined, outro: { overlap: number | null | undefined, fadeVolume: number | null | undefined, isFadingIn: boolean | null | undefined } | null | undefined } | null | undefined, processingSettings: { voiceAutoEq: boolean, bgNoiseRemoval: boolean, removeBreathings: boolean, bandwidthExtension: boolean }, transcriptionPreferences: { language: string | null | undefined }, links: { apple: string | null | undefined, spotify: string | null | undefined, alituBadge: boolean | null | undefined, facebookPage: string | null | undefined, facebookGroup: string | null | undefined, twitter: string | null | undefined, instagram: string | null | undefined, linkedin: string | null | undefined, youtube: string | null | undefined, website: string | null | undefined, pandora: string | null | undefined, iHeartRadio: string | null | undefined, deezer: string | null | undefined, funding: string | null | undefined }, license: { slug: string | null | undefined, url: string | null | undefined } | null | undefined, location: { title: string | null | undefined, country: string | null | undefined, type: string | null | undefined } | null | undefined } } };

export type CreateCustomerMutationVariables = Exact<{
  company?: Company | null | undefined;
  promoCode?: string | null | undefined;
  address?: StripeAddressParam | null | undefined;
  plan: string;
  hostingPlan?: string | null | undefined;
  paymentMethod?: string | null | undefined;
  celloUcc?: string | null | undefined;
  stripeTestClock?: string | null | undefined;
}>;


export type CreateCustomerMutation = { createCustomer: { clientSecret: string, setupIntentId: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  paymentMethod?: string | null | undefined;
  plan: string;
  hostingPlan?: string | null | undefined;
  isEuropeanUnion: boolean;
  company?: Company | null | undefined;
  withTrial?: boolean | null | undefined;
  promoCode?: string | null | undefined;
  address?: StripeAddressParam | null | undefined;
}>;


export type CreateSubscriptionMutation = { createSubscription: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined, latest_invoice: { amount_due: number, currency: string, id: string, lines: { data: Array<{ amount: number, currency: string, description: string, quantity: number }> | null | undefined }, confirmation_secret: { client_secret: string } | null | undefined } | null | undefined } };

export type CreateSubscriptionFromSetupIntentMutationVariables = Exact<{
  setupIntentId: string;
}>;


export type CreateSubscriptionFromSetupIntentMutation = { createSubscriptionFromSetupIntent: { id: string, status: string, cancel_at_period_end: boolean, current_period_end: number, currency: string, trial_end: number | null | undefined, trial_start: number | null | undefined, hostingExpiresAt: string | null | undefined, hostingSuspended: string | null | undefined, hostingLimit: number, hasAlreadyPaused: boolean, isPaypalSubscription: boolean, metadata: { countryCode: string | null | undefined } | null | undefined, plans: Array<{ nickname: string, amount: number, interval: string, currency: string }> | null | undefined, pause_collection: { resumes_at: number | null | undefined } | null | undefined, discount: { id: string | null | undefined, coupon: { id: string | null | undefined, percent_off: number | null | undefined, amount_off: number | null | undefined, duration: string | null | undefined, duration_in_months: number | null | undefined } | null | undefined } | null | undefined } };

export type TaxPercentageQueryVariables = Exact<{
  countryCode: string;
  vatNumber?: string | null | undefined;
}>;


export type TaxPercentageQuery = { tax: { percentage: number } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { countries: Array<{ name: string, alpha2Code: string, regionalBlocs: Array<{ name: string | null | undefined } | null | undefined> | null | undefined }> | null | undefined };

export type PromoCodeQueryVariables = Exact<{
  promoCode: string;
  planType: string;
  currency?: string | null | undefined;
}>;


export type PromoCodeQuery = { promoCode: { id: string, percent_off: number | null | undefined, amount_off: number | null | undefined, terms: string | null | undefined, duration: string | null | undefined, trial_days: number | null | undefined, interval: string | null | undefined } | null | undefined };

export type SubscriptionPriceQueryVariables = Exact<{
  countryCode: string;
  planType: string;
  hostingPlan?: string | null | undefined;
}>;


export type SubscriptionPriceQuery = { subscriptionPrice: { price: string, currency: string, symbol: string } };

export type StatisticsPageQueryVariables = Exact<{
  showId: string | number;
}>;


export type StatisticsPageQuery = { show: { artworkUrl: string | null | undefined, links: { spotify: string | null | undefined } } };

export type GetPodcastStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPodcastStatsQuery = { getPodcastStats: { downloadsToday: number | null | undefined, downloadsYesterday: number | null | undefined, downloadsLastWeek: number | null | undefined, downloadsLastMonth: number | null | undefined, downloadsLastQuarter: number | null | undefined, downloadsAllTime: number | null | undefined } };

export type GetPodcastAveragesStatsQueryVariables = Exact<{
  period?: string | null | undefined;
}>;


export type GetPodcastAveragesStatsQuery = { getPodcastAveragesStats: { dailyAverage: number | null | undefined, weeklyAverage: number | null | undefined, monthlyAverage: number | null | undefined } };

export type GetEpisodeDownloadsOverviewStatsQueryVariables = Exact<{
  episodeId: string | number;
}>;


export type GetEpisodeDownloadsOverviewStatsQuery = { getEpisodeDownloadsOverviewStats: { downloadsToday: number | null | undefined, downloadsYesterday: number | null | undefined, downloadsLastWeek: number | null | undefined, downloadsLastMonth: number | null | undefined, downloadsLastQuarter: number | null | undefined, downloadsForever: number | null | undefined } };

export type GetOsStatsQueryVariables = Exact<{
  period?: string | null | undefined;
}>;


export type GetOsStatsQuery = { getOSStats: { androidDownloads: number | null | undefined, windowsDownloads: number | null | undefined, macosDownloads: number | null | undefined, iosDownloads: number | null | undefined, others: number | null | undefined } };

export type GetDevicesStatsQueryVariables = Exact<{
  period?: string | null | undefined;
}>;


export type GetDevicesStatsQuery = { getDevicesStats: { mobileDownloads: number | null | undefined, allDownloads: number | null | undefined } };

export type GetCountriesStatsQueryVariables = Exact<{
  period?: string | null | undefined;
}>;


export type GetCountriesStatsQuery = { getCountriesStats: { countriesStats: any } };

export type GetShowDetailsStatsQueryVariables = Exact<{
  limit: number;
  offset: number;
  order: string;
}>;


export type GetShowDetailsStatsQuery = { getShowDetailsStats: { total: number, episodeStats: Array<{ episodeId: string, name: string, episodeNumber: string | null | undefined, deletedAt: string | null | undefined, today: number, yesterday: number, week: number, month: number, quarter: number, forever: number }> } };

export type GetAppsStatsQueryVariables = Exact<{
  start?: string | null | undefined;
}>;


export type GetAppsStatsQuery = { getAppsStats: Array<{ appName: string, downloads: number, percentage: number }> };

export type UniversalFilesQueryVariables = Exact<{
  offset?: number | null | undefined;
  limit?: number | null | undefined;
}>;


export type UniversalFilesQuery = { universalFiles: { total: number, categories: Array<{ name: string, previewFile: any, files: Array<{ id: string, name: string, duration: string | null | undefined, users: any, isAddedToLibrary: boolean }> }> } };

export type LinkFileMutationVariables = Exact<{
  id: string | number;
}>;


export type LinkFileMutation = { linkFile: any };

export type UnlinkFileMutationVariables = Exact<{
  id: string | number;
}>;


export type UnlinkFileMutation = { unlinkFile: boolean };

export const ApiKeyFragmentDoc = gql`
    fragment ApiKey on ApiKey {
  id
  name
  createdAt
}
    `;
export const CreatedApiKeyFragmentDoc = gql`
    fragment CreatedApiKey on ApiKey {
  id
  apiKeyValue
  name
  createdAt
}
    `;
export const ShowFragmentFragmentDoc = gql`
    fragment ShowFragment on Podcast {
  id
  name
  description
  categories {
    category
    subcategory
    thirdCategory
  }
  language
  feedLimit
  isExplicit
  type
  contentType
  email
  hostName
  timeZone
  lockFeed
  statsUrlPrefix
  hasAlituHosting
  userId
  transitionDefaults {
    intro {
      overlap
      fadeVolume
      isFadingOut
    }
    outro {
      overlap
      fadeVolume
      isFadingIn
    }
  }
  processingSettings {
    voiceAutoEq
    bgNoiseRemoval
    removeBreathings
    bandwidthExtension
  }
  showExpiresAt
  artworkUrl
  waveformPreference
  bitratePreference
  transcriptionPreferences {
    language
  }
  autoZoomPreference
  autoCenterPreference
  copyright
  subdomain
  links {
    apple
    spotify
    alituBadge
    facebookPage
    facebookGroup
    twitter
    instagram
    linkedin
    youtube
    website
    pandora
    iHeartRadio
    deezer
    funding
  }
  showHostingExpiresAt
  rssFeedUrl
  redirectUrl
  host
  thirdPartyRssFeed
  appleClaimToken
  submittedThroughAppleApi
  txt
  license {
    slug
    url
  }
  location {
    title
    country
    type
  }
  updateFrequency
}
    `;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on Subscription {
  id
  status
  cancel_at_period_end
  current_period_end
  currency
  trial_end
  trial_start
  metadata {
    countryCode
  }
  plans {
    nickname
    amount
    interval
    currency
  }
  hostingExpiresAt
  pause_collection {
    resumes_at
  }
  hostingSuspended
  hostingLimit
  hasAlreadyPaused
  isPaypalSubscription
}
    `;
export const SubscriptionDiscountFragmentFragmentDoc = gql`
    fragment SubscriptionDiscountFragment on Subscription {
  discount {
    id
    coupon {
      id
      percent_off
      amount_off
      duration
      duration_in_months
    }
  }
}
    `;
export const SubscriptionInvoiceFragmentFragmentDoc = gql`
    fragment SubscriptionInvoiceFragment on Subscription {
  latest_invoice {
    amount_due
    currency
    id
    lines {
      data {
        amount
        currency
        description
        quantity
      }
    }
    confirmation_secret {
      client_secret
    }
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  firstName
  lastName
  email
  address
  phone
  company
  role
  isAuthenticated
  isTester
  activeProjectId
  callPermalink
  emailOptIn
  createdAt
  marketingData
  autoZoomPreference
  autoCenterPreference
  transcriptionPreferences {
    language
  }
  waveformPreference
  bitratePreference
  ga4ClientId
  librarySortOrder
}
    `;
export const MetaDataFragmentDoc = gql`
    fragment MetaData on EpisodeMetaData {
  name
  summary
  description
  episodeNumber
  seasonNumber
  hostNames
  isExplicit
  type
  location {
    title
    country
    type
  }
  __typename
}
    `;
export const AudioItemAllFieldsFragmentDoc = gql`
    fragment AudioItemAllFields on AudioItem {
  type
  start
  end
  sourceStart
  resource
}
    `;
export const RemovedAudioItemAllFieldsFragmentDoc = gql`
    fragment RemovedAudioItemAllFields on RemovedAudioItem {
  type
  id
  start
  sourceStart
  duration
  magicFilter
  resource
}
    `;
export const SilenceItemAllFieldsFragmentDoc = gql`
    fragment SilenceItemAllFields on SilenceItem {
  type
  id
  start
  end
}
    `;
export const MuteItemAllFieldsFragmentDoc = gql`
    fragment MuteItemAllFields on MuteItem {
  type
  id
  start
  end
  sourceStart
  resource
}
    `;
export const BleepItemAllFieldsFragmentDoc = gql`
    fragment BleepItemAllFields on BleepItem {
  type
  id
  start
  end
  sourceStart
  resource
}
    `;
export const BackgroundItemAllFieldsFragmentDoc = gql`
    fragment BackgroundItemAllFields on BackgroundItem {
  type
  id
  start
  end
  sourceStart
  resource
  volume
  fadeInDuration
  fadeOutDuration
}
    `;
export const MarkerItemAllFieldsFragmentDoc = gql`
    fragment MarkerItemAllFields on MarkerItem {
  type
  id
  start
  parentRegion
}
    `;
export const EpisodeFileFragmentDoc = gql`
    fragment EpisodeFile on EpisodeFile {
  id
  uniqueId
  type
  name
  bucket
  duration
  trimmedDuration
  overlapDuration
  audioTimeline {
    ...AudioItemAllFields
    ...RemovedAudioItemAllFields
    ...SilenceItemAllFields
    ...MuteItemAllFields
    ...BleepItemAllFields
    ...BackgroundItemAllFields
    ...MarkerItemAllFields
  }
  tags
  fade {
    isFadingIn
    isFadingOut
    fadeVolume
  }
  job {
    id
    schema
    status
    progress
    createdAt
    hash
    userId
  }
  additionalFiles {
    id
    name
    duration
  }
  hasVideo
  trimSource {
    inPoint
    outPoint
  }
  visual {
    source
    customImageFileId
    replaceVideo
    layout {
      mode
      blurredBackground
    }
  }
}
    ${AudioItemAllFieldsFragmentDoc}
${RemovedAudioItemAllFieldsFragmentDoc}
${SilenceItemAllFieldsFragmentDoc}
${MuteItemAllFieldsFragmentDoc}
${BleepItemAllFieldsFragmentDoc}
${BackgroundItemAllFieldsFragmentDoc}
${MarkerItemAllFieldsFragmentDoc}`;
export const EpisodeAllFieldsFragmentDoc = gql`
    fragment EpisodeAllFields on Episode {
  id
  guid
  metaData {
    ...MetaData
  }
  timeline {
    ...EpisodeFile
  }
  version
  isArchivedVersion
  createdAt
  publishedAt
  host
  shouldSuggestTitle
  shouldSuggestDescription
  shouldIncludeTranscriptInRss
  artworkUrl
  hasArtwork
  updatedAt
  videoMode
}
    ${MetaDataFragmentDoc}
${EpisodeFileFragmentDoc}`;
export const DefaultMusicFieldsFragmentDoc = gql`
    fragment DefaultMusicFields on File {
  id
  name
  type
}
    `;
export const ShowImportFieldsFragmentDoc = gql`
    fragment ShowImportFields on ShowImport {
  id
  status
  rssFeedUrl
  totalEpisodes
  completedEpisodes
  failedEpisodes
  failedEpisodeTitles
  rssUrl
  error
  createdAt
}
    `;
export const GetApiKeysDocument = gql`
    query getApiKeys {
  getApiKeys {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
// @ts-ignore
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiKeysQuery | undefined, GetApiKeysQueryVariables>;
export function useGetApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysSuspenseQueryHookResult = ReturnType<typeof useGetApiKeysSuspenseQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($name: String!) {
  createApiKey(name: $name) {
    ...CreatedApiKey
  }
}
    ${CreatedApiKeyFragmentDoc}`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation updateApiKey($id: ID!, $input: ApiKeyUpdateInput!) {
  updateApiKey(id: $id, input: $input) {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const DeleteAPiKeyDocument = gql`
    mutation deleteAPiKey($id: ID!) {
  deleteApiKey(id: $id) {
    ...ApiKey
  }
}
    ${ApiKeyFragmentDoc}`;
export type DeleteAPiKeyMutationFn = Apollo.MutationFunction<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>;

/**
 * __useDeleteAPiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteAPiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAPiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAPiKeyMutation, { data, loading, error }] = useDeleteAPiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAPiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>(DeleteAPiKeyDocument, options);
      }
export type DeleteAPiKeyMutationHookResult = ReturnType<typeof useDeleteAPiKeyMutation>;
export type DeleteAPiKeyMutationResult = Apollo.MutationResult<DeleteAPiKeyMutation>;
export type DeleteAPiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteAPiKeyMutation, DeleteAPiKeyMutationVariables>;
export const GetCelloTokenDocument = gql`
    query getCelloToken {
  getCelloToken {
    token
    productId
  }
}
    `;

/**
 * __useGetCelloTokenQuery__
 *
 * To run a query within a React component, call `useGetCelloTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCelloTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCelloTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCelloTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetCelloTokenQuery, GetCelloTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCelloTokenQuery, GetCelloTokenQueryVariables>(GetCelloTokenDocument, options);
      }
export function useGetCelloTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCelloTokenQuery, GetCelloTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCelloTokenQuery, GetCelloTokenQueryVariables>(GetCelloTokenDocument, options);
        }
// @ts-ignore
export function useGetCelloTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCelloTokenQuery, GetCelloTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetCelloTokenQuery, GetCelloTokenQueryVariables>;
export function useGetCelloTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCelloTokenQuery, GetCelloTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetCelloTokenQuery | undefined, GetCelloTokenQueryVariables>;
export function useGetCelloTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCelloTokenQuery, GetCelloTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCelloTokenQuery, GetCelloTokenQueryVariables>(GetCelloTokenDocument, options);
        }
export type GetCelloTokenQueryHookResult = ReturnType<typeof useGetCelloTokenQuery>;
export type GetCelloTokenLazyQueryHookResult = ReturnType<typeof useGetCelloTokenLazyQuery>;
export type GetCelloTokenSuspenseQueryHookResult = ReturnType<typeof useGetCelloTokenSuspenseQuery>;
export type GetCelloTokenQueryResult = Apollo.QueryResult<GetCelloTokenQuery, GetCelloTokenQueryVariables>;
export const CreateMetaDataJobDocument = gql`
    mutation createMetaDataJob($episodeId: ID!, $metaData: EpisodeMetaDataInput!) {
  createMetaDataJob(episodeId: $episodeId, metaData: $metaData) {
    id
  }
}
    `;
export type CreateMetaDataJobMutationFn = Apollo.MutationFunction<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>;

/**
 * __useCreateMetaDataJobMutation__
 *
 * To run a mutation, you first call `useCreateMetaDataJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaDataJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaDataJobMutation, { data, loading, error }] = useCreateMetaDataJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      metaData: // value for 'metaData'
 *   },
 * });
 */
export function useCreateMetaDataJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>(CreateMetaDataJobDocument, options);
      }
export type CreateMetaDataJobMutationHookResult = ReturnType<typeof useCreateMetaDataJobMutation>;
export type CreateMetaDataJobMutationResult = Apollo.MutationResult<CreateMetaDataJobMutation>;
export type CreateMetaDataJobMutationOptions = Apollo.BaseMutationOptions<CreateMetaDataJobMutation, CreateMetaDataJobMutationVariables>;
export const ShowDocument = gql`
    query show($id: ID!) {
  show(id: $id) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;

/**
 * __useShowQuery__
 *
 * To run a query within a React component, call `useShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShowQuery(baseOptions: Apollo.QueryHookOptions<ShowQuery, ShowQueryVariables> & ({ variables: ShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
      }
export function useShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowQuery, ShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
        }
// @ts-ignore
export function useShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShowQuery, ShowQueryVariables>): Apollo.UseSuspenseQueryResult<ShowQuery, ShowQueryVariables>;
export function useShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowQuery, ShowQueryVariables>): Apollo.UseSuspenseQueryResult<ShowQuery | undefined, ShowQueryVariables>;
export function useShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowQuery, ShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowQuery, ShowQueryVariables>(ShowDocument, options);
        }
export type ShowQueryHookResult = ReturnType<typeof useShowQuery>;
export type ShowLazyQueryHookResult = ReturnType<typeof useShowLazyQuery>;
export type ShowSuspenseQueryHookResult = ReturnType<typeof useShowSuspenseQuery>;
export type ShowQueryResult = Apollo.QueryResult<ShowQuery, ShowQueryVariables>;
export const UpdateTransitionDefaultsDocument = gql`
    mutation updateTransitionDefaults($data: TransitionDefaultsInput!) {
  updateTransitionDefaults(data: $data) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type UpdateTransitionDefaultsMutationFn = Apollo.MutationFunction<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>;

/**
 * __useUpdateTransitionDefaultsMutation__
 *
 * To run a mutation, you first call `useUpdateTransitionDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransitionDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransitionDefaultsMutation, { data, loading, error }] = useUpdateTransitionDefaultsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTransitionDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>(UpdateTransitionDefaultsDocument, options);
      }
export type UpdateTransitionDefaultsMutationHookResult = ReturnType<typeof useUpdateTransitionDefaultsMutation>;
export type UpdateTransitionDefaultsMutationResult = Apollo.MutationResult<UpdateTransitionDefaultsMutation>;
export type UpdateTransitionDefaultsMutationOptions = Apollo.BaseMutationOptions<UpdateTransitionDefaultsMutation, UpdateTransitionDefaultsMutationVariables>;
export const RenewAlituHostingDocument = gql`
    mutation renewAlituHosting($showId: ID!) {
  renewAlituHosting(showId: $showId) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type RenewAlituHostingMutationFn = Apollo.MutationFunction<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>;

/**
 * __useRenewAlituHostingMutation__
 *
 * To run a mutation, you first call `useRenewAlituHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewAlituHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewAlituHostingMutation, { data, loading, error }] = useRenewAlituHostingMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useRenewAlituHostingMutation(baseOptions?: Apollo.MutationHookOptions<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>(RenewAlituHostingDocument, options);
      }
export type RenewAlituHostingMutationHookResult = ReturnType<typeof useRenewAlituHostingMutation>;
export type RenewAlituHostingMutationResult = Apollo.MutationResult<RenewAlituHostingMutation>;
export type RenewAlituHostingMutationOptions = Apollo.BaseMutationOptions<RenewAlituHostingMutation, RenewAlituHostingMutationVariables>;
export const GetSubscriptionDocument = gql`
    query getSubscription {
  subscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionQuery | undefined, GetSubscriptionQueryVariables>;
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const UserDocument = gql`
    query user {
  user {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UploadUrlsDocument = gql`
    mutation uploadUrls($numberOfFiles: Int!) {
  uploadUrls(numberOfFiles: $numberOfFiles) {
    id
    url
  }
}
    `;
export type UploadUrlsMutationFn = Apollo.MutationFunction<UploadUrlsMutation, UploadUrlsMutationVariables>;

/**
 * __useUploadUrlsMutation__
 *
 * To run a mutation, you first call `useUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadUrlsMutation, { data, loading, error }] = useUploadUrlsMutation({
 *   variables: {
 *      numberOfFiles: // value for 'numberOfFiles'
 *   },
 * });
 */
export function useUploadUrlsMutation(baseOptions?: Apollo.MutationHookOptions<UploadUrlsMutation, UploadUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadUrlsMutation, UploadUrlsMutationVariables>(UploadUrlsDocument, options);
      }
export type UploadUrlsMutationHookResult = ReturnType<typeof useUploadUrlsMutation>;
export type UploadUrlsMutationResult = Apollo.MutationResult<UploadUrlsMutation>;
export type UploadUrlsMutationOptions = Apollo.BaseMutationOptions<UploadUrlsMutation, UploadUrlsMutationVariables>;
export const CreateFileDocument = gql`
    mutation createFile($keys: [ID!]!, $filename: String!, $type: String!, $tags: [String], $skipAuphonic: Boolean, $isUniversal: Boolean, $duration: Float!) {
  createFile(
    keys: $keys
    filename: $filename
    type: $type
    tags: $tags
    skipAuphonic: $skipAuphonic
    isUniversal: $isUniversal
    duration: $duration
  ) {
    fileId
    jobId
  }
}
    `;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *      filename: // value for 'filename'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *      skipAuphonic: // value for 'skipAuphonic'
 *      isUniversal: // value for 'isUniversal'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const CreateImageFileDocument = gql`
    mutation createImageFile($key: ID!, $filename: String!, $tags: [String]) {
  createImageFile(key: $key, filename: $filename, tags: $tags) {
    fileId
    jobId
  }
}
    `;
export type CreateImageFileMutationFn = Apollo.MutationFunction<CreateImageFileMutation, CreateImageFileMutationVariables>;

/**
 * __useCreateImageFileMutation__
 *
 * To run a mutation, you first call `useCreateImageFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageFileMutation, { data, loading, error }] = useCreateImageFileMutation({
 *   variables: {
 *      key: // value for 'key'
 *      filename: // value for 'filename'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateImageFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateImageFileMutation, CreateImageFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImageFileMutation, CreateImageFileMutationVariables>(CreateImageFileDocument, options);
      }
export type CreateImageFileMutationHookResult = ReturnType<typeof useCreateImageFileMutation>;
export type CreateImageFileMutationResult = Apollo.MutationResult<CreateImageFileMutation>;
export type CreateImageFileMutationOptions = Apollo.BaseMutationOptions<CreateImageFileMutation, CreateImageFileMutationVariables>;
export const PermissionsDocument = gql`
    query permissions {
  permissions {
    tier
    episodeLimit
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
// @ts-ignore
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsQuery, PermissionsQueryVariables>;
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsQuery | undefined, PermissionsQueryVariables>;
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsSuspenseQueryHookResult = ReturnType<typeof usePermissionsSuspenseQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const ShowsDocument = gql`
    query shows {
  shows {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;

/**
 * __useShowsQuery__
 *
 * To run a query within a React component, call `useShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowsQuery(baseOptions?: Apollo.QueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
      }
export function useShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
        }
// @ts-ignore
export function useShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShowsQuery, ShowsQueryVariables>): Apollo.UseSuspenseQueryResult<ShowsQuery, ShowsQueryVariables>;
export function useShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowsQuery, ShowsQueryVariables>): Apollo.UseSuspenseQueryResult<ShowsQuery | undefined, ShowsQueryVariables>;
export function useShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShowsQuery, ShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShowsQuery, ShowsQueryVariables>(ShowsDocument, options);
        }
export type ShowsQueryHookResult = ReturnType<typeof useShowsQuery>;
export type ShowsLazyQueryHookResult = ReturnType<typeof useShowsLazyQuery>;
export type ShowsSuspenseQueryHookResult = ReturnType<typeof useShowsSuspenseQuery>;
export type ShowsQueryResult = Apollo.QueryResult<ShowsQuery, ShowsQueryVariables>;
export const AddShowDocument = gql`
    mutation addShow($name: String!) {
  addShow(name: $name)
}
    `;
export type AddShowMutationFn = Apollo.MutationFunction<AddShowMutation, AddShowMutationVariables>;

/**
 * __useAddShowMutation__
 *
 * To run a mutation, you first call `useAddShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShowMutation, { data, loading, error }] = useAddShowMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddShowMutation(baseOptions?: Apollo.MutationHookOptions<AddShowMutation, AddShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShowMutation, AddShowMutationVariables>(AddShowDocument, options);
      }
export type AddShowMutationHookResult = ReturnType<typeof useAddShowMutation>;
export type AddShowMutationResult = Apollo.MutationResult<AddShowMutation>;
export type AddShowMutationOptions = Apollo.BaseMutationOptions<AddShowMutation, AddShowMutationVariables>;
export const RemoveShowDocument = gql`
    mutation removeShow($id: ID!) {
  removeShow(id: $id) {
    success
  }
}
    `;
export type RemoveShowMutationFn = Apollo.MutationFunction<RemoveShowMutation, RemoveShowMutationVariables>;

/**
 * __useRemoveShowMutation__
 *
 * To run a mutation, you first call `useRemoveShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShowMutation, { data, loading, error }] = useRemoveShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveShowMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShowMutation, RemoveShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShowMutation, RemoveShowMutationVariables>(RemoveShowDocument, options);
      }
export type RemoveShowMutationHookResult = ReturnType<typeof useRemoveShowMutation>;
export type RemoveShowMutationResult = Apollo.MutationResult<RemoveShowMutation>;
export type RemoveShowMutationOptions = Apollo.BaseMutationOptions<RemoveShowMutation, RemoveShowMutationVariables>;
export const RenewShowDocument = gql`
    mutation renewShow($id: ID!) {
  renewShow(id: $id) {
    success
  }
}
    `;
export type RenewShowMutationFn = Apollo.MutationFunction<RenewShowMutation, RenewShowMutationVariables>;

/**
 * __useRenewShowMutation__
 *
 * To run a mutation, you first call `useRenewShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewShowMutation, { data, loading, error }] = useRenewShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenewShowMutation(baseOptions?: Apollo.MutationHookOptions<RenewShowMutation, RenewShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewShowMutation, RenewShowMutationVariables>(RenewShowDocument, options);
      }
export type RenewShowMutationHookResult = ReturnType<typeof useRenewShowMutation>;
export type RenewShowMutationResult = Apollo.MutationResult<RenewShowMutation>;
export type RenewShowMutationOptions = Apollo.BaseMutationOptions<RenewShowMutation, RenewShowMutationVariables>;
export const CreateEpisodeDocument = gql`
    mutation createEpisode($metaData: EpisodeMetaDataInput!) {
  episode: createEpisode(metaData: $metaData) {
    id
  }
}
    `;
export type CreateEpisodeMutationFn = Apollo.MutationFunction<CreateEpisodeMutation, CreateEpisodeMutationVariables>;

/**
 * __useCreateEpisodeMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeMutation, { data, loading, error }] = useCreateEpisodeMutation({
 *   variables: {
 *      metaData: // value for 'metaData'
 *   },
 * });
 */
export function useCreateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpisodeMutation, CreateEpisodeMutationVariables>(CreateEpisodeDocument, options);
      }
export type CreateEpisodeMutationHookResult = ReturnType<typeof useCreateEpisodeMutation>;
export type CreateEpisodeMutationResult = Apollo.MutationResult<CreateEpisodeMutation>;
export type CreateEpisodeMutationOptions = Apollo.BaseMutationOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>;
export const PopulateShowDetailsFromRssDocument = gql`
    mutation populateShowDetailsFromRss($rssFeedUrl: String!) {
  populateShowDetailsFromRss(rssFeedUrl: $rssFeedUrl) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type PopulateShowDetailsFromRssMutationFn = Apollo.MutationFunction<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>;

/**
 * __usePopulateShowDetailsFromRssMutation__
 *
 * To run a mutation, you first call `usePopulateShowDetailsFromRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateShowDetailsFromRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateShowDetailsFromRssMutation, { data, loading, error }] = usePopulateShowDetailsFromRssMutation({
 *   variables: {
 *      rssFeedUrl: // value for 'rssFeedUrl'
 *   },
 * });
 */
export function usePopulateShowDetailsFromRssMutation(baseOptions?: Apollo.MutationHookOptions<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>(PopulateShowDetailsFromRssDocument, options);
      }
export type PopulateShowDetailsFromRssMutationHookResult = ReturnType<typeof usePopulateShowDetailsFromRssMutation>;
export type PopulateShowDetailsFromRssMutationResult = Apollo.MutationResult<PopulateShowDetailsFromRssMutation>;
export type PopulateShowDetailsFromRssMutationOptions = Apollo.BaseMutationOptions<PopulateShowDetailsFromRssMutation, PopulateShowDetailsFromRssMutationVariables>;
export const GetRssAndPopulateBuzzsproutShowDetailsDocument = gql`
    mutation getRssAndPopulateBuzzsproutShowDetails {
  getRssAndPopulateBuzzsproutShowDetails {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationFn = Apollo.MutationFunction<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>;

/**
 * __useGetRssAndPopulateBuzzsproutShowDetailsMutation__
 *
 * To run a mutation, you first call `useGetRssAndPopulateBuzzsproutShowDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRssAndPopulateBuzzsproutShowDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRssAndPopulateBuzzsproutShowDetailsMutation, { data, loading, error }] = useGetRssAndPopulateBuzzsproutShowDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetRssAndPopulateBuzzsproutShowDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>(GetRssAndPopulateBuzzsproutShowDetailsDocument, options);
      }
export type GetRssAndPopulateBuzzsproutShowDetailsMutationHookResult = ReturnType<typeof useGetRssAndPopulateBuzzsproutShowDetailsMutation>;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationResult = Apollo.MutationResult<GetRssAndPopulateBuzzsproutShowDetailsMutation>;
export type GetRssAndPopulateBuzzsproutShowDetailsMutationOptions = Apollo.BaseMutationOptions<GetRssAndPopulateBuzzsproutShowDetailsMutation, GetRssAndPopulateBuzzsproutShowDetailsMutationVariables>;
export const GetRssAndPopulatePodbeanShowDetailsDocument = gql`
    mutation getRssAndPopulatePodbeanShowDetails {
  getRssAndPopulatePodbeanShowDetails {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type GetRssAndPopulatePodbeanShowDetailsMutationFn = Apollo.MutationFunction<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>;

/**
 * __useGetRssAndPopulatePodbeanShowDetailsMutation__
 *
 * To run a mutation, you first call `useGetRssAndPopulatePodbeanShowDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRssAndPopulatePodbeanShowDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRssAndPopulatePodbeanShowDetailsMutation, { data, loading, error }] = useGetRssAndPopulatePodbeanShowDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetRssAndPopulatePodbeanShowDetailsMutation(baseOptions?: Apollo.MutationHookOptions<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>(GetRssAndPopulatePodbeanShowDetailsDocument, options);
      }
export type GetRssAndPopulatePodbeanShowDetailsMutationHookResult = ReturnType<typeof useGetRssAndPopulatePodbeanShowDetailsMutation>;
export type GetRssAndPopulatePodbeanShowDetailsMutationResult = Apollo.MutationResult<GetRssAndPopulatePodbeanShowDetailsMutation>;
export type GetRssAndPopulatePodbeanShowDetailsMutationOptions = Apollo.BaseMutationOptions<GetRssAndPopulatePodbeanShowDetailsMutation, GetRssAndPopulatePodbeanShowDetailsMutationVariables>;
export const SubmitShowToAppleDocument = gql`
    mutation submitShowToApple {
  submitShowToApple {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type SubmitShowToAppleMutationFn = Apollo.MutationFunction<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>;

/**
 * __useSubmitShowToAppleMutation__
 *
 * To run a mutation, you first call `useSubmitShowToAppleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitShowToAppleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitShowToAppleMutation, { data, loading, error }] = useSubmitShowToAppleMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitShowToAppleMutation(baseOptions?: Apollo.MutationHookOptions<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>(SubmitShowToAppleDocument, options);
      }
export type SubmitShowToAppleMutationHookResult = ReturnType<typeof useSubmitShowToAppleMutation>;
export type SubmitShowToAppleMutationResult = Apollo.MutationResult<SubmitShowToAppleMutation>;
export type SubmitShowToAppleMutationOptions = Apollo.BaseMutationOptions<SubmitShowToAppleMutation, SubmitShowToAppleMutationVariables>;
export const PopulateAppleClaimTokenDocument = gql`
    mutation populateAppleClaimToken($token: String!) {
  populateAppleClaimToken(token: $token) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type PopulateAppleClaimTokenMutationFn = Apollo.MutationFunction<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>;

/**
 * __usePopulateAppleClaimTokenMutation__
 *
 * To run a mutation, you first call `usePopulateAppleClaimTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePopulateAppleClaimTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [populateAppleClaimTokenMutation, { data, loading, error }] = usePopulateAppleClaimTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function usePopulateAppleClaimTokenMutation(baseOptions?: Apollo.MutationHookOptions<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>(PopulateAppleClaimTokenDocument, options);
      }
export type PopulateAppleClaimTokenMutationHookResult = ReturnType<typeof usePopulateAppleClaimTokenMutation>;
export type PopulateAppleClaimTokenMutationResult = Apollo.MutationResult<PopulateAppleClaimTokenMutation>;
export type PopulateAppleClaimTokenMutationOptions = Apollo.BaseMutationOptions<PopulateAppleClaimTokenMutation, PopulateAppleClaimTokenMutationVariables>;
export const CheckAppleShowStatusDocument = gql`
    query checkAppleShowStatus($appleShowId: String!) {
  checkAppleShowStatus(appleShowId: $appleShowId) {
    exists
  }
}
    `;

/**
 * __useCheckAppleShowStatusQuery__
 *
 * To run a query within a React component, call `useCheckAppleShowStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAppleShowStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAppleShowStatusQuery({
 *   variables: {
 *      appleShowId: // value for 'appleShowId'
 *   },
 * });
 */
export function useCheckAppleShowStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables> & ({ variables: CheckAppleShowStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
      }
export function useCheckAppleShowStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
        }
// @ts-ignore
export function useCheckAppleShowStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>;
export function useCheckAppleShowStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>): Apollo.UseSuspenseQueryResult<CheckAppleShowStatusQuery | undefined, CheckAppleShowStatusQueryVariables>;
export function useCheckAppleShowStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>(CheckAppleShowStatusDocument, options);
        }
export type CheckAppleShowStatusQueryHookResult = ReturnType<typeof useCheckAppleShowStatusQuery>;
export type CheckAppleShowStatusLazyQueryHookResult = ReturnType<typeof useCheckAppleShowStatusLazyQuery>;
export type CheckAppleShowStatusSuspenseQueryHookResult = ReturnType<typeof useCheckAppleShowStatusSuspenseQuery>;
export type CheckAppleShowStatusQueryResult = Apollo.QueryResult<CheckAppleShowStatusQuery, CheckAppleShowStatusQueryVariables>;
export const AlituEpisodesCountPerShowDocument = gql`
    query alituEpisodesCountPerShow {
  alituEpisodesCountPerShow
}
    `;

/**
 * __useAlituEpisodesCountPerShowQuery__
 *
 * To run a query within a React component, call `useAlituEpisodesCountPerShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlituEpisodesCountPerShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlituEpisodesCountPerShowQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlituEpisodesCountPerShowQuery(baseOptions?: Apollo.QueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
      }
export function useAlituEpisodesCountPerShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
        }
// @ts-ignore
export function useAlituEpisodesCountPerShowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>): Apollo.UseSuspenseQueryResult<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>;
export function useAlituEpisodesCountPerShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>): Apollo.UseSuspenseQueryResult<AlituEpisodesCountPerShowQuery | undefined, AlituEpisodesCountPerShowQueryVariables>;
export function useAlituEpisodesCountPerShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>(AlituEpisodesCountPerShowDocument, options);
        }
export type AlituEpisodesCountPerShowQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowQuery>;
export type AlituEpisodesCountPerShowLazyQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowLazyQuery>;
export type AlituEpisodesCountPerShowSuspenseQueryHookResult = ReturnType<typeof useAlituEpisodesCountPerShowSuspenseQuery>;
export type AlituEpisodesCountPerShowQueryResult = Apollo.QueryResult<AlituEpisodesCountPerShowQuery, AlituEpisodesCountPerShowQueryVariables>;
export const GetDemoFileAndTranscriptDocument = gql`
    query getDemoFileAndTranscript {
  getDemoFileAndTranscript {
    demoFile {
      id
      name
      bucket
      type
      tags
      codecInformation {
        format {
          duration
        }
      }
      job: audioJob {
        id
        schema
        status
        createdAt
        hash
        userId
      }
    }
    transcript {
      id
      fileId
      speakerNames
      createdAt
      status
    }
  }
}
    `;

/**
 * __useGetDemoFileAndTranscriptQuery__
 *
 * To run a query within a React component, call `useGetDemoFileAndTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemoFileAndTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemoFileAndTranscriptQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDemoFileAndTranscriptQuery(baseOptions?: Apollo.QueryHookOptions<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>(GetDemoFileAndTranscriptDocument, options);
      }
export function useGetDemoFileAndTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>(GetDemoFileAndTranscriptDocument, options);
        }
// @ts-ignore
export function useGetDemoFileAndTranscriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>;
export function useGetDemoFileAndTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemoFileAndTranscriptQuery | undefined, GetDemoFileAndTranscriptQueryVariables>;
export function useGetDemoFileAndTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>(GetDemoFileAndTranscriptDocument, options);
        }
export type GetDemoFileAndTranscriptQueryHookResult = ReturnType<typeof useGetDemoFileAndTranscriptQuery>;
export type GetDemoFileAndTranscriptLazyQueryHookResult = ReturnType<typeof useGetDemoFileAndTranscriptLazyQuery>;
export type GetDemoFileAndTranscriptSuspenseQueryHookResult = ReturnType<typeof useGetDemoFileAndTranscriptSuspenseQuery>;
export type GetDemoFileAndTranscriptQueryResult = Apollo.QueryResult<GetDemoFileAndTranscriptQuery, GetDemoFileAndTranscriptQueryVariables>;
export const GetUniversalFileDocument = gql`
    query getUniversalFile($id: ID!) {
  universalFile(id: $id) {
    id
    name
    bucket
    type
    tags
    codecInformation {
      format {
        duration
      }
    }
    audioJob {
      id
      schema
      status
      createdAt
      hash
      userId
    }
    transcriptionJob {
      id
      schema
      status
      createdAt
      hash
      userId
    }
  }
}
    `;

/**
 * __useGetUniversalFileQuery__
 *
 * To run a query within a React component, call `useGetUniversalFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversalFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversalFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUniversalFileQuery(baseOptions: Apollo.QueryHookOptions<GetUniversalFileQuery, GetUniversalFileQueryVariables> & ({ variables: GetUniversalFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniversalFileQuery, GetUniversalFileQueryVariables>(GetUniversalFileDocument, options);
      }
export function useGetUniversalFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversalFileQuery, GetUniversalFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniversalFileQuery, GetUniversalFileQueryVariables>(GetUniversalFileDocument, options);
        }
// @ts-ignore
export function useGetUniversalFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUniversalFileQuery, GetUniversalFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniversalFileQuery, GetUniversalFileQueryVariables>;
export function useGetUniversalFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniversalFileQuery, GetUniversalFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetUniversalFileQuery | undefined, GetUniversalFileQueryVariables>;
export function useGetUniversalFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniversalFileQuery, GetUniversalFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniversalFileQuery, GetUniversalFileQueryVariables>(GetUniversalFileDocument, options);
        }
export type GetUniversalFileQueryHookResult = ReturnType<typeof useGetUniversalFileQuery>;
export type GetUniversalFileLazyQueryHookResult = ReturnType<typeof useGetUniversalFileLazyQuery>;
export type GetUniversalFileSuspenseQueryHookResult = ReturnType<typeof useGetUniversalFileSuspenseQuery>;
export type GetUniversalFileQueryResult = Apollo.QueryResult<GetUniversalFileQuery, GetUniversalFileQueryVariables>;
export const AddHostingDocument = gql`
    mutation addHosting($hostingPlan: String!) {
  addHosting(hostingPlan: $hostingPlan) {
    subscription {
      ...SubscriptionFragment
      ...SubscriptionDiscountFragment
    }
    show {
      ...ShowFragment
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}
${ShowFragmentFragmentDoc}`;
export type AddHostingMutationFn = Apollo.MutationFunction<AddHostingMutation, AddHostingMutationVariables>;

/**
 * __useAddHostingMutation__
 *
 * To run a mutation, you first call `useAddHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHostingMutation, { data, loading, error }] = useAddHostingMutation({
 *   variables: {
 *      hostingPlan: // value for 'hostingPlan'
 *   },
 * });
 */
export function useAddHostingMutation(baseOptions?: Apollo.MutationHookOptions<AddHostingMutation, AddHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddHostingMutation, AddHostingMutationVariables>(AddHostingDocument, options);
      }
export type AddHostingMutationHookResult = ReturnType<typeof useAddHostingMutation>;
export type AddHostingMutationResult = Apollo.MutationResult<AddHostingMutation>;
export type AddHostingMutationOptions = Apollo.BaseMutationOptions<AddHostingMutation, AddHostingMutationVariables>;
export const DeleteSubscriptionDocument = gql`
    mutation deleteSubscription($isPausing: Boolean) {
  deleteSubscription(isPausing: $isPausing) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type DeleteSubscriptionMutationFn = Apollo.MutationFunction<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;

/**
 * __useDeleteSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubscriptionMutation, { data, loading, error }] = useDeleteSubscriptionMutation({
 *   variables: {
 *      isPausing: // value for 'isPausing'
 *   },
 * });
 */
export function useDeleteSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>(DeleteSubscriptionDocument, options);
      }
export type DeleteSubscriptionMutationHookResult = ReturnType<typeof useDeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationResult = Apollo.MutationResult<DeleteSubscriptionMutation>;
export type DeleteSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteSubscriptionMutation, DeleteSubscriptionMutationVariables>;
export const PauseSubscriptionDocument = gql`
    mutation pauseSubscription($typeformFormId: String!, $typeformResponseId: String!) {
  pauseSubscription(
    typeformFormId: $typeformFormId
    typeformResponseId: $typeformResponseId
  ) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type PauseSubscriptionMutationFn = Apollo.MutationFunction<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;

/**
 * __usePauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionMutation, { data, loading, error }] = usePauseSubscriptionMutation({
 *   variables: {
 *      typeformFormId: // value for 'typeformFormId'
 *      typeformResponseId: // value for 'typeformResponseId'
 *   },
 * });
 */
export function usePauseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, options);
      }
export type PauseSubscriptionMutationHookResult = ReturnType<typeof usePauseSubscriptionMutation>;
export type PauseSubscriptionMutationResult = Apollo.MutationResult<PauseSubscriptionMutation>;
export type PauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;
export const CancelHostingSubscriptionDocument = gql`
    mutation cancelHostingSubscription {
  cancelHostingSubscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type CancelHostingSubscriptionMutationFn = Apollo.MutationFunction<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>;

/**
 * __useCancelHostingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelHostingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelHostingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelHostingSubscriptionMutation, { data, loading, error }] = useCancelHostingSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelHostingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>(CancelHostingSubscriptionDocument, options);
      }
export type CancelHostingSubscriptionMutationHookResult = ReturnType<typeof useCancelHostingSubscriptionMutation>;
export type CancelHostingSubscriptionMutationResult = Apollo.MutationResult<CancelHostingSubscriptionMutation>;
export type CancelHostingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelHostingSubscriptionMutation, CancelHostingSubscriptionMutationVariables>;
export const UnpauseSubscriptionDocument = gql`
    mutation unpauseSubscription {
  unpauseSubscription {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type UnpauseSubscriptionMutationFn = Apollo.MutationFunction<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>;

/**
 * __useUnpauseSubscriptionMutation__
 *
 * To run a mutation, you first call `useUnpauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpauseSubscriptionMutation, { data, loading, error }] = useUnpauseSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnpauseSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>(UnpauseSubscriptionDocument, options);
      }
export type UnpauseSubscriptionMutationHookResult = ReturnType<typeof useUnpauseSubscriptionMutation>;
export type UnpauseSubscriptionMutationResult = Apollo.MutationResult<UnpauseSubscriptionMutation>;
export type UnpauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<UnpauseSubscriptionMutation, UnpauseSubscriptionMutationVariables>;
export const UpgradeFromTrialDocument = gql`
    mutation upgradeFromTrial {
  upgradeFromTrial {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type UpgradeFromTrialMutationFn = Apollo.MutationFunction<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>;

/**
 * __useUpgradeFromTrialMutation__
 *
 * To run a mutation, you first call `useUpgradeFromTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeFromTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeFromTrialMutation, { data, loading, error }] = useUpgradeFromTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpgradeFromTrialMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>(UpgradeFromTrialDocument, options);
      }
export type UpgradeFromTrialMutationHookResult = ReturnType<typeof useUpgradeFromTrialMutation>;
export type UpgradeFromTrialMutationResult = Apollo.MutationResult<UpgradeFromTrialMutation>;
export type UpgradeFromTrialMutationOptions = Apollo.BaseMutationOptions<UpgradeFromTrialMutation, UpgradeFromTrialMutationVariables>;
export const UpcomingInvoiceDocument = gql`
    query upcomingInvoice {
  upcomingInvoice {
    amount
    currency
  }
}
    `;

/**
 * __useUpcomingInvoiceQuery__
 *
 * To run a query within a React component, call `useUpcomingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpcomingInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
      }
export function useUpcomingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
// @ts-ignore
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>;
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingInvoiceQuery | undefined, UpcomingInvoiceQueryVariables>;
export function useUpcomingInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>(UpcomingInvoiceDocument, options);
        }
export type UpcomingInvoiceQueryHookResult = ReturnType<typeof useUpcomingInvoiceQuery>;
export type UpcomingInvoiceLazyQueryHookResult = ReturnType<typeof useUpcomingInvoiceLazyQuery>;
export type UpcomingInvoiceSuspenseQueryHookResult = ReturnType<typeof useUpcomingInvoiceSuspenseQuery>;
export type UpcomingInvoiceQueryResult = Apollo.QueryResult<UpcomingInvoiceQuery, UpcomingInvoiceQueryVariables>;
export const SwitchPlanPreviewDocument = gql`
    query switchPlanPreview($changeType: String!, $planType: String) {
  subscriptionChangePreview(changeType: $changeType, planType: $planType) {
    immediateCharge
    nextPaymentAmount
    nextPaymentDate
    creditAmount
    currency
    changeType
    currentInterval
    newInterval
    currentPlanType
    newPlanType
  }
}
    `;

/**
 * __useSwitchPlanPreviewQuery__
 *
 * To run a query within a React component, call `useSwitchPlanPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitchPlanPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchPlanPreviewQuery({
 *   variables: {
 *      changeType: // value for 'changeType'
 *      planType: // value for 'planType'
 *   },
 * });
 */
export function useSwitchPlanPreviewQuery(baseOptions: Apollo.QueryHookOptions<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables> & ({ variables: SwitchPlanPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>(SwitchPlanPreviewDocument, options);
      }
export function useSwitchPlanPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>(SwitchPlanPreviewDocument, options);
        }
// @ts-ignore
export function useSwitchPlanPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>;
export function useSwitchPlanPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SwitchPlanPreviewQuery | undefined, SwitchPlanPreviewQueryVariables>;
export function useSwitchPlanPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>(SwitchPlanPreviewDocument, options);
        }
export type SwitchPlanPreviewQueryHookResult = ReturnType<typeof useSwitchPlanPreviewQuery>;
export type SwitchPlanPreviewLazyQueryHookResult = ReturnType<typeof useSwitchPlanPreviewLazyQuery>;
export type SwitchPlanPreviewSuspenseQueryHookResult = ReturnType<typeof useSwitchPlanPreviewSuspenseQuery>;
export type SwitchPlanPreviewQueryResult = Apollo.QueryResult<SwitchPlanPreviewQuery, SwitchPlanPreviewQueryVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      ...UserFragment
    }
    show {
      ...ShowFragment
    }
    subscription {
      ...SubscriptionFragment
      ...SubscriptionDiscountFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ShowFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($firstName: String, $lastName: String, $email: String, $password: String, $isTester: Boolean, $bitratePreference: Int, $waveformPreference: String, $autoZoomPreference: Boolean, $autoCenterPreference: Boolean, $transcriptionLanguage: String, $activeProjectId: ID, $ga4ClientId: String, $librarySortOrder: LibrarySortOrder) {
  updateUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password, isTester: $isTester, bitratePreference: $bitratePreference, waveformPreference: $waveformPreference, autoZoomPreference: $autoZoomPreference, autoCenterPreference: $autoCenterPreference, transcriptionLanguage: $transcriptionLanguage, activeProjectId: $activeProjectId, ga4ClientId: $ga4ClientId, librarySortOrder: $librarySortOrder}
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      isTester: // value for 'isTester'
 *      bitratePreference: // value for 'bitratePreference'
 *      waveformPreference: // value for 'waveformPreference'
 *      autoZoomPreference: // value for 'autoZoomPreference'
 *      autoCenterPreference: // value for 'autoCenterPreference'
 *      transcriptionLanguage: // value for 'transcriptionLanguage'
 *      activeProjectId: // value for 'activeProjectId'
 *      ga4ClientId: // value for 'ga4ClientId'
 *      librarySortOrder: // value for 'librarySortOrder'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserCredentialsDocument = gql`
    mutation updateUserCredentials($firstName: String, $lastName: String, $email: String, $password: String, $currentPassword: String) {
  updateUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, password: $password}
    currentPassword: $currentPassword
  ) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserCredentialsMutationFn = Apollo.MutationFunction<UpdateUserCredentialsMutation, UpdateUserCredentialsMutationVariables>;

/**
 * __useUpdateUserCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateUserCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCredentialsMutation, { data, loading, error }] = useUpdateUserCredentialsMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useUpdateUserCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCredentialsMutation, UpdateUserCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCredentialsMutation, UpdateUserCredentialsMutationVariables>(UpdateUserCredentialsDocument, options);
      }
export type UpdateUserCredentialsMutationHookResult = ReturnType<typeof useUpdateUserCredentialsMutation>;
export type UpdateUserCredentialsMutationResult = Apollo.MutationResult<UpdateUserCredentialsMutation>;
export type UpdateUserCredentialsMutationOptions = Apollo.BaseMutationOptions<UpdateUserCredentialsMutation, UpdateUserCredentialsMutationVariables>;
export const AdminAssumeUserDocument = gql`
    query adminAssumeUser($userId: ID!) {
  adminAssumeUser(userId: $userId) {
    user {
      ...UserFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useAdminAssumeUserQuery__
 *
 * To run a query within a React component, call `useAdminAssumeUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAssumeUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAssumeUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminAssumeUserQuery(baseOptions: Apollo.QueryHookOptions<AdminAssumeUserQuery, AdminAssumeUserQueryVariables> & ({ variables: AdminAssumeUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>(AdminAssumeUserDocument, options);
      }
export function useAdminAssumeUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>(AdminAssumeUserDocument, options);
        }
// @ts-ignore
export function useAdminAssumeUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>): Apollo.UseSuspenseQueryResult<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>;
export function useAdminAssumeUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>): Apollo.UseSuspenseQueryResult<AdminAssumeUserQuery | undefined, AdminAssumeUserQueryVariables>;
export function useAdminAssumeUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>(AdminAssumeUserDocument, options);
        }
export type AdminAssumeUserQueryHookResult = ReturnType<typeof useAdminAssumeUserQuery>;
export type AdminAssumeUserLazyQueryHookResult = ReturnType<typeof useAdminAssumeUserLazyQuery>;
export type AdminAssumeUserSuspenseQueryHookResult = ReturnType<typeof useAdminAssumeUserSuspenseQuery>;
export type AdminAssumeUserQueryResult = Apollo.QueryResult<AdminAssumeUserQuery, AdminAssumeUserQueryVariables>;
export const AllJobsDocument = gql`
    query allJobs($limit: Int!, $hasFailed: Boolean, $isRunning: Boolean) {
  allJobs(limit: $limit, hasFailed: $hasFailed, isRunning: $isRunning) {
    createdAt
    id
    hash
    schema
    userId
    status
  }
}
    `;

/**
 * __useAllJobsQuery__
 *
 * To run a query within a React component, call `useAllJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      hasFailed: // value for 'hasFailed'
 *      isRunning: // value for 'isRunning'
 *   },
 * });
 */
export function useAllJobsQuery(baseOptions: Apollo.QueryHookOptions<AllJobsQuery, AllJobsQueryVariables> & ({ variables: AllJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
      }
export function useAllJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
        }
// @ts-ignore
export function useAllJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>): Apollo.UseSuspenseQueryResult<AllJobsQuery, AllJobsQueryVariables>;
export function useAllJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>): Apollo.UseSuspenseQueryResult<AllJobsQuery | undefined, AllJobsQueryVariables>;
export function useAllJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllJobsQuery, AllJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllJobsQuery, AllJobsQueryVariables>(AllJobsDocument, options);
        }
export type AllJobsQueryHookResult = ReturnType<typeof useAllJobsQuery>;
export type AllJobsLazyQueryHookResult = ReturnType<typeof useAllJobsLazyQuery>;
export type AllJobsSuspenseQueryHookResult = ReturnType<typeof useAllJobsSuspenseQuery>;
export type AllJobsQueryResult = Apollo.QueryResult<AllJobsQuery, AllJobsQueryVariables>;
export const JobLogsDocument = gql`
    query jobLogs($jobId: ID!) {
  jobLogs(jobId: $jobId) {
    id
    payload
    createdAt
  }
}
    `;

/**
 * __useJobLogsQuery__
 *
 * To run a query within a React component, call `useJobLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLogsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobLogsQuery(baseOptions: Apollo.QueryHookOptions<JobLogsQuery, JobLogsQueryVariables> & ({ variables: JobLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
      }
export function useJobLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
        }
// @ts-ignore
export function useJobLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>): Apollo.UseSuspenseQueryResult<JobLogsQuery, JobLogsQueryVariables>;
export function useJobLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>): Apollo.UseSuspenseQueryResult<JobLogsQuery | undefined, JobLogsQueryVariables>;
export function useJobLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLogsQuery, JobLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobLogsQuery, JobLogsQueryVariables>(JobLogsDocument, options);
        }
export type JobLogsQueryHookResult = ReturnType<typeof useJobLogsQuery>;
export type JobLogsLazyQueryHookResult = ReturnType<typeof useJobLogsLazyQuery>;
export type JobLogsSuspenseQueryHookResult = ReturnType<typeof useJobLogsSuspenseQuery>;
export type JobLogsQueryResult = Apollo.QueryResult<JobLogsQuery, JobLogsQueryVariables>;
export const RerunJobDocument = gql`
    mutation rerunJob($jobId: ID!) {
  rerunJob(jobId: $jobId) {
    id
  }
}
    `;
export type RerunJobMutationFn = Apollo.MutationFunction<RerunJobMutation, RerunJobMutationVariables>;

/**
 * __useRerunJobMutation__
 *
 * To run a mutation, you first call `useRerunJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunJobMutation, { data, loading, error }] = useRerunJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useRerunJobMutation(baseOptions?: Apollo.MutationHookOptions<RerunJobMutation, RerunJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunJobMutation, RerunJobMutationVariables>(RerunJobDocument, options);
      }
export type RerunJobMutationHookResult = ReturnType<typeof useRerunJobMutation>;
export type RerunJobMutationResult = Apollo.MutationResult<RerunJobMutation>;
export type RerunJobMutationOptions = Apollo.BaseMutationOptions<RerunJobMutation, RerunJobMutationVariables>;
export const AdminRerunJobDocument = gql`
    mutation adminRerunJob($jobId: ID!, $priority: Boolean) {
  adminRerunJob(jobId: $jobId, priority: $priority) {
    id
  }
}
    `;
export type AdminRerunJobMutationFn = Apollo.MutationFunction<AdminRerunJobMutation, AdminRerunJobMutationVariables>;

/**
 * __useAdminRerunJobMutation__
 *
 * To run a mutation, you first call `useAdminRerunJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRerunJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRerunJobMutation, { data, loading, error }] = useAdminRerunJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useAdminRerunJobMutation(baseOptions?: Apollo.MutationHookOptions<AdminRerunJobMutation, AdminRerunJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRerunJobMutation, AdminRerunJobMutationVariables>(AdminRerunJobDocument, options);
      }
export type AdminRerunJobMutationHookResult = ReturnType<typeof useAdminRerunJobMutation>;
export type AdminRerunJobMutationResult = Apollo.MutationResult<AdminRerunJobMutation>;
export type AdminRerunJobMutationOptions = Apollo.BaseMutationOptions<AdminRerunJobMutation, AdminRerunJobMutationVariables>;
export const AdminUsersDocument = gql`
    query adminUsers($email: String, $id: ID) {
  adminUsers(email: $email, id: $id) {
    id
    firstName
    lastName
    email
    address
    isTester
    activeProjectId
    hasAlreadyPaused
  }
}
    `;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
      }
export function useAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
// @ts-ignore
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUsersQuery | undefined, AdminUsersQueryVariables>;
export function useAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersSuspenseQueryHookResult = ReturnType<typeof useAdminUsersSuspenseQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export const SupportDashboardShowsDocument = gql`
    query supportDashboardShows($userId: ID) {
  shows(userId: $userId) {
    id
    description
    name
  }
}
    `;

/**
 * __useSupportDashboardShowsQuery__
 *
 * To run a query within a React component, call `useSupportDashboardShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportDashboardShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportDashboardShowsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSupportDashboardShowsQuery(baseOptions?: Apollo.QueryHookOptions<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>(SupportDashboardShowsDocument, options);
      }
export function useSupportDashboardShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>(SupportDashboardShowsDocument, options);
        }
// @ts-ignore
export function useSupportDashboardShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>): Apollo.UseSuspenseQueryResult<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>;
export function useSupportDashboardShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>): Apollo.UseSuspenseQueryResult<SupportDashboardShowsQuery | undefined, SupportDashboardShowsQueryVariables>;
export function useSupportDashboardShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>(SupportDashboardShowsDocument, options);
        }
export type SupportDashboardShowsQueryHookResult = ReturnType<typeof useSupportDashboardShowsQuery>;
export type SupportDashboardShowsLazyQueryHookResult = ReturnType<typeof useSupportDashboardShowsLazyQuery>;
export type SupportDashboardShowsSuspenseQueryHookResult = ReturnType<typeof useSupportDashboardShowsSuspenseQuery>;
export type SupportDashboardShowsQueryResult = Apollo.QueryResult<SupportDashboardShowsQuery, SupportDashboardShowsQueryVariables>;
export const RegenerateRssDocument = gql`
    mutation regenerateRss($showId: ID!) {
  regenerateRss(showId: $showId) {
    success
  }
}
    `;
export type RegenerateRssMutationFn = Apollo.MutationFunction<RegenerateRssMutation, RegenerateRssMutationVariables>;

/**
 * __useRegenerateRssMutation__
 *
 * To run a mutation, you first call `useRegenerateRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateRssMutation, { data, loading, error }] = useRegenerateRssMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useRegenerateRssMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateRssMutation, RegenerateRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateRssMutation, RegenerateRssMutationVariables>(RegenerateRssDocument, options);
      }
export type RegenerateRssMutationHookResult = ReturnType<typeof useRegenerateRssMutation>;
export type RegenerateRssMutationResult = Apollo.MutationResult<RegenerateRssMutation>;
export type RegenerateRssMutationOptions = Apollo.BaseMutationOptions<RegenerateRssMutation, RegenerateRssMutationVariables>;
export const AdminRecoverDeletedFileDocument = gql`
    mutation adminRecoverDeletedFile($fileId: ID!) {
  adminRecoverDeletedFile(fileId: $fileId) {
    success
  }
}
    `;
export type AdminRecoverDeletedFileMutationFn = Apollo.MutationFunction<AdminRecoverDeletedFileMutation, AdminRecoverDeletedFileMutationVariables>;

/**
 * __useAdminRecoverDeletedFileMutation__
 *
 * To run a mutation, you first call `useAdminRecoverDeletedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRecoverDeletedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRecoverDeletedFileMutation, { data, loading, error }] = useAdminRecoverDeletedFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAdminRecoverDeletedFileMutation(baseOptions?: Apollo.MutationHookOptions<AdminRecoverDeletedFileMutation, AdminRecoverDeletedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRecoverDeletedFileMutation, AdminRecoverDeletedFileMutationVariables>(AdminRecoverDeletedFileDocument, options);
      }
export type AdminRecoverDeletedFileMutationHookResult = ReturnType<typeof useAdminRecoverDeletedFileMutation>;
export type AdminRecoverDeletedFileMutationResult = Apollo.MutationResult<AdminRecoverDeletedFileMutation>;
export type AdminRecoverDeletedFileMutationOptions = Apollo.BaseMutationOptions<AdminRecoverDeletedFileMutation, AdminRecoverDeletedFileMutationVariables>;
export const RegenerateAllRssFeedsDocument = gql`
    mutation regenerateAllRssFeeds {
  regenerateAllRssFeeds {
    updated {
      showId
    }
    failed {
      showId
      error
    }
  }
}
    `;
export type RegenerateAllRssFeedsMutationFn = Apollo.MutationFunction<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>;

/**
 * __useRegenerateAllRssFeedsMutation__
 *
 * To run a mutation, you first call `useRegenerateAllRssFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAllRssFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAllRssFeedsMutation, { data, loading, error }] = useRegenerateAllRssFeedsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateAllRssFeedsMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>(RegenerateAllRssFeedsDocument, options);
      }
export type RegenerateAllRssFeedsMutationHookResult = ReturnType<typeof useRegenerateAllRssFeedsMutation>;
export type RegenerateAllRssFeedsMutationResult = Apollo.MutationResult<RegenerateAllRssFeedsMutation>;
export type RegenerateAllRssFeedsMutationOptions = Apollo.BaseMutationOptions<RegenerateAllRssFeedsMutation, RegenerateAllRssFeedsMutationVariables>;
export const AdminHostedShowsDocument = gql`
    query adminHostedShows($limit: Int!, $offset: Int!, $name: String, $userId: ID) {
  adminHostedShows(limit: $limit, offset: $offset, name: $name, userId: $userId) {
    shows {
      id
      name
      userId
      rssFeedUrl
      hostingSuspended
    }
    total
  }
}
    `;

/**
 * __useAdminHostedShowsQuery__
 *
 * To run a query within a React component, call `useAdminHostedShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminHostedShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminHostedShowsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminHostedShowsQuery(baseOptions: Apollo.QueryHookOptions<AdminHostedShowsQuery, AdminHostedShowsQueryVariables> & ({ variables: AdminHostedShowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>(AdminHostedShowsDocument, options);
      }
export function useAdminHostedShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>(AdminHostedShowsDocument, options);
        }
// @ts-ignore
export function useAdminHostedShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>;
export function useAdminHostedShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>): Apollo.UseSuspenseQueryResult<AdminHostedShowsQuery | undefined, AdminHostedShowsQueryVariables>;
export function useAdminHostedShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>(AdminHostedShowsDocument, options);
        }
export type AdminHostedShowsQueryHookResult = ReturnType<typeof useAdminHostedShowsQuery>;
export type AdminHostedShowsLazyQueryHookResult = ReturnType<typeof useAdminHostedShowsLazyQuery>;
export type AdminHostedShowsSuspenseQueryHookResult = ReturnType<typeof useAdminHostedShowsSuspenseQuery>;
export type AdminHostedShowsQueryResult = Apollo.QueryResult<AdminHostedShowsQuery, AdminHostedShowsQueryVariables>;
export const AdminHostingLimitOffendersDocument = gql`
    query adminHostingLimitOffenders {
  adminHostingLimitOffenders {
    userId
    hostingLimit
    prevMonth1
    prevMonth2
    prevMonth3
  }
}
    `;

/**
 * __useAdminHostingLimitOffendersQuery__
 *
 * To run a query within a React component, call `useAdminHostingLimitOffendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminHostingLimitOffendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminHostingLimitOffendersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminHostingLimitOffendersQuery(baseOptions?: Apollo.QueryHookOptions<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>(AdminHostingLimitOffendersDocument, options);
      }
export function useAdminHostingLimitOffendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>(AdminHostingLimitOffendersDocument, options);
        }
// @ts-ignore
export function useAdminHostingLimitOffendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>;
export function useAdminHostingLimitOffendersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>): Apollo.UseSuspenseQueryResult<AdminHostingLimitOffendersQuery | undefined, AdminHostingLimitOffendersQueryVariables>;
export function useAdminHostingLimitOffendersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>(AdminHostingLimitOffendersDocument, options);
        }
export type AdminHostingLimitOffendersQueryHookResult = ReturnType<typeof useAdminHostingLimitOffendersQuery>;
export type AdminHostingLimitOffendersLazyQueryHookResult = ReturnType<typeof useAdminHostingLimitOffendersLazyQuery>;
export type AdminHostingLimitOffendersSuspenseQueryHookResult = ReturnType<typeof useAdminHostingLimitOffendersSuspenseQuery>;
export type AdminHostingLimitOffendersQueryResult = Apollo.QueryResult<AdminHostingLimitOffendersQuery, AdminHostingLimitOffendersQueryVariables>;
export const AdminSuspendHostingDocument = gql`
    mutation adminSuspendHosting($userId: ID!, $suspensionType: String) {
  adminSuspendHosting(userId: $userId, suspensionType: $suspensionType) {
    success
  }
}
    `;
export type AdminSuspendHostingMutationFn = Apollo.MutationFunction<AdminSuspendHostingMutation, AdminSuspendHostingMutationVariables>;

/**
 * __useAdminSuspendHostingMutation__
 *
 * To run a mutation, you first call `useAdminSuspendHostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSuspendHostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSuspendHostingMutation, { data, loading, error }] = useAdminSuspendHostingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      suspensionType: // value for 'suspensionType'
 *   },
 * });
 */
export function useAdminSuspendHostingMutation(baseOptions?: Apollo.MutationHookOptions<AdminSuspendHostingMutation, AdminSuspendHostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSuspendHostingMutation, AdminSuspendHostingMutationVariables>(AdminSuspendHostingDocument, options);
      }
export type AdminSuspendHostingMutationHookResult = ReturnType<typeof useAdminSuspendHostingMutation>;
export type AdminSuspendHostingMutationResult = Apollo.MutationResult<AdminSuspendHostingMutation>;
export type AdminSuspendHostingMutationOptions = Apollo.BaseMutationOptions<AdminSuspendHostingMutation, AdminSuspendHostingMutationVariables>;
export const AdminUserFilesDocument = gql`
    query adminUserFiles($userId: ID!, $name: String, $id: ID) {
  adminUserFiles(userId: $userId, name: $name, id: $id) {
    id
    name
    bucket
    createdAt
    deletedAt
    audioJobId
    jobStatus
  }
}
    `;

/**
 * __useAdminUserFilesQuery__
 *
 * To run a query within a React component, call `useAdminUserFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserFilesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserFilesQuery(baseOptions: Apollo.QueryHookOptions<AdminUserFilesQuery, AdminUserFilesQueryVariables> & ({ variables: AdminUserFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserFilesQuery, AdminUserFilesQueryVariables>(AdminUserFilesDocument, options);
      }
export function useAdminUserFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserFilesQuery, AdminUserFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserFilesQuery, AdminUserFilesQueryVariables>(AdminUserFilesDocument, options);
        }
// @ts-ignore
export function useAdminUserFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUserFilesQuery, AdminUserFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUserFilesQuery, AdminUserFilesQueryVariables>;
export function useAdminUserFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUserFilesQuery, AdminUserFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AdminUserFilesQuery | undefined, AdminUserFilesQueryVariables>;
export function useAdminUserFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminUserFilesQuery, AdminUserFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUserFilesQuery, AdminUserFilesQueryVariables>(AdminUserFilesDocument, options);
        }
export type AdminUserFilesQueryHookResult = ReturnType<typeof useAdminUserFilesQuery>;
export type AdminUserFilesLazyQueryHookResult = ReturnType<typeof useAdminUserFilesLazyQuery>;
export type AdminUserFilesSuspenseQueryHookResult = ReturnType<typeof useAdminUserFilesSuspenseQuery>;
export type AdminUserFilesQueryResult = Apollo.QueryResult<AdminUserFilesQuery, AdminUserFilesQueryVariables>;
export const AdminUpdateContentDocument = gql`
    mutation adminUpdateContent($section: String!, $content: JSON!) {
  adminUpdateContent(section: $section, content: $content) {
    success
  }
}
    `;
export type AdminUpdateContentMutationFn = Apollo.MutationFunction<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>;

/**
 * __useAdminUpdateContentMutation__
 *
 * To run a mutation, you first call `useAdminUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateContentMutation, { data, loading, error }] = useAdminUpdateContentMutation({
 *   variables: {
 *      section: // value for 'section'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useAdminUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>(AdminUpdateContentDocument, options);
      }
export type AdminUpdateContentMutationHookResult = ReturnType<typeof useAdminUpdateContentMutation>;
export type AdminUpdateContentMutationResult = Apollo.MutationResult<AdminUpdateContentMutation>;
export type AdminUpdateContentMutationOptions = Apollo.BaseMutationOptions<AdminUpdateContentMutation, AdminUpdateContentMutationVariables>;
export const SignupPageContentDocument = gql`
    query signupPageContent {
  signupPageContent {
    mainTitle
    sidebarContent
  }
}
    `;

/**
 * __useSignupPageContentQuery__
 *
 * To run a query within a React component, call `useSignupPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupPageContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignupPageContentQuery(baseOptions?: Apollo.QueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
      }
export function useSignupPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
        }
// @ts-ignore
export function useSignupPageContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>): Apollo.UseSuspenseQueryResult<SignupPageContentQuery, SignupPageContentQueryVariables>;
export function useSignupPageContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>): Apollo.UseSuspenseQueryResult<SignupPageContentQuery | undefined, SignupPageContentQueryVariables>;
export function useSignupPageContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignupPageContentQuery, SignupPageContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignupPageContentQuery, SignupPageContentQueryVariables>(SignupPageContentDocument, options);
        }
export type SignupPageContentQueryHookResult = ReturnType<typeof useSignupPageContentQuery>;
export type SignupPageContentLazyQueryHookResult = ReturnType<typeof useSignupPageContentLazyQuery>;
export type SignupPageContentSuspenseQueryHookResult = ReturnType<typeof useSignupPageContentSuspenseQuery>;
export type SignupPageContentQueryResult = Apollo.QueryResult<SignupPageContentQuery, SignupPageContentQueryVariables>;
export const AdminUpdateUserDocument = gql`
    mutation adminUpdateUser($userId: ID!, $input: UserInput) {
  adminUpdateUser(userId: $userId, input: $input) {
    id
    firstName
    lastName
    email
    isTester
  }
}
    `;
export type AdminUpdateUserMutationFn = Apollo.MutationFunction<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;

/**
 * __useAdminUpdateUserMutation__
 *
 * To run a mutation, you first call `useAdminUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateUserMutation, { data, loading, error }] = useAdminUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>(AdminUpdateUserDocument, options);
      }
export type AdminUpdateUserMutationHookResult = ReturnType<typeof useAdminUpdateUserMutation>;
export type AdminUpdateUserMutationResult = Apollo.MutationResult<AdminUpdateUserMutation>;
export type AdminUpdateUserMutationOptions = Apollo.BaseMutationOptions<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;
export const AdminSetHasAlreadyPausedDocument = gql`
    mutation adminSetHasAlreadyPaused($userId: ID!, $hasAlreadyPaused: Boolean!) {
  adminSetHasAlreadyPaused(userId: $userId, hasAlreadyPaused: $hasAlreadyPaused)
}
    `;
export type AdminSetHasAlreadyPausedMutationFn = Apollo.MutationFunction<AdminSetHasAlreadyPausedMutation, AdminSetHasAlreadyPausedMutationVariables>;

/**
 * __useAdminSetHasAlreadyPausedMutation__
 *
 * To run a mutation, you first call `useAdminSetHasAlreadyPausedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetHasAlreadyPausedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetHasAlreadyPausedMutation, { data, loading, error }] = useAdminSetHasAlreadyPausedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      hasAlreadyPaused: // value for 'hasAlreadyPaused'
 *   },
 * });
 */
export function useAdminSetHasAlreadyPausedMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetHasAlreadyPausedMutation, AdminSetHasAlreadyPausedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetHasAlreadyPausedMutation, AdminSetHasAlreadyPausedMutationVariables>(AdminSetHasAlreadyPausedDocument, options);
      }
export type AdminSetHasAlreadyPausedMutationHookResult = ReturnType<typeof useAdminSetHasAlreadyPausedMutation>;
export type AdminSetHasAlreadyPausedMutationResult = Apollo.MutationResult<AdminSetHasAlreadyPausedMutation>;
export type AdminSetHasAlreadyPausedMutationOptions = Apollo.BaseMutationOptions<AdminSetHasAlreadyPausedMutation, AdminSetHasAlreadyPausedMutationVariables>;
export const AdminRevokeSessionsDocument = gql`
    mutation adminRevokeSessions($userId: ID!) {
  adminRevokeSessions(userId: $userId)
}
    `;
export type AdminRevokeSessionsMutationFn = Apollo.MutationFunction<AdminRevokeSessionsMutation, AdminRevokeSessionsMutationVariables>;

/**
 * __useAdminRevokeSessionsMutation__
 *
 * To run a mutation, you first call `useAdminRevokeSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRevokeSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRevokeSessionsMutation, { data, loading, error }] = useAdminRevokeSessionsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminRevokeSessionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminRevokeSessionsMutation, AdminRevokeSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRevokeSessionsMutation, AdminRevokeSessionsMutationVariables>(AdminRevokeSessionsDocument, options);
      }
export type AdminRevokeSessionsMutationHookResult = ReturnType<typeof useAdminRevokeSessionsMutation>;
export type AdminRevokeSessionsMutationResult = Apollo.MutationResult<AdminRevokeSessionsMutation>;
export type AdminRevokeSessionsMutationOptions = Apollo.BaseMutationOptions<AdminRevokeSessionsMutation, AdminRevokeSessionsMutationVariables>;
export const AdminAddSubscriptionToUserDocument = gql`
    mutation adminAddSubscriptionToUser($userId: ID!, $subscriptionId: ID!, $customerId: ID!) {
  adminAddSubscriptionToUser(
    userId: $userId
    subscriptionId: $subscriptionId
    customerId: $customerId
  )
}
    `;
export type AdminAddSubscriptionToUserMutationFn = Apollo.MutationFunction<AdminAddSubscriptionToUserMutation, AdminAddSubscriptionToUserMutationVariables>;

/**
 * __useAdminAddSubscriptionToUserMutation__
 *
 * To run a mutation, you first call `useAdminAddSubscriptionToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddSubscriptionToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddSubscriptionToUserMutation, { data, loading, error }] = useAdminAddSubscriptionToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      subscriptionId: // value for 'subscriptionId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useAdminAddSubscriptionToUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddSubscriptionToUserMutation, AdminAddSubscriptionToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddSubscriptionToUserMutation, AdminAddSubscriptionToUserMutationVariables>(AdminAddSubscriptionToUserDocument, options);
      }
export type AdminAddSubscriptionToUserMutationHookResult = ReturnType<typeof useAdminAddSubscriptionToUserMutation>;
export type AdminAddSubscriptionToUserMutationResult = Apollo.MutationResult<AdminAddSubscriptionToUserMutation>;
export type AdminAddSubscriptionToUserMutationOptions = Apollo.BaseMutationOptions<AdminAddSubscriptionToUserMutation, AdminAddSubscriptionToUserMutationVariables>;
export const AdminDeleteAllUserDataDocument = gql`
    mutation adminDeleteAllUserData($userId: ID!) {
  adminDeleteAllUserData(userId: $userId)
}
    `;
export type AdminDeleteAllUserDataMutationFn = Apollo.MutationFunction<AdminDeleteAllUserDataMutation, AdminDeleteAllUserDataMutationVariables>;

/**
 * __useAdminDeleteAllUserDataMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAllUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAllUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAllUserDataMutation, { data, loading, error }] = useAdminDeleteAllUserDataMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminDeleteAllUserDataMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAllUserDataMutation, AdminDeleteAllUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAllUserDataMutation, AdminDeleteAllUserDataMutationVariables>(AdminDeleteAllUserDataDocument, options);
      }
export type AdminDeleteAllUserDataMutationHookResult = ReturnType<typeof useAdminDeleteAllUserDataMutation>;
export type AdminDeleteAllUserDataMutationResult = Apollo.MutationResult<AdminDeleteAllUserDataMutation>;
export type AdminDeleteAllUserDataMutationOptions = Apollo.BaseMutationOptions<AdminDeleteAllUserDataMutation, AdminDeleteAllUserDataMutationVariables>;
export const EpisodeMetadataDocument = gql`
    query episodeMetadata($id: ID!) {
  episode(id: $id) {
    id
    metaData {
      ...MetaData
    }
  }
}
    ${MetaDataFragmentDoc}`;

/**
 * __useEpisodeMetadataQuery__
 *
 * To run a query within a React component, call `useEpisodeMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEpisodeMetadataQuery(baseOptions: Apollo.QueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables> & ({ variables: EpisodeMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
      }
export function useEpisodeMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
        }
// @ts-ignore
export function useEpisodeMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>;
export function useEpisodeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeMetadataQuery | undefined, EpisodeMetadataQueryVariables>;
export function useEpisodeMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>(EpisodeMetadataDocument, options);
        }
export type EpisodeMetadataQueryHookResult = ReturnType<typeof useEpisodeMetadataQuery>;
export type EpisodeMetadataLazyQueryHookResult = ReturnType<typeof useEpisodeMetadataLazyQuery>;
export type EpisodeMetadataSuspenseQueryHookResult = ReturnType<typeof useEpisodeMetadataSuspenseQuery>;
export type EpisodeMetadataQueryResult = Apollo.QueryResult<EpisodeMetadataQuery, EpisodeMetadataQueryVariables>;
export const UpdateEpisodeMetadataDocument = gql`
    mutation updateEpisodeMetadata($id: ID!, $metaData: EpisodeMetaDataInput, $version: Int) {
  episode: updateEpisode(id: $id, metaData: $metaData, version: $version) {
    id
    metaData {
      name
      summary
      description
      episodeNumber
      seasonNumber
      hostNames
      isExplicit
      type
      location {
        title
        country
        type
      }
      __typename
    }
    version
    videoMode
  }
}
    `;
export type UpdateEpisodeMetadataMutationFn = Apollo.MutationFunction<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>;

/**
 * __useUpdateEpisodeMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeMetadataMutation, { data, loading, error }] = useUpdateEpisodeMetadataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metaData: // value for 'metaData'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUpdateEpisodeMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>(UpdateEpisodeMetadataDocument, options);
      }
export type UpdateEpisodeMetadataMutationHookResult = ReturnType<typeof useUpdateEpisodeMetadataMutation>;
export type UpdateEpisodeMetadataMutationResult = Apollo.MutationResult<UpdateEpisodeMetadataMutation>;
export type UpdateEpisodeMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeMetadataMutation, UpdateEpisodeMetadataMutationVariables>;
export const EditGeneratedAssetsWarningDocument = gql`
    query EditGeneratedAssetsWarning($episodeId: ID!, $version: Int, $includeSocialClips: Boolean!) {
  episode(id: $episodeId, version: $version) {
    id
    isArchivedVersion
    file {
      id
      videoJob {
        id
        status
      }
      transcriptionJob {
        id
        status
      }
    }
  }
  episodeSocialClips(episodeId: $episodeId) @include(if: $includeSocialClips) {
    id
    state
    isGeneratedFileStale
    file {
      id
    }
  }
}
    `;

/**
 * __useEditGeneratedAssetsWarningQuery__
 *
 * To run a query within a React component, call `useEditGeneratedAssetsWarningQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditGeneratedAssetsWarningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditGeneratedAssetsWarningQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      version: // value for 'version'
 *      includeSocialClips: // value for 'includeSocialClips'
 *   },
 * });
 */
export function useEditGeneratedAssetsWarningQuery(baseOptions: Apollo.QueryHookOptions<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables> & ({ variables: EditGeneratedAssetsWarningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>(EditGeneratedAssetsWarningDocument, options);
      }
export function useEditGeneratedAssetsWarningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>(EditGeneratedAssetsWarningDocument, options);
        }
// @ts-ignore
export function useEditGeneratedAssetsWarningSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>): Apollo.UseSuspenseQueryResult<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>;
export function useEditGeneratedAssetsWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>): Apollo.UseSuspenseQueryResult<EditGeneratedAssetsWarningQuery | undefined, EditGeneratedAssetsWarningQueryVariables>;
export function useEditGeneratedAssetsWarningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>(EditGeneratedAssetsWarningDocument, options);
        }
export type EditGeneratedAssetsWarningQueryHookResult = ReturnType<typeof useEditGeneratedAssetsWarningQuery>;
export type EditGeneratedAssetsWarningLazyQueryHookResult = ReturnType<typeof useEditGeneratedAssetsWarningLazyQuery>;
export type EditGeneratedAssetsWarningSuspenseQueryHookResult = ReturnType<typeof useEditGeneratedAssetsWarningSuspenseQuery>;
export type EditGeneratedAssetsWarningQueryResult = Apollo.QueryResult<EditGeneratedAssetsWarningQuery, EditGeneratedAssetsWarningQueryVariables>;
export const DeleteRecordingDocument = gql`
    mutation deleteRecording($id: ID!) {
  deleteRecording(id: $id)
}
    `;
export type DeleteRecordingMutationFn = Apollo.MutationFunction<DeleteRecordingMutation, DeleteRecordingMutationVariables>;

/**
 * __useDeleteRecordingMutation__
 *
 * To run a mutation, you first call `useDeleteRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecordingMutation, { data, loading, error }] = useDeleteRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecordingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecordingMutation, DeleteRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecordingMutation, DeleteRecordingMutationVariables>(DeleteRecordingDocument, options);
      }
export type DeleteRecordingMutationHookResult = ReturnType<typeof useDeleteRecordingMutation>;
export type DeleteRecordingMutationResult = Apollo.MutationResult<DeleteRecordingMutation>;
export type DeleteRecordingMutationOptions = Apollo.BaseMutationOptions<DeleteRecordingMutation, DeleteRecordingMutationVariables>;
export const PauseRecordingDocument = gql`
    mutation pauseRecording($id: ID!, $paused: Boolean!) {
  pauseRecording(id: $id, paused: $paused)
}
    `;
export type PauseRecordingMutationFn = Apollo.MutationFunction<PauseRecordingMutation, PauseRecordingMutationVariables>;

/**
 * __usePauseRecordingMutation__
 *
 * To run a mutation, you first call `usePauseRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseRecordingMutation, { data, loading, error }] = usePauseRecordingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function usePauseRecordingMutation(baseOptions?: Apollo.MutationHookOptions<PauseRecordingMutation, PauseRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseRecordingMutation, PauseRecordingMutationVariables>(PauseRecordingDocument, options);
      }
export type PauseRecordingMutationHookResult = ReturnType<typeof usePauseRecordingMutation>;
export type PauseRecordingMutationResult = Apollo.MutationResult<PauseRecordingMutation>;
export type PauseRecordingMutationOptions = Apollo.BaseMutationOptions<PauseRecordingMutation, PauseRecordingMutationVariables>;
export const CallDocument = gql`
    query call($id: ID!) {
  call(id: $id) {
    job {
      status
      schema
    }
  }
}
    `;

/**
 * __useCallQuery__
 *
 * To run a query within a React component, call `useCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCallQuery(baseOptions: Apollo.QueryHookOptions<CallQuery, CallQueryVariables> & ({ variables: CallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallQuery, CallQueryVariables>(CallDocument, options);
      }
export function useCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallQuery, CallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallQuery, CallQueryVariables>(CallDocument, options);
        }
// @ts-ignore
export function useCallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallQuery, CallQueryVariables>): Apollo.UseSuspenseQueryResult<CallQuery, CallQueryVariables>;
export function useCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallQuery, CallQueryVariables>): Apollo.UseSuspenseQueryResult<CallQuery | undefined, CallQueryVariables>;
export function useCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallQuery, CallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallQuery, CallQueryVariables>(CallDocument, options);
        }
export type CallQueryHookResult = ReturnType<typeof useCallQuery>;
export type CallLazyQueryHookResult = ReturnType<typeof useCallLazyQuery>;
export type CallSuspenseQueryHookResult = ReturnType<typeof useCallSuspenseQuery>;
export type CallQueryResult = Apollo.QueryResult<CallQuery, CallQueryVariables>;
export const CreateChunkUploadUrlDocument = gql`
    mutation createChunkUploadUrl($callId: ID!, $instanceId: String!, $timestamp: Date!, $participantToken: String) {
  createChunkUploadUrl(
    callId: $callId
    instanceId: $instanceId
    timestamp: $timestamp
    participantToken: $participantToken
  ) {
    url
  }
}
    `;
export type CreateChunkUploadUrlMutationFn = Apollo.MutationFunction<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>;

/**
 * __useCreateChunkUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateChunkUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChunkUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChunkUploadUrlMutation, { data, loading, error }] = useCreateChunkUploadUrlMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *      timestamp: // value for 'timestamp'
 *      participantToken: // value for 'participantToken'
 *   },
 * });
 */
export function useCreateChunkUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>(CreateChunkUploadUrlDocument, options);
      }
export type CreateChunkUploadUrlMutationHookResult = ReturnType<typeof useCreateChunkUploadUrlMutation>;
export type CreateChunkUploadUrlMutationResult = Apollo.MutationResult<CreateChunkUploadUrlMutation>;
export type CreateChunkUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateChunkUploadUrlMutation, CreateChunkUploadUrlMutationVariables>;
export const ConcatenateChunksDocument = gql`
    mutation concatenateChunks($callId: ID!, $instanceId: String!) {
  concatenateChunks(callId: $callId, instanceId: $instanceId)
}
    `;
export type ConcatenateChunksMutationFn = Apollo.MutationFunction<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>;

/**
 * __useConcatenateChunksMutation__
 *
 * To run a mutation, you first call `useConcatenateChunksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConcatenateChunksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [concatenateChunksMutation, { data, loading, error }] = useConcatenateChunksMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useConcatenateChunksMutation(baseOptions?: Apollo.MutationHookOptions<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>(ConcatenateChunksDocument, options);
      }
export type ConcatenateChunksMutationHookResult = ReturnType<typeof useConcatenateChunksMutation>;
export type ConcatenateChunksMutationResult = Apollo.MutationResult<ConcatenateChunksMutation>;
export type ConcatenateChunksMutationOptions = Apollo.BaseMutationOptions<ConcatenateChunksMutation, ConcatenateChunksMutationVariables>;
export const CreateRecordingDocument = gql`
    mutation createRecording($callId: ID!, $duration: Float!, $instanceId: String, $fileName: String) {
  createRecording(
    callId: $callId
    duration: $duration
    instanceId: $instanceId
    fileName: $fileName
  ) {
    fileId
  }
}
    `;
export type CreateRecordingMutationFn = Apollo.MutationFunction<CreateRecordingMutation, CreateRecordingMutationVariables>;

/**
 * __useCreateRecordingMutation__
 *
 * To run a mutation, you first call `useCreateRecordingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingMutation, { data, loading, error }] = useCreateRecordingMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      duration: // value for 'duration'
 *      instanceId: // value for 'instanceId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCreateRecordingMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecordingMutation, CreateRecordingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecordingMutation, CreateRecordingMutationVariables>(CreateRecordingDocument, options);
      }
export type CreateRecordingMutationHookResult = ReturnType<typeof useCreateRecordingMutation>;
export type CreateRecordingMutationResult = Apollo.MutationResult<CreateRecordingMutation>;
export type CreateRecordingMutationOptions = Apollo.BaseMutationOptions<CreateRecordingMutation, CreateRecordingMutationVariables>;
export const CreateRecordingUploadUrlDocument = gql`
    mutation createRecordingUploadUrl($callId: ID!, $instanceId: String!) {
  createRecordingUploadUrl(callId: $callId, instanceId: $instanceId) {
    url
  }
}
    `;
export type CreateRecordingUploadUrlMutationFn = Apollo.MutationFunction<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>;

/**
 * __useCreateRecordingUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateRecordingUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecordingUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecordingUploadUrlMutation, { data, loading, error }] = useCreateRecordingUploadUrlMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useCreateRecordingUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>(CreateRecordingUploadUrlDocument, options);
      }
export type CreateRecordingUploadUrlMutationHookResult = ReturnType<typeof useCreateRecordingUploadUrlMutation>;
export type CreateRecordingUploadUrlMutationResult = Apollo.MutationResult<CreateRecordingUploadUrlMutation>;
export type CreateRecordingUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateRecordingUploadUrlMutation, CreateRecordingUploadUrlMutationVariables>;
export const AddCallRecordingTrackDocument = gql`
    mutation addCallRecordingTrack($callId: ID!, $instanceId: String!, $startTime: Date!, $participantToken: String) {
  addCallRecordingTrack(
    callId: $callId
    instanceId: $instanceId
    startTime: $startTime
    participantToken: $participantToken
  )
}
    `;
export type AddCallRecordingTrackMutationFn = Apollo.MutationFunction<AddCallRecordingTrackMutation, AddCallRecordingTrackMutationVariables>;

/**
 * __useAddCallRecordingTrackMutation__
 *
 * To run a mutation, you first call `useAddCallRecordingTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallRecordingTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallRecordingTrackMutation, { data, loading, error }] = useAddCallRecordingTrackMutation({
 *   variables: {
 *      callId: // value for 'callId'
 *      instanceId: // value for 'instanceId'
 *      startTime: // value for 'startTime'
 *      participantToken: // value for 'participantToken'
 *   },
 * });
 */
export function useAddCallRecordingTrackMutation(baseOptions?: Apollo.MutationHookOptions<AddCallRecordingTrackMutation, AddCallRecordingTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallRecordingTrackMutation, AddCallRecordingTrackMutationVariables>(AddCallRecordingTrackDocument, options);
      }
export type AddCallRecordingTrackMutationHookResult = ReturnType<typeof useAddCallRecordingTrackMutation>;
export type AddCallRecordingTrackMutationResult = Apollo.MutationResult<AddCallRecordingTrackMutation>;
export type AddCallRecordingTrackMutationOptions = Apollo.BaseMutationOptions<AddCallRecordingTrackMutation, AddCallRecordingTrackMutationVariables>;
export const ProjectFilesDocument = gql`
    query projectFiles($name: String, $offset: Int!, $limit: Int!, $tags: String, $type: String) {
  projectFiles: getProjectFiles(
    name: $name
    offset: $offset
    limit: $limit
    tags: $tags
    type: $type
  ) {
    total
    files {
      id
      name
      type
      tags
      bucket
      codecInformation {
        format {
          duration
        }
      }
      users {
        userFile
      }
      audioJob {
        id
        status
        schema
        progress
        createdAt
        hash
        userId
      }
      imageJob {
        id
        status
        schema
        progress
        createdAt
        hash
        userId
      }
      createdAt
    }
  }
}
    `;

/**
 * __useProjectFilesQuery__
 *
 * To run a query within a React component, call `useProjectFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      tags: // value for 'tags'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProjectFilesQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables> & ({ variables: ProjectFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
      }
export function useProjectFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
        }
// @ts-ignore
export function useProjectFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectFilesQuery, ProjectFilesQueryVariables>;
export function useProjectFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectFilesQuery | undefined, ProjectFilesQueryVariables>;
export function useProjectFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesQuery, ProjectFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectFilesQuery, ProjectFilesQueryVariables>(ProjectFilesDocument, options);
        }
export type ProjectFilesQueryHookResult = ReturnType<typeof useProjectFilesQuery>;
export type ProjectFilesLazyQueryHookResult = ReturnType<typeof useProjectFilesLazyQuery>;
export type ProjectFilesSuspenseQueryHookResult = ReturnType<typeof useProjectFilesSuspenseQuery>;
export type ProjectFilesQueryResult = Apollo.QueryResult<ProjectFilesQuery, ProjectFilesQueryVariables>;
export const ProjectFilesAndFoldersDocument = gql`
    query projectFilesAndFolders($name: String, $folderId: ID, $tags: String, $type: String, $offset: Int!, $limit: Int, $sort: String) {
  projectFiles: getProjectFilesAndFolders(
    name: $name
    folderId: $folderId
    tags: $tags
    type: $type
    offset: $offset
    limit: $limit
    sort: $sort
  ) {
    total
    files {
      id
      fileId
      folderId
      name
      audioJob {
        status
      }
      imageJob {
        status
      }
      bucket
      codecInformation {
        format {
          duration
        }
      }
      tags
      bookmarked
      createdAt
      userId
      fileCount
      type
    }
  }
}
    `;

/**
 * __useProjectFilesAndFoldersQuery__
 *
 * To run a query within a React component, call `useProjectFilesAndFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFilesAndFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFilesAndFoldersQuery({
 *   variables: {
 *      name: // value for 'name'
 *      folderId: // value for 'folderId'
 *      tags: // value for 'tags'
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProjectFilesAndFoldersQuery(baseOptions: Apollo.QueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables> & ({ variables: ProjectFilesAndFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
      }
export function useProjectFilesAndFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
        }
// @ts-ignore
export function useProjectFilesAndFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>;
export function useProjectFilesAndFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ProjectFilesAndFoldersQuery | undefined, ProjectFilesAndFoldersQueryVariables>;
export function useProjectFilesAndFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>(ProjectFilesAndFoldersDocument, options);
        }
export type ProjectFilesAndFoldersQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersQuery>;
export type ProjectFilesAndFoldersLazyQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersLazyQuery>;
export type ProjectFilesAndFoldersSuspenseQueryHookResult = ReturnType<typeof useProjectFilesAndFoldersSuspenseQuery>;
export type ProjectFilesAndFoldersQueryResult = Apollo.QueryResult<ProjectFilesAndFoldersQuery, ProjectFilesAndFoldersQueryVariables>;
export const GetFoldersDocument = gql`
    query getFolders {
  getFolders {
    id
    name
  }
}
    `;

/**
 * __useGetFoldersQuery__
 *
 * To run a query within a React component, call `useGetFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
      }
export function useGetFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
        }
// @ts-ignore
export function useGetFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetFoldersQuery, GetFoldersQueryVariables>;
export function useGetFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetFoldersQuery | undefined, GetFoldersQueryVariables>;
export function useGetFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFoldersQuery, GetFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFoldersQuery, GetFoldersQueryVariables>(GetFoldersDocument, options);
        }
export type GetFoldersQueryHookResult = ReturnType<typeof useGetFoldersQuery>;
export type GetFoldersLazyQueryHookResult = ReturnType<typeof useGetFoldersLazyQuery>;
export type GetFoldersSuspenseQueryHookResult = ReturnType<typeof useGetFoldersSuspenseQuery>;
export type GetFoldersQueryResult = Apollo.QueryResult<GetFoldersQuery, GetFoldersQueryVariables>;
export const CreateFolderDocument = gql`
    mutation createFolder($name: String!) {
  createFolder(name: $name) {
    id
    name
  }
}
    `;
export type CreateFolderMutationFn = Apollo.MutationFunction<CreateFolderMutation, CreateFolderMutationVariables>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateFolderMutation, CreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFolderMutation, CreateFolderMutationVariables>(CreateFolderDocument, options);
      }
export type CreateFolderMutationHookResult = ReturnType<typeof useCreateFolderMutation>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<CreateFolderMutation, CreateFolderMutationVariables>;
export const UpdateFolderDocument = gql`
    mutation updateFolder($id: ID!, $name: String!) {
  updateFolder(id: $id, name: $name)
}
    `;
export type UpdateFolderMutationFn = Apollo.MutationFunction<UpdateFolderMutation, UpdateFolderMutationVariables>;

/**
 * __useUpdateFolderMutation__
 *
 * To run a mutation, you first call `useUpdateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFolderMutation, { data, loading, error }] = useUpdateFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFolderMutation, UpdateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFolderMutation, UpdateFolderMutationVariables>(UpdateFolderDocument, options);
      }
export type UpdateFolderMutationHookResult = ReturnType<typeof useUpdateFolderMutation>;
export type UpdateFolderMutationResult = Apollo.MutationResult<UpdateFolderMutation>;
export type UpdateFolderMutationOptions = Apollo.BaseMutationOptions<UpdateFolderMutation, UpdateFolderMutationVariables>;
export const DeleteFolderDocument = gql`
    mutation deleteFolder($id: ID!) {
  deleteFolder(id: $id)
}
    `;
export type DeleteFolderMutationFn = Apollo.MutationFunction<DeleteFolderMutation, DeleteFolderMutationVariables>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFolderMutation, DeleteFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFolderMutation, DeleteFolderMutationVariables>(DeleteFolderDocument, options);
      }
export type DeleteFolderMutationHookResult = ReturnType<typeof useDeleteFolderMutation>;
export type DeleteFolderMutationResult = Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<DeleteFolderMutation, DeleteFolderMutationVariables>;
export const AddFileToFolderDocument = gql`
    mutation addFileToFolder($fileId: ID!, $folderId: ID!) {
  addFileToFolder(fileId: $fileId, folderId: $folderId)
}
    `;
export type AddFileToFolderMutationFn = Apollo.MutationFunction<AddFileToFolderMutation, AddFileToFolderMutationVariables>;

/**
 * __useAddFileToFolderMutation__
 *
 * To run a mutation, you first call `useAddFileToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFileToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFileToFolderMutation, { data, loading, error }] = useAddFileToFolderMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useAddFileToFolderMutation(baseOptions?: Apollo.MutationHookOptions<AddFileToFolderMutation, AddFileToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFileToFolderMutation, AddFileToFolderMutationVariables>(AddFileToFolderDocument, options);
      }
export type AddFileToFolderMutationHookResult = ReturnType<typeof useAddFileToFolderMutation>;
export type AddFileToFolderMutationResult = Apollo.MutationResult<AddFileToFolderMutation>;
export type AddFileToFolderMutationOptions = Apollo.BaseMutationOptions<AddFileToFolderMutation, AddFileToFolderMutationVariables>;
export const RemoveFileFromFolderDocument = gql`
    mutation removeFileFromFolder($fileId: ID!, $folderId: ID!) {
  removeFileFromFolder(fileId: $fileId, folderId: $folderId)
}
    `;
export type RemoveFileFromFolderMutationFn = Apollo.MutationFunction<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>;

/**
 * __useRemoveFileFromFolderMutation__
 *
 * To run a mutation, you first call `useRemoveFileFromFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileFromFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileFromFolderMutation, { data, loading, error }] = useRemoveFileFromFolderMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useRemoveFileFromFolderMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>(RemoveFileFromFolderDocument, options);
      }
export type RemoveFileFromFolderMutationHookResult = ReturnType<typeof useRemoveFileFromFolderMutation>;
export type RemoveFileFromFolderMutationResult = Apollo.MutationResult<RemoveFileFromFolderMutation>;
export type RemoveFileFromFolderMutationOptions = Apollo.BaseMutationOptions<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>;
export const GenerateTranscriptionDocument = gql`
    mutation generateTranscription($fileId: ID!, $language: String, $speakersExpected: Int) {
  generateTranscription(
    fileId: $fileId
    language: $language
    speakersExpected: $speakersExpected
  )
}
    `;
export type GenerateTranscriptionMutationFn = Apollo.MutationFunction<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>;

/**
 * __useGenerateTranscriptionMutation__
 *
 * To run a mutation, you first call `useGenerateTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTranscriptionMutation, { data, loading, error }] = useGenerateTranscriptionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      language: // value for 'language'
 *      speakersExpected: // value for 'speakersExpected'
 *   },
 * });
 */
export function useGenerateTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>(GenerateTranscriptionDocument, options);
      }
export type GenerateTranscriptionMutationHookResult = ReturnType<typeof useGenerateTranscriptionMutation>;
export type GenerateTranscriptionMutationResult = Apollo.MutationResult<GenerateTranscriptionMutation>;
export type GenerateTranscriptionMutationOptions = Apollo.BaseMutationOptions<GenerateTranscriptionMutation, GenerateTranscriptionMutationVariables>;
export const CreateExportClipToLibraryJobDocument = gql`
    mutation createExportClipToLibraryJob($episodeId: ID!, $uniqueId: ID!, $exportedFilename: String!, $clipTimings: ClipTimingsInput, $addToEpisode: Boolean = false) {
  createExportClipToLibraryJob(
    episodeId: $episodeId
    uniqueId: $uniqueId
    exportedFilename: $exportedFilename
    clipTimings: $clipTimings
    addToEpisode: $addToEpisode
  ) {
    id
  }
}
    `;
export type CreateExportClipToLibraryJobMutationFn = Apollo.MutationFunction<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>;

/**
 * __useCreateExportClipToLibraryJobMutation__
 *
 * To run a mutation, you first call `useCreateExportClipToLibraryJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportClipToLibraryJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportClipToLibraryJobMutation, { data, loading, error }] = useCreateExportClipToLibraryJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      uniqueId: // value for 'uniqueId'
 *      exportedFilename: // value for 'exportedFilename'
 *      clipTimings: // value for 'clipTimings'
 *      addToEpisode: // value for 'addToEpisode'
 *   },
 * });
 */
export function useCreateExportClipToLibraryJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>(CreateExportClipToLibraryJobDocument, options);
      }
export type CreateExportClipToLibraryJobMutationHookResult = ReturnType<typeof useCreateExportClipToLibraryJobMutation>;
export type CreateExportClipToLibraryJobMutationResult = Apollo.MutationResult<CreateExportClipToLibraryJobMutation>;
export type CreateExportClipToLibraryJobMutationOptions = Apollo.BaseMutationOptions<CreateExportClipToLibraryJobMutation, CreateExportClipToLibraryJobMutationVariables>;
export const SplitEpisodeClipDocument = gql`
    mutation splitEpisodeClip($id: ID!, $uniqueId: ID!, $splitTime: Float!, $firstFileName: String!, $secondFileName: String!, $version: Int!) {
  splitEpisodeClip(
    id: $id
    uniqueId: $uniqueId
    splitTime: $splitTime
    firstFileName: $firstFileName
    secondFileName: $secondFileName
    version: $version
  ) {
    id
    version
    timeline {
      ...EpisodeFile
    }
  }
}
    ${EpisodeFileFragmentDoc}`;
export type SplitEpisodeClipMutationFn = Apollo.MutationFunction<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>;

/**
 * __useSplitEpisodeClipMutation__
 *
 * To run a mutation, you first call `useSplitEpisodeClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitEpisodeClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitEpisodeClipMutation, { data, loading, error }] = useSplitEpisodeClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      uniqueId: // value for 'uniqueId'
 *      splitTime: // value for 'splitTime'
 *      firstFileName: // value for 'firstFileName'
 *      secondFileName: // value for 'secondFileName'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSplitEpisodeClipMutation(baseOptions?: Apollo.MutationHookOptions<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>(SplitEpisodeClipDocument, options);
      }
export type SplitEpisodeClipMutationHookResult = ReturnType<typeof useSplitEpisodeClipMutation>;
export type SplitEpisodeClipMutationResult = Apollo.MutationResult<SplitEpisodeClipMutation>;
export type SplitEpisodeClipMutationOptions = Apollo.BaseMutationOptions<SplitEpisodeClipMutation, SplitEpisodeClipMutationVariables>;
export const GetRecordingRulesDocument = gql`
    query getRecordingRules($callPermalink: ID!) {
  getRecordingRules(callPermalink: $callPermalink)
}
    `;

/**
 * __useGetRecordingRulesQuery__
 *
 * To run a query within a React component, call `useGetRecordingRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingRulesQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useGetRecordingRulesQuery(baseOptions: Apollo.QueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables> & ({ variables: GetRecordingRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
      }
export function useGetRecordingRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
        }
// @ts-ignore
export function useGetRecordingRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>;
export function useGetRecordingRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecordingRulesQuery | undefined, GetRecordingRulesQueryVariables>;
export function useGetRecordingRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>(GetRecordingRulesDocument, options);
        }
export type GetRecordingRulesQueryHookResult = ReturnType<typeof useGetRecordingRulesQuery>;
export type GetRecordingRulesLazyQueryHookResult = ReturnType<typeof useGetRecordingRulesLazyQuery>;
export type GetRecordingRulesSuspenseQueryHookResult = ReturnType<typeof useGetRecordingRulesSuspenseQuery>;
export type GetRecordingRulesQueryResult = Apollo.QueryResult<GetRecordingRulesQuery, GetRecordingRulesQueryVariables>;
export const UpdateRecordingRulesDocument = gql`
    mutation updateRecordingRules($callPermalink: ID!, $type: String!) {
  updateRecordingRules(callPermalink: $callPermalink, type: $type)
}
    `;
export type UpdateRecordingRulesMutationFn = Apollo.MutationFunction<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>;

/**
 * __useUpdateRecordingRulesMutation__
 *
 * To run a mutation, you first call `useUpdateRecordingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecordingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecordingRulesMutation, { data, loading, error }] = useUpdateRecordingRulesMutation({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateRecordingRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>(UpdateRecordingRulesDocument, options);
      }
export type UpdateRecordingRulesMutationHookResult = ReturnType<typeof useUpdateRecordingRulesMutation>;
export type UpdateRecordingRulesMutationResult = Apollo.MutationResult<UpdateRecordingRulesMutation>;
export type UpdateRecordingRulesMutationOptions = Apollo.BaseMutationOptions<UpdateRecordingRulesMutation, UpdateRecordingRulesMutationVariables>;
export const CreateCallDocument = gql`
    mutation createCall($twilioId: String!, $isSolo: Boolean, $fileName: String, $recordOnConnect: Boolean!) {
  createCall(
    twilioId: $twilioId
    isSolo: $isSolo
    fileName: $fileName
    recordOnConnect: $recordOnConnect
  ) {
    id
    token
    room
    participant {
      instanceId
      token
    }
  }
}
    `;
export type CreateCallMutationFn = Apollo.MutationFunction<CreateCallMutation, CreateCallMutationVariables>;

/**
 * __useCreateCallMutation__
 *
 * To run a mutation, you first call `useCreateCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCallMutation, { data, loading, error }] = useCreateCallMutation({
 *   variables: {
 *      twilioId: // value for 'twilioId'
 *      isSolo: // value for 'isSolo'
 *      fileName: // value for 'fileName'
 *      recordOnConnect: // value for 'recordOnConnect'
 *   },
 * });
 */
export function useCreateCallMutation(baseOptions?: Apollo.MutationHookOptions<CreateCallMutation, CreateCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCallMutation, CreateCallMutationVariables>(CreateCallDocument, options);
      }
export type CreateCallMutationHookResult = ReturnType<typeof useCreateCallMutation>;
export type CreateCallMutationResult = Apollo.MutationResult<CreateCallMutation>;
export type CreateCallMutationOptions = Apollo.BaseMutationOptions<CreateCallMutation, CreateCallMutationVariables>;
export const JoinCallDocument = gql`
    mutation joinCall($callPermalink: ID!, $twilioId: String!) {
  joinCall(callPermalink: $callPermalink, twilioId: $twilioId) {
    id
    token
    room
    participant {
      instanceId
      token
    }
  }
}
    `;
export type JoinCallMutationFn = Apollo.MutationFunction<JoinCallMutation, JoinCallMutationVariables>;

/**
 * __useJoinCallMutation__
 *
 * To run a mutation, you first call `useJoinCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCallMutation, { data, loading, error }] = useJoinCallMutation({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *      twilioId: // value for 'twilioId'
 *   },
 * });
 */
export function useJoinCallMutation(baseOptions?: Apollo.MutationHookOptions<JoinCallMutation, JoinCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCallMutation, JoinCallMutationVariables>(JoinCallDocument, options);
      }
export type JoinCallMutationHookResult = ReturnType<typeof useJoinCallMutation>;
export type JoinCallMutationResult = Apollo.MutationResult<JoinCallMutation>;
export type JoinCallMutationOptions = Apollo.BaseMutationOptions<JoinCallMutation, JoinCallMutationVariables>;
export const CallExistsDocument = gql`
    query callExists($callPermalink: ID!) {
  callExists(callPermalink: $callPermalink)
}
    `;

/**
 * __useCallExistsQuery__
 *
 * To run a query within a React component, call `useCallExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallExistsQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useCallExistsQuery(baseOptions: Apollo.QueryHookOptions<CallExistsQuery, CallExistsQueryVariables> & ({ variables: CallExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
      }
export function useCallExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
        }
// @ts-ignore
export function useCallExistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>): Apollo.UseSuspenseQueryResult<CallExistsQuery, CallExistsQueryVariables>;
export function useCallExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>): Apollo.UseSuspenseQueryResult<CallExistsQuery | undefined, CallExistsQueryVariables>;
export function useCallExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CallExistsQuery, CallExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallExistsQuery, CallExistsQueryVariables>(CallExistsDocument, options);
        }
export type CallExistsQueryHookResult = ReturnType<typeof useCallExistsQuery>;
export type CallExistsLazyQueryHookResult = ReturnType<typeof useCallExistsLazyQuery>;
export type CallExistsSuspenseQueryHookResult = ReturnType<typeof useCallExistsSuspenseQuery>;
export type CallExistsQueryResult = Apollo.QueryResult<CallExistsQuery, CallExistsQueryVariables>;
export const UpdateCallLockDocument = gql`
    mutation updateCallLock($id: ID!, $locked: Boolean!) {
  updateCallLock(id: $id, locked: $locked)
}
    `;
export type UpdateCallLockMutationFn = Apollo.MutationFunction<UpdateCallLockMutation, UpdateCallLockMutationVariables>;

/**
 * __useUpdateCallLockMutation__
 *
 * To run a mutation, you first call `useUpdateCallLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallLockMutation, { data, loading, error }] = useUpdateCallLockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locked: // value for 'locked'
 *   },
 * });
 */
export function useUpdateCallLockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallLockMutation, UpdateCallLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallLockMutation, UpdateCallLockMutationVariables>(UpdateCallLockDocument, options);
      }
export type UpdateCallLockMutationHookResult = ReturnType<typeof useUpdateCallLockMutation>;
export type UpdateCallLockMutationResult = Apollo.MutationResult<UpdateCallLockMutation>;
export type UpdateCallLockMutationOptions = Apollo.BaseMutationOptions<UpdateCallLockMutation, UpdateCallLockMutationVariables>;
export const GetCallCreatorDocument = gql`
    query getCallCreator($callPermalink: ID!) {
  getCallCreator(callPermalink: $callPermalink) {
    creatorTwilioId
  }
}
    `;

/**
 * __useGetCallCreatorQuery__
 *
 * To run a query within a React component, call `useGetCallCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallCreatorQuery({
 *   variables: {
 *      callPermalink: // value for 'callPermalink'
 *   },
 * });
 */
export function useGetCallCreatorQuery(baseOptions: Apollo.QueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables> & ({ variables: GetCallCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
      }
export function useGetCallCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
        }
// @ts-ignore
export function useGetCallCreatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallCreatorQuery, GetCallCreatorQueryVariables>;
export function useGetCallCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallCreatorQuery | undefined, GetCallCreatorQueryVariables>;
export function useGetCallCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallCreatorQuery, GetCallCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallCreatorQuery, GetCallCreatorQueryVariables>(GetCallCreatorDocument, options);
        }
export type GetCallCreatorQueryHookResult = ReturnType<typeof useGetCallCreatorQuery>;
export type GetCallCreatorLazyQueryHookResult = ReturnType<typeof useGetCallCreatorLazyQuery>;
export type GetCallCreatorSuspenseQueryHookResult = ReturnType<typeof useGetCallCreatorSuspenseQuery>;
export type GetCallCreatorQueryResult = Apollo.QueryResult<GetCallCreatorQuery, GetCallCreatorQueryVariables>;
export const AddCallRecordingDurationDocument = gql`
    mutation addCallRecordingDuration($id: ID!, $duration: Float!) {
  addCallRecordingDuration(id: $id, duration: $duration)
}
    `;
export type AddCallRecordingDurationMutationFn = Apollo.MutationFunction<AddCallRecordingDurationMutation, AddCallRecordingDurationMutationVariables>;

/**
 * __useAddCallRecordingDurationMutation__
 *
 * To run a mutation, you first call `useAddCallRecordingDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallRecordingDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallRecordingDurationMutation, { data, loading, error }] = useAddCallRecordingDurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAddCallRecordingDurationMutation(baseOptions?: Apollo.MutationHookOptions<AddCallRecordingDurationMutation, AddCallRecordingDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallRecordingDurationMutation, AddCallRecordingDurationMutationVariables>(AddCallRecordingDurationDocument, options);
      }
export type AddCallRecordingDurationMutationHookResult = ReturnType<typeof useAddCallRecordingDurationMutation>;
export type AddCallRecordingDurationMutationResult = Apollo.MutationResult<AddCallRecordingDurationMutation>;
export type AddCallRecordingDurationMutationOptions = Apollo.BaseMutationOptions<AddCallRecordingDurationMutation, AddCallRecordingDurationMutationVariables>;
export const AddCallRecordingTypeDocument = gql`
    mutation addCallRecordingType($id: ID!, $type: RecordingType!) {
  addCallRecordingType(id: $id, type: $type)
}
    `;
export type AddCallRecordingTypeMutationFn = Apollo.MutationFunction<AddCallRecordingTypeMutation, AddCallRecordingTypeMutationVariables>;

/**
 * __useAddCallRecordingTypeMutation__
 *
 * To run a mutation, you first call `useAddCallRecordingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCallRecordingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCallRecordingTypeMutation, { data, loading, error }] = useAddCallRecordingTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAddCallRecordingTypeMutation(baseOptions?: Apollo.MutationHookOptions<AddCallRecordingTypeMutation, AddCallRecordingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCallRecordingTypeMutation, AddCallRecordingTypeMutationVariables>(AddCallRecordingTypeDocument, options);
      }
export type AddCallRecordingTypeMutationHookResult = ReturnType<typeof useAddCallRecordingTypeMutation>;
export type AddCallRecordingTypeMutationResult = Apollo.MutationResult<AddCallRecordingTypeMutation>;
export type AddCallRecordingTypeMutationOptions = Apollo.BaseMutationOptions<AddCallRecordingTypeMutation, AddCallRecordingTypeMutationVariables>;
export const CreateMusicEditorJobDocument = gql`
    mutation createMusicEditorJob($fileName: String, $voice: JSON!, $music: JSON!, $introDuration: Float, $outroDuration: Float, $musicVolume: Float) {
  createMusicEditorJob(
    fileName: $fileName
    voice: $voice
    music: $music
    introDuration: $introDuration
    outroDuration: $outroDuration
    musicVolume: $musicVolume
  )
}
    `;
export type CreateMusicEditorJobMutationFn = Apollo.MutationFunction<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>;

/**
 * __useCreateMusicEditorJobMutation__
 *
 * To run a mutation, you first call `useCreateMusicEditorJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMusicEditorJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMusicEditorJobMutation, { data, loading, error }] = useCreateMusicEditorJobMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      voice: // value for 'voice'
 *      music: // value for 'music'
 *      introDuration: // value for 'introDuration'
 *      outroDuration: // value for 'outroDuration'
 *      musicVolume: // value for 'musicVolume'
 *   },
 * });
 */
export function useCreateMusicEditorJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>(CreateMusicEditorJobDocument, options);
      }
export type CreateMusicEditorJobMutationHookResult = ReturnType<typeof useCreateMusicEditorJobMutation>;
export type CreateMusicEditorJobMutationResult = Apollo.MutationResult<CreateMusicEditorJobMutation>;
export type CreateMusicEditorJobMutationOptions = Apollo.BaseMutationOptions<CreateMusicEditorJobMutation, CreateMusicEditorJobMutationVariables>;
export const CreateMusicEditorEditJobDocument = gql`
    mutation createMusicEditorEditJob($fileId: ID!, $timeline: JSON!) {
  createMusicEditorEditJob(fileId: $fileId, timeline: $timeline)
}
    `;
export type CreateMusicEditorEditJobMutationFn = Apollo.MutationFunction<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>;

/**
 * __useCreateMusicEditorEditJobMutation__
 *
 * To run a mutation, you first call `useCreateMusicEditorEditJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMusicEditorEditJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMusicEditorEditJobMutation, { data, loading, error }] = useCreateMusicEditorEditJobMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      timeline: // value for 'timeline'
 *   },
 * });
 */
export function useCreateMusicEditorEditJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>(CreateMusicEditorEditJobDocument, options);
      }
export type CreateMusicEditorEditJobMutationHookResult = ReturnType<typeof useCreateMusicEditorEditJobMutation>;
export type CreateMusicEditorEditJobMutationResult = Apollo.MutationResult<CreateMusicEditorEditJobMutation>;
export type CreateMusicEditorEditJobMutationOptions = Apollo.BaseMutationOptions<CreateMusicEditorEditJobMutation, CreateMusicEditorEditJobMutationVariables>;
export const EpisodeDocument = gql`
    query episode($id: ID!, $version: Int) {
  episode(id: $id, version: $version) {
    ...EpisodeAllFields
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;

/**
 * __useEpisodeQuery__
 *
 * To run a query within a React component, call `useEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useEpisodeQuery(baseOptions: Apollo.QueryHookOptions<EpisodeQuery, EpisodeQueryVariables> & ({ variables: EpisodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
      }
export function useEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
        }
// @ts-ignore
export function useEpisodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeQuery, EpisodeQueryVariables>;
export function useEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeQuery | undefined, EpisodeQueryVariables>;
export function useEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeQuery, EpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeQuery, EpisodeQueryVariables>(EpisodeDocument, options);
        }
export type EpisodeQueryHookResult = ReturnType<typeof useEpisodeQuery>;
export type EpisodeLazyQueryHookResult = ReturnType<typeof useEpisodeLazyQuery>;
export type EpisodeSuspenseQueryHookResult = ReturnType<typeof useEpisodeSuspenseQuery>;
export type EpisodeQueryResult = Apollo.QueryResult<EpisodeQuery, EpisodeQueryVariables>;
export const UpdateEpisodeDocument = gql`
    mutation updateEpisode($id: ID!, $metaData: EpisodeMetaDataInput, $timeline: [EpisodeFileInput!], $shouldSuggestTitle: Boolean, $shouldSuggestDescription: Boolean, $shouldIncludeTranscriptInRss: Boolean, $version: Int, $artwork: ArtworkInput, $videoMode: Boolean, $metaDataNeedsReprocessing: Boolean) {
  episode: updateEpisode(
    id: $id
    metaData: $metaData
    timeline: $timeline
    shouldSuggestTitle: $shouldSuggestTitle
    shouldSuggestDescription: $shouldSuggestDescription
    shouldIncludeTranscriptInRss: $shouldIncludeTranscriptInRss
    version: $version
    artwork: $artwork
    videoMode: $videoMode
    metaDataNeedsReprocessing: $metaDataNeedsReprocessing
  ) {
    ...EpisodeAllFields
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;
export type UpdateEpisodeMutationFn = Apollo.MutationFunction<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;

/**
 * __useUpdateEpisodeMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeMutation, { data, loading, error }] = useUpdateEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metaData: // value for 'metaData'
 *      timeline: // value for 'timeline'
 *      shouldSuggestTitle: // value for 'shouldSuggestTitle'
 *      shouldSuggestDescription: // value for 'shouldSuggestDescription'
 *      shouldIncludeTranscriptInRss: // value for 'shouldIncludeTranscriptInRss'
 *      version: // value for 'version'
 *      artwork: // value for 'artwork'
 *      videoMode: // value for 'videoMode'
 *      metaDataNeedsReprocessing: // value for 'metaDataNeedsReprocessing'
 *   },
 * });
 */
export function useUpdateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>(UpdateEpisodeDocument, options);
      }
export type UpdateEpisodeMutationHookResult = ReturnType<typeof useUpdateEpisodeMutation>;
export type UpdateEpisodeMutationResult = Apollo.MutationResult<UpdateEpisodeMutation>;
export type UpdateEpisodeMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;
export const AddAuphonicMetadataDocument = gql`
    mutation addAuphonicMetadata($fileId: ID!) {
  addAuphonicMetadata(fileId: $fileId)
}
    `;
export type AddAuphonicMetadataMutationFn = Apollo.MutationFunction<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>;

/**
 * __useAddAuphonicMetadataMutation__
 *
 * To run a mutation, you first call `useAddAuphonicMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAuphonicMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAuphonicMetadataMutation, { data, loading, error }] = useAddAuphonicMetadataMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAddAuphonicMetadataMutation(baseOptions?: Apollo.MutationHookOptions<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>(AddAuphonicMetadataDocument, options);
      }
export type AddAuphonicMetadataMutationHookResult = ReturnType<typeof useAddAuphonicMetadataMutation>;
export type AddAuphonicMetadataMutationResult = Apollo.MutationResult<AddAuphonicMetadataMutation>;
export type AddAuphonicMetadataMutationOptions = Apollo.BaseMutationOptions<AddAuphonicMetadataMutation, AddAuphonicMetadataMutationVariables>;
export const CreateExportJobDocument = gql`
    mutation createExportJob($episodeId: ID!) {
  createExportJob(episodeId: $episodeId) {
    id
  }
}
    `;
export type CreateExportJobMutationFn = Apollo.MutationFunction<CreateExportJobMutation, CreateExportJobMutationVariables>;

/**
 * __useCreateExportJobMutation__
 *
 * To run a mutation, you first call `useCreateExportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportJobMutation, { data, loading, error }] = useCreateExportJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useCreateExportJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportJobMutation, CreateExportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportJobMutation, CreateExportJobMutationVariables>(CreateExportJobDocument, options);
      }
export type CreateExportJobMutationHookResult = ReturnType<typeof useCreateExportJobMutation>;
export type CreateExportJobMutationResult = Apollo.MutationResult<CreateExportJobMutation>;
export type CreateExportJobMutationOptions = Apollo.BaseMutationOptions<CreateExportJobMutation, CreateExportJobMutationVariables>;
export const EpisodesDocument = gql`
    query episodes($name: String, $offset: Int!, $limit: Int, $order: String, $jobStatus: String, $lifecycleState: LifecycleState, $showId: String) {
  episodes(
    name: $name
    offset: $offset
    limit: $limit
    order: $order
    jobStatus: $jobStatus
    lifecycleState: $lifecycleState
    showId: $showId
  ) {
    id
    metaData {
      name
      summary
      description
      episodeNumber
      seasonNumber
    }
    timeline {
      id
      uniqueId
    }
    version
    isArchivedVersion
    file {
      id
      audioJob {
        id
        createdAt
        status
        schema
        progress
      }
      videoJob {
        id
        createdAt
        status
        schema
        progress
      }
      transcriptionJob {
        id
        createdAt
        status
        schema
        progress
      }
      aiJob {
        id
        createdAt
        status
        schema
        progress
      }
      metaDataJob {
        id
        createdAt
        status
        schema
        progress
      }
    }
    artworkUrl
    createdAt
    updatedAt
    publishedAt
    schedulePublishAt
    host
    metaDataNeedsReprocessing
  }
  filteredTotal: episodesCount(
    name: $name
    jobStatus: $jobStatus
    lifecycleState: $lifecycleState
    showId: $showId
  )
  all: episodesCount
  draft: episodesCount(lifecycleState: draft)
  processing: episodesCount(jobStatus: "processing")
  complete: episodesCount(jobStatus: "complete")
  host
}
    `;

/**
 * __useEpisodesQuery__
 *
 * To run a query within a React component, call `useEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      jobStatus: // value for 'jobStatus'
 *      lifecycleState: // value for 'lifecycleState'
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useEpisodesQuery(baseOptions: Apollo.QueryHookOptions<EpisodesQuery, EpisodesQueryVariables> & ({ variables: EpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
      }
export function useEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
        }
// @ts-ignore
export function useEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesQuery, EpisodesQueryVariables>;
export function useEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesQuery | undefined, EpisodesQueryVariables>;
export function useEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesQuery, EpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodesQuery, EpisodesQueryVariables>(EpisodesDocument, options);
        }
export type EpisodesQueryHookResult = ReturnType<typeof useEpisodesQuery>;
export type EpisodesLazyQueryHookResult = ReturnType<typeof useEpisodesLazyQuery>;
export type EpisodesSuspenseQueryHookResult = ReturnType<typeof useEpisodesSuspenseQuery>;
export type EpisodesQueryResult = Apollo.QueryResult<EpisodesQuery, EpisodesQueryVariables>;
export const EpisodesCopyDestinationDocument = gql`
    query episodesCopyDestination {
  draft: episodes(
    lifecycleState: draft
    offset: 0
    limit: 1000
    order: "updatedAt-DESC"
  ) {
    id
    metaData {
      name
    }
  }
  ready: episodes(
    lifecycleState: ready
    offset: 0
    limit: 1000
    order: "updatedAt-DESC"
  ) {
    id
    metaData {
      name
    }
  }
  published: episodes(
    lifecycleState: published
    offset: 0
    limit: 1000
    order: "updatedAt-DESC"
  ) {
    id
    metaData {
      name
    }
  }
  scheduled: episodes(
    lifecycleState: scheduled
    offset: 0
    limit: 1000
    order: "updatedAt-DESC"
  ) {
    id
    metaData {
      name
    }
  }
}
    `;

/**
 * __useEpisodesCopyDestinationQuery__
 *
 * To run a query within a React component, call `useEpisodesCopyDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodesCopyDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodesCopyDestinationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpisodesCopyDestinationQuery(baseOptions?: Apollo.QueryHookOptions<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>(EpisodesCopyDestinationDocument, options);
      }
export function useEpisodesCopyDestinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>(EpisodesCopyDestinationDocument, options);
        }
// @ts-ignore
export function useEpisodesCopyDestinationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>;
export function useEpisodesCopyDestinationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesCopyDestinationQuery | undefined, EpisodesCopyDestinationQueryVariables>;
export function useEpisodesCopyDestinationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>(EpisodesCopyDestinationDocument, options);
        }
export type EpisodesCopyDestinationQueryHookResult = ReturnType<typeof useEpisodesCopyDestinationQuery>;
export type EpisodesCopyDestinationLazyQueryHookResult = ReturnType<typeof useEpisodesCopyDestinationLazyQuery>;
export type EpisodesCopyDestinationSuspenseQueryHookResult = ReturnType<typeof useEpisodesCopyDestinationSuspenseQuery>;
export type EpisodesCopyDestinationQueryResult = Apollo.QueryResult<EpisodesCopyDestinationQuery, EpisodesCopyDestinationQueryVariables>;
export const DuplicateEpisodeDocument = gql`
    mutation duplicateEpisode($id: ID!, $name: String) {
  duplicateEpisode(id: $id, name: $name) {
    id
  }
}
    `;
export type DuplicateEpisodeMutationFn = Apollo.MutationFunction<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>;

/**
 * __useDuplicateEpisodeMutation__
 *
 * To run a mutation, you first call `useDuplicateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEpisodeMutation, { data, loading, error }] = useDuplicateEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDuplicateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>(DuplicateEpisodeDocument, options);
      }
export type DuplicateEpisodeMutationHookResult = ReturnType<typeof useDuplicateEpisodeMutation>;
export type DuplicateEpisodeMutationResult = Apollo.MutationResult<DuplicateEpisodeMutation>;
export type DuplicateEpisodeMutationOptions = Apollo.BaseMutationOptions<DuplicateEpisodeMutation, DuplicateEpisodeMutationVariables>;
export const DeleteEpisodeDocument = gql`
    mutation deleteEpisode($id: ID!) {
  deleteEpisode(id: $id) {
    deletedEpisodeId
  }
}
    `;
export type DeleteEpisodeMutationFn = Apollo.MutationFunction<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>;

/**
 * __useDeleteEpisodeMutation__
 *
 * To run a mutation, you first call `useDeleteEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpisodeMutation, { data, loading, error }] = useDeleteEpisodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>(DeleteEpisodeDocument, options);
      }
export type DeleteEpisodeMutationHookResult = ReturnType<typeof useDeleteEpisodeMutation>;
export type DeleteEpisodeMutationResult = Apollo.MutationResult<DeleteEpisodeMutation>;
export type DeleteEpisodeMutationOptions = Apollo.BaseMutationOptions<DeleteEpisodeMutation, DeleteEpisodeMutationVariables>;
export const EpisodesCountPerUserDocument = gql`
    query episodesCountPerUser {
  episodesCountPerUser
}
    `;

/**
 * __useEpisodesCountPerUserQuery__
 *
 * To run a query within a React component, call `useEpisodesCountPerUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodesCountPerUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodesCountPerUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpisodesCountPerUserQuery(baseOptions?: Apollo.QueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
      }
export function useEpisodesCountPerUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
        }
// @ts-ignore
export function useEpisodesCountPerUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>;
export function useEpisodesCountPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodesCountPerUserQuery | undefined, EpisodesCountPerUserQueryVariables>;
export function useEpisodesCountPerUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>(EpisodesCountPerUserDocument, options);
        }
export type EpisodesCountPerUserQueryHookResult = ReturnType<typeof useEpisodesCountPerUserQuery>;
export type EpisodesCountPerUserLazyQueryHookResult = ReturnType<typeof useEpisodesCountPerUserLazyQuery>;
export type EpisodesCountPerUserSuspenseQueryHookResult = ReturnType<typeof useEpisodesCountPerUserSuspenseQuery>;
export type EpisodesCountPerUserQueryResult = Apollo.QueryResult<EpisodesCountPerUserQuery, EpisodesCountPerUserQueryVariables>;
export const FetchProcessingFileDocument = gql`
    query fetchProcessingFile($id: ID!, $projectId: ID!) {
  file(id: $id, projectId: $projectId) {
    codecInformation {
      format {
        duration
      }
    }
    audioJob {
      status
    }
    imageJob {
      status
    }
  }
}
    `;

/**
 * __useFetchProcessingFileQuery__
 *
 * To run a query within a React component, call `useFetchProcessingFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProcessingFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProcessingFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchProcessingFileQuery(baseOptions: Apollo.QueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables> & ({ variables: FetchProcessingFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
      }
export function useFetchProcessingFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
        }
// @ts-ignore
export function useFetchProcessingFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>;
export function useFetchProcessingFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchProcessingFileQuery | undefined, FetchProcessingFileQueryVariables>;
export function useFetchProcessingFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>(FetchProcessingFileDocument, options);
        }
export type FetchProcessingFileQueryHookResult = ReturnType<typeof useFetchProcessingFileQuery>;
export type FetchProcessingFileLazyQueryHookResult = ReturnType<typeof useFetchProcessingFileLazyQuery>;
export type FetchProcessingFileSuspenseQueryHookResult = ReturnType<typeof useFetchProcessingFileSuspenseQuery>;
export type FetchProcessingFileQueryResult = Apollo.QueryResult<FetchProcessingFileQuery, FetchProcessingFileQueryVariables>;
export const FetchFileDocument = gql`
    query fetchFile($id: ID!, $projectId: ID!) {
  file(id: $id, projectId: $projectId) {
    id
    name
    type
    tags
    bucket
    codecInformation {
      format {
        duration
      }
    }
    users {
      userFile
    }
    audioJob {
      id
      status
    }
    imageJob {
      id
      status
    }
  }
}
    `;

/**
 * __useFetchFileQuery__
 *
 * To run a query within a React component, call `useFetchFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFetchFileQuery(baseOptions: Apollo.QueryHookOptions<FetchFileQuery, FetchFileQueryVariables> & ({ variables: FetchFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
      }
export function useFetchFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
        }
// @ts-ignore
export function useFetchFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchFileQuery, FetchFileQueryVariables>;
export function useFetchFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>): Apollo.UseSuspenseQueryResult<FetchFileQuery | undefined, FetchFileQueryVariables>;
export function useFetchFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchFileQuery, FetchFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchFileQuery, FetchFileQueryVariables>(FetchFileDocument, options);
        }
export type FetchFileQueryHookResult = ReturnType<typeof useFetchFileQuery>;
export type FetchFileLazyQueryHookResult = ReturnType<typeof useFetchFileLazyQuery>;
export type FetchFileSuspenseQueryHookResult = ReturnType<typeof useFetchFileSuspenseQuery>;
export type FetchFileQueryResult = Apollo.QueryResult<FetchFileQuery, FetchFileQueryVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($id: ID!, $newData: UpdateFile, $removeData: JSON) {
  updateFile(id: $id, newData: $newData, removeData: $removeData)
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newData: // value for 'newData'
 *      removeData: // value for 'removeData'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdateUserFileDocument = gql`
    mutation updateUserFile($fileId: ID!, $newData: UpdateUserFile) {
  updateUserFile(fileId: $fileId, newData: $newData)
}
    `;
export type UpdateUserFileMutationFn = Apollo.MutationFunction<UpdateUserFileMutation, UpdateUserFileMutationVariables>;

/**
 * __useUpdateUserFileMutation__
 *
 * To run a mutation, you first call `useUpdateUserFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFileMutation, { data, loading, error }] = useUpdateUserFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      newData: // value for 'newData'
 *   },
 * });
 */
export function useUpdateUserFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFileMutation, UpdateUserFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFileMutation, UpdateUserFileMutationVariables>(UpdateUserFileDocument, options);
      }
export type UpdateUserFileMutationHookResult = ReturnType<typeof useUpdateUserFileMutation>;
export type UpdateUserFileMutationResult = Apollo.MutationResult<UpdateUserFileMutation>;
export type UpdateUserFileMutationOptions = Apollo.BaseMutationOptions<UpdateUserFileMutation, UpdateUserFileMutationVariables>;
export const RemoveFileDocument = gql`
    mutation removeFile($id: ID!) {
  removeFile(id: $id)
}
    `;
export type RemoveFileMutationFn = Apollo.MutationFunction<RemoveFileMutation, RemoveFileMutationVariables>;

/**
 * __useRemoveFileMutation__
 *
 * To run a mutation, you first call `useRemoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileMutation, { data, loading, error }] = useRemoveFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileMutation, RemoveFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileMutation, RemoveFileMutationVariables>(RemoveFileDocument, options);
      }
export type RemoveFileMutationHookResult = ReturnType<typeof useRemoveFileMutation>;
export type RemoveFileMutationResult = Apollo.MutationResult<RemoveFileMutation>;
export type RemoveFileMutationOptions = Apollo.BaseMutationOptions<RemoveFileMutation, RemoveFileMutationVariables>;
export const BulkDeleteFilesDocument = gql`
    mutation bulkDeleteFiles($fileIds: [String!]) {
  bulkDeleteFiles(fileIds: $fileIds)
}
    `;
export type BulkDeleteFilesMutationFn = Apollo.MutationFunction<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>;

/**
 * __useBulkDeleteFilesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteFilesMutation, { data, loading, error }] = useBulkDeleteFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useBulkDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>(BulkDeleteFilesDocument, options);
      }
export type BulkDeleteFilesMutationHookResult = ReturnType<typeof useBulkDeleteFilesMutation>;
export type BulkDeleteFilesMutationResult = Apollo.MutationResult<BulkDeleteFilesMutation>;
export type BulkDeleteFilesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteFilesMutation, BulkDeleteFilesMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($email: String!) {
  requestResetPassword(email: $email) {
    success
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($password: String!, $token: String!) {
  resetPassword(password: $password, token: $token) {
    success
    reason
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SwitchPlanTypeDocument = gql`
    mutation switchPlanType {
  switchPlanType {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type SwitchPlanTypeMutationFn = Apollo.MutationFunction<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>;

/**
 * __useSwitchPlanTypeMutation__
 *
 * To run a mutation, you first call `useSwitchPlanTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPlanTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPlanTypeMutation, { data, loading, error }] = useSwitchPlanTypeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSwitchPlanTypeMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>(SwitchPlanTypeDocument, options);
      }
export type SwitchPlanTypeMutationHookResult = ReturnType<typeof useSwitchPlanTypeMutation>;
export type SwitchPlanTypeMutationResult = Apollo.MutationResult<SwitchPlanTypeMutation>;
export type SwitchPlanTypeMutationOptions = Apollo.BaseMutationOptions<SwitchPlanTypeMutation, SwitchPlanTypeMutationVariables>;
export const UpgradePlanDocument = gql`
    mutation upgradePlan($planType: String!) {
  upgradePlan(planType: $planType) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type UpgradePlanMutationFn = Apollo.MutationFunction<UpgradePlanMutation, UpgradePlanMutationVariables>;

/**
 * __useUpgradePlanMutation__
 *
 * To run a mutation, you first call `useUpgradePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradePlanMutation, { data, loading, error }] = useUpgradePlanMutation({
 *   variables: {
 *      planType: // value for 'planType'
 *   },
 * });
 */
export function useUpgradePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpgradePlanMutation, UpgradePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradePlanMutation, UpgradePlanMutationVariables>(UpgradePlanDocument, options);
      }
export type UpgradePlanMutationHookResult = ReturnType<typeof useUpgradePlanMutation>;
export type UpgradePlanMutationResult = Apollo.MutationResult<UpgradePlanMutation>;
export type UpgradePlanMutationOptions = Apollo.BaseMutationOptions<UpgradePlanMutation, UpgradePlanMutationVariables>;
export const SubscriptionChangePreviewDocument = gql`
    query subscriptionChangePreview($changeType: String!, $planType: String) {
  subscriptionChangePreview(changeType: $changeType, planType: $planType) {
    immediateCharge
    nextPaymentAmount
    nextPaymentDate
    creditAmount
    currency
    changeType
    currentInterval
    newInterval
    currentPlanType
    newPlanType
  }
}
    `;

/**
 * __useSubscriptionChangePreviewQuery__
 *
 * To run a query within a React component, call `useSubscriptionChangePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionChangePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionChangePreviewQuery({
 *   variables: {
 *      changeType: // value for 'changeType'
 *      planType: // value for 'planType'
 *   },
 * });
 */
export function useSubscriptionChangePreviewQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables> & ({ variables: SubscriptionChangePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>(SubscriptionChangePreviewDocument, options);
      }
export function useSubscriptionChangePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>(SubscriptionChangePreviewDocument, options);
        }
// @ts-ignore
export function useSubscriptionChangePreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>;
export function useSubscriptionChangePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionChangePreviewQuery | undefined, SubscriptionChangePreviewQueryVariables>;
export function useSubscriptionChangePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>(SubscriptionChangePreviewDocument, options);
        }
export type SubscriptionChangePreviewQueryHookResult = ReturnType<typeof useSubscriptionChangePreviewQuery>;
export type SubscriptionChangePreviewLazyQueryHookResult = ReturnType<typeof useSubscriptionChangePreviewLazyQuery>;
export type SubscriptionChangePreviewSuspenseQueryHookResult = ReturnType<typeof useSubscriptionChangePreviewSuspenseQuery>;
export type SubscriptionChangePreviewQueryResult = Apollo.QueryResult<SubscriptionChangePreviewQuery, SubscriptionChangePreviewQueryVariables>;
export const RenewSubscriptionDocument = gql`
    mutation renewSubscription($paymentMethod: String!) {
  renewSubscription(paymentMethod: $paymentMethod) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type RenewSubscriptionMutationFn = Apollo.MutationFunction<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;

/**
 * __useRenewSubscriptionMutation__
 *
 * To run a mutation, you first call `useRenewSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewSubscriptionMutation, { data, loading, error }] = useRenewSubscriptionMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useRenewSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>(RenewSubscriptionDocument, options);
      }
export type RenewSubscriptionMutationHookResult = ReturnType<typeof useRenewSubscriptionMutation>;
export type RenewSubscriptionMutationResult = Apollo.MutationResult<RenewSubscriptionMutation>;
export type RenewSubscriptionMutationOptions = Apollo.BaseMutationOptions<RenewSubscriptionMutation, RenewSubscriptionMutationVariables>;
export const GetPaymentMethodsDocument = gql`
    query getPaymentMethods {
  getPaymentMethods
}
    `;

/**
 * __useGetPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
      }
export function useGetPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
// @ts-ignore
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsQuery | undefined, GetPaymentMethodsQueryVariables>;
export function useGetPaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>(GetPaymentMethodsDocument, options);
        }
export type GetPaymentMethodsQueryHookResult = ReturnType<typeof useGetPaymentMethodsQuery>;
export type GetPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsLazyQuery>;
export type GetPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsSuspenseQuery>;
export type GetPaymentMethodsQueryResult = Apollo.QueryResult<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const SocialClipDesignerClipDocument = gql`
    query SocialClipDesignerClip($id: ID!) {
  episodeSocialClip(id: $id) {
    id
    episodeId
    name
    schema
    schemaHash
    generatedSchemaHash
    isGeneratedFileStale
    state
    file {
      id
      name
    }
    job {
      id
      status
      progress
    }
  }
}
    `;

/**
 * __useSocialClipDesignerClipQuery__
 *
 * To run a query within a React component, call `useSocialClipDesignerClipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialClipDesignerClipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialClipDesignerClipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialClipDesignerClipQuery(baseOptions: Apollo.QueryHookOptions<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables> & ({ variables: SocialClipDesignerClipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>(SocialClipDesignerClipDocument, options);
      }
export function useSocialClipDesignerClipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>(SocialClipDesignerClipDocument, options);
        }
// @ts-ignore
export function useSocialClipDesignerClipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>): Apollo.UseSuspenseQueryResult<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>;
export function useSocialClipDesignerClipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>): Apollo.UseSuspenseQueryResult<SocialClipDesignerClipQuery | undefined, SocialClipDesignerClipQueryVariables>;
export function useSocialClipDesignerClipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>(SocialClipDesignerClipDocument, options);
        }
export type SocialClipDesignerClipQueryHookResult = ReturnType<typeof useSocialClipDesignerClipQuery>;
export type SocialClipDesignerClipLazyQueryHookResult = ReturnType<typeof useSocialClipDesignerClipLazyQuery>;
export type SocialClipDesignerClipSuspenseQueryHookResult = ReturnType<typeof useSocialClipDesignerClipSuspenseQuery>;
export type SocialClipDesignerClipQueryResult = Apollo.QueryResult<SocialClipDesignerClipQuery, SocialClipDesignerClipQueryVariables>;
export const SocialClipsForEpisodeDocument = gql`
    query SocialClipsForEpisode($episodeId: ID!) {
  episodeSocialClips(episodeId: $episodeId) {
    id
    episodeId
    name
    schema
    schemaHash
    generatedSchemaHash
    isGeneratedFileStale
    state
    file {
      id
      name
      type
    }
    job {
      id
      status
      progress
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSocialClipsForEpisodeQuery__
 *
 * To run a query within a React component, call `useSocialClipsForEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialClipsForEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialClipsForEpisodeQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useSocialClipsForEpisodeQuery(baseOptions: Apollo.QueryHookOptions<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables> & ({ variables: SocialClipsForEpisodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>(SocialClipsForEpisodeDocument, options);
      }
export function useSocialClipsForEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>(SocialClipsForEpisodeDocument, options);
        }
// @ts-ignore
export function useSocialClipsForEpisodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>;
export function useSocialClipsForEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<SocialClipsForEpisodeQuery | undefined, SocialClipsForEpisodeQueryVariables>;
export function useSocialClipsForEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>(SocialClipsForEpisodeDocument, options);
        }
export type SocialClipsForEpisodeQueryHookResult = ReturnType<typeof useSocialClipsForEpisodeQuery>;
export type SocialClipsForEpisodeLazyQueryHookResult = ReturnType<typeof useSocialClipsForEpisodeLazyQuery>;
export type SocialClipsForEpisodeSuspenseQueryHookResult = ReturnType<typeof useSocialClipsForEpisodeSuspenseQuery>;
export type SocialClipsForEpisodeQueryResult = Apollo.QueryResult<SocialClipsForEpisodeQuery, SocialClipsForEpisodeQueryVariables>;
export const DeleteEpisodeSocialClipDocument = gql`
    mutation DeleteEpisodeSocialClip($id: ID!) {
  deleteEpisodeSocialClip(id: $id)
}
    `;
export type DeleteEpisodeSocialClipMutationFn = Apollo.MutationFunction<DeleteEpisodeSocialClipMutation, DeleteEpisodeSocialClipMutationVariables>;

/**
 * __useDeleteEpisodeSocialClipMutation__
 *
 * To run a mutation, you first call `useDeleteEpisodeSocialClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEpisodeSocialClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEpisodeSocialClipMutation, { data, loading, error }] = useDeleteEpisodeSocialClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEpisodeSocialClipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEpisodeSocialClipMutation, DeleteEpisodeSocialClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEpisodeSocialClipMutation, DeleteEpisodeSocialClipMutationVariables>(DeleteEpisodeSocialClipDocument, options);
      }
export type DeleteEpisodeSocialClipMutationHookResult = ReturnType<typeof useDeleteEpisodeSocialClipMutation>;
export type DeleteEpisodeSocialClipMutationResult = Apollo.MutationResult<DeleteEpisodeSocialClipMutation>;
export type DeleteEpisodeSocialClipMutationOptions = Apollo.BaseMutationOptions<DeleteEpisodeSocialClipMutation, DeleteEpisodeSocialClipMutationVariables>;
export const DuplicateEpisodeSocialClipDocument = gql`
    mutation DuplicateEpisodeSocialClip($id: ID!, $name: String) {
  duplicateEpisodeSocialClip(id: $id, name: $name) {
    id
  }
}
    `;
export type DuplicateEpisodeSocialClipMutationFn = Apollo.MutationFunction<DuplicateEpisodeSocialClipMutation, DuplicateEpisodeSocialClipMutationVariables>;

/**
 * __useDuplicateEpisodeSocialClipMutation__
 *
 * To run a mutation, you first call `useDuplicateEpisodeSocialClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEpisodeSocialClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEpisodeSocialClipMutation, { data, loading, error }] = useDuplicateEpisodeSocialClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDuplicateEpisodeSocialClipMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateEpisodeSocialClipMutation, DuplicateEpisodeSocialClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateEpisodeSocialClipMutation, DuplicateEpisodeSocialClipMutationVariables>(DuplicateEpisodeSocialClipDocument, options);
      }
export type DuplicateEpisodeSocialClipMutationHookResult = ReturnType<typeof useDuplicateEpisodeSocialClipMutation>;
export type DuplicateEpisodeSocialClipMutationResult = Apollo.MutationResult<DuplicateEpisodeSocialClipMutation>;
export type DuplicateEpisodeSocialClipMutationOptions = Apollo.BaseMutationOptions<DuplicateEpisodeSocialClipMutation, DuplicateEpisodeSocialClipMutationVariables>;
export const RenameEpisodeSocialClipDocument = gql`
    mutation RenameEpisodeSocialClip($id: ID!, $name: String) {
  updateEpisodeSocialClip(id: $id, name: $name) {
    id
    name
    updatedAt
  }
}
    `;
export type RenameEpisodeSocialClipMutationFn = Apollo.MutationFunction<RenameEpisodeSocialClipMutation, RenameEpisodeSocialClipMutationVariables>;

/**
 * __useRenameEpisodeSocialClipMutation__
 *
 * To run a mutation, you first call `useRenameEpisodeSocialClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameEpisodeSocialClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameEpisodeSocialClipMutation, { data, loading, error }] = useRenameEpisodeSocialClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameEpisodeSocialClipMutation(baseOptions?: Apollo.MutationHookOptions<RenameEpisodeSocialClipMutation, RenameEpisodeSocialClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameEpisodeSocialClipMutation, RenameEpisodeSocialClipMutationVariables>(RenameEpisodeSocialClipDocument, options);
      }
export type RenameEpisodeSocialClipMutationHookResult = ReturnType<typeof useRenameEpisodeSocialClipMutation>;
export type RenameEpisodeSocialClipMutationResult = Apollo.MutationResult<RenameEpisodeSocialClipMutation>;
export type RenameEpisodeSocialClipMutationOptions = Apollo.BaseMutationOptions<RenameEpisodeSocialClipMutation, RenameEpisodeSocialClipMutationVariables>;
export const AlituSchedulePublishDocument = gql`
    mutation alituSchedulePublish($episodeId: ID!, $schedulePublishAt: String) {
  alituSchedulePublish(
    episodeId: $episodeId
    schedulePublishAt: $schedulePublishAt
  ) {
    success
  }
}
    `;
export type AlituSchedulePublishMutationFn = Apollo.MutationFunction<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>;

/**
 * __useAlituSchedulePublishMutation__
 *
 * To run a mutation, you first call `useAlituSchedulePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituSchedulePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituSchedulePublishMutation, { data, loading, error }] = useAlituSchedulePublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      schedulePublishAt: // value for 'schedulePublishAt'
 *   },
 * });
 */
export function useAlituSchedulePublishMutation(baseOptions?: Apollo.MutationHookOptions<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>(AlituSchedulePublishDocument, options);
      }
export type AlituSchedulePublishMutationHookResult = ReturnType<typeof useAlituSchedulePublishMutation>;
export type AlituSchedulePublishMutationResult = Apollo.MutationResult<AlituSchedulePublishMutation>;
export type AlituSchedulePublishMutationOptions = Apollo.BaseMutationOptions<AlituSchedulePublishMutation, AlituSchedulePublishMutationVariables>;
export const AlituCancelSchedulePublishDocument = gql`
    mutation alituCancelSchedulePublish($episodeId: ID!) {
  alituCancelSchedulePublish(episodeId: $episodeId) {
    success
  }
}
    `;
export type AlituCancelSchedulePublishMutationFn = Apollo.MutationFunction<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>;

/**
 * __useAlituCancelSchedulePublishMutation__
 *
 * To run a mutation, you first call `useAlituCancelSchedulePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituCancelSchedulePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituCancelSchedulePublishMutation, { data, loading, error }] = useAlituCancelSchedulePublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useAlituCancelSchedulePublishMutation(baseOptions?: Apollo.MutationHookOptions<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>(AlituCancelSchedulePublishDocument, options);
      }
export type AlituCancelSchedulePublishMutationHookResult = ReturnType<typeof useAlituCancelSchedulePublishMutation>;
export type AlituCancelSchedulePublishMutationResult = Apollo.MutationResult<AlituCancelSchedulePublishMutation>;
export type AlituCancelSchedulePublishMutationOptions = Apollo.BaseMutationOptions<AlituCancelSchedulePublishMutation, AlituCancelSchedulePublishMutationVariables>;
export const AlituUpdatePublishedDateDocument = gql`
    mutation alituUpdatePublishedDate($episodeId: ID!, $publishedAt: String!) {
  alituUpdatePublishedDate(episodeId: $episodeId, publishedAt: $publishedAt) {
    success
  }
}
    `;
export type AlituUpdatePublishedDateMutationFn = Apollo.MutationFunction<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>;

/**
 * __useAlituUpdatePublishedDateMutation__
 *
 * To run a mutation, you first call `useAlituUpdatePublishedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituUpdatePublishedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituUpdatePublishedDateMutation, { data, loading, error }] = useAlituUpdatePublishedDateMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      publishedAt: // value for 'publishedAt'
 *   },
 * });
 */
export function useAlituUpdatePublishedDateMutation(baseOptions?: Apollo.MutationHookOptions<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>(AlituUpdatePublishedDateDocument, options);
      }
export type AlituUpdatePublishedDateMutationHookResult = ReturnType<typeof useAlituUpdatePublishedDateMutation>;
export type AlituUpdatePublishedDateMutationResult = Apollo.MutationResult<AlituUpdatePublishedDateMutation>;
export type AlituUpdatePublishedDateMutationOptions = Apollo.BaseMutationOptions<AlituUpdatePublishedDateMutation, AlituUpdatePublishedDateMutationVariables>;
export const GenerateTitlesAndSummariesDocument = gql`
    mutation generateTitlesAndSummaries($episodeId: ID!) {
  generateTitlesAndSummaries(episodeId: $episodeId) {
    jobId
    episode {
      ...EpisodeAllFields
    }
  }
}
    ${EpisodeAllFieldsFragmentDoc}`;
export type GenerateTitlesAndSummariesMutationFn = Apollo.MutationFunction<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>;

/**
 * __useGenerateTitlesAndSummariesMutation__
 *
 * To run a mutation, you first call `useGenerateTitlesAndSummariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTitlesAndSummariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTitlesAndSummariesMutation, { data, loading, error }] = useGenerateTitlesAndSummariesMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGenerateTitlesAndSummariesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>(GenerateTitlesAndSummariesDocument, options);
      }
export type GenerateTitlesAndSummariesMutationHookResult = ReturnType<typeof useGenerateTitlesAndSummariesMutation>;
export type GenerateTitlesAndSummariesMutationResult = Apollo.MutationResult<GenerateTitlesAndSummariesMutation>;
export type GenerateTitlesAndSummariesMutationOptions = Apollo.BaseMutationOptions<GenerateTitlesAndSummariesMutation, GenerateTitlesAndSummariesMutationVariables>;
export const SaveEpisodeSocialClipDocument = gql`
    mutation SaveEpisodeSocialClip($episodeId: ID!, $name: String!, $schema: JSON!) {
  createEpisodeSocialClip(episodeId: $episodeId, name: $name, schema: $schema) {
    id
  }
}
    `;
export type SaveEpisodeSocialClipMutationFn = Apollo.MutationFunction<SaveEpisodeSocialClipMutation, SaveEpisodeSocialClipMutationVariables>;

/**
 * __useSaveEpisodeSocialClipMutation__
 *
 * To run a mutation, you first call `useSaveEpisodeSocialClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEpisodeSocialClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEpisodeSocialClipMutation, { data, loading, error }] = useSaveEpisodeSocialClipMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      name: // value for 'name'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useSaveEpisodeSocialClipMutation(baseOptions?: Apollo.MutationHookOptions<SaveEpisodeSocialClipMutation, SaveEpisodeSocialClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEpisodeSocialClipMutation, SaveEpisodeSocialClipMutationVariables>(SaveEpisodeSocialClipDocument, options);
      }
export type SaveEpisodeSocialClipMutationHookResult = ReturnType<typeof useSaveEpisodeSocialClipMutation>;
export type SaveEpisodeSocialClipMutationResult = Apollo.MutationResult<SaveEpisodeSocialClipMutation>;
export type SaveEpisodeSocialClipMutationOptions = Apollo.BaseMutationOptions<SaveEpisodeSocialClipMutation, SaveEpisodeSocialClipMutationVariables>;
export const UpdateEpisodeSocialClipDocument = gql`
    mutation UpdateEpisodeSocialClip($id: ID!, $name: String, $schema: JSON) {
  updateEpisodeSocialClip(id: $id, name: $name, schema: $schema) {
    id
  }
}
    `;
export type UpdateEpisodeSocialClipMutationFn = Apollo.MutationFunction<UpdateEpisodeSocialClipMutation, UpdateEpisodeSocialClipMutationVariables>;

/**
 * __useUpdateEpisodeSocialClipMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeSocialClipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeSocialClipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeSocialClipMutation, { data, loading, error }] = useUpdateEpisodeSocialClipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useUpdateEpisodeSocialClipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeSocialClipMutation, UpdateEpisodeSocialClipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeSocialClipMutation, UpdateEpisodeSocialClipMutationVariables>(UpdateEpisodeSocialClipDocument, options);
      }
export type UpdateEpisodeSocialClipMutationHookResult = ReturnType<typeof useUpdateEpisodeSocialClipMutation>;
export type UpdateEpisodeSocialClipMutationResult = Apollo.MutationResult<UpdateEpisodeSocialClipMutation>;
export type UpdateEpisodeSocialClipMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeSocialClipMutation, UpdateEpisodeSocialClipMutationVariables>;
export const CreateEpisodeSocialClipVideoJobDocument = gql`
    mutation CreateEpisodeSocialClipVideoJob($id: ID!, $name: String, $schema: JSON) {
  createEpisodeSocialClipVideoJob(id: $id, name: $name, schema: $schema) {
    id
    state
    job {
      id
      status
      progress
    }
  }
}
    `;
export type CreateEpisodeSocialClipVideoJobMutationFn = Apollo.MutationFunction<CreateEpisodeSocialClipVideoJobMutation, CreateEpisodeSocialClipVideoJobMutationVariables>;

/**
 * __useCreateEpisodeSocialClipVideoJobMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeSocialClipVideoJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeSocialClipVideoJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeSocialClipVideoJobMutation, { data, loading, error }] = useCreateEpisodeSocialClipVideoJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateEpisodeSocialClipVideoJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpisodeSocialClipVideoJobMutation, CreateEpisodeSocialClipVideoJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpisodeSocialClipVideoJobMutation, CreateEpisodeSocialClipVideoJobMutationVariables>(CreateEpisodeSocialClipVideoJobDocument, options);
      }
export type CreateEpisodeSocialClipVideoJobMutationHookResult = ReturnType<typeof useCreateEpisodeSocialClipVideoJobMutation>;
export type CreateEpisodeSocialClipVideoJobMutationResult = Apollo.MutationResult<CreateEpisodeSocialClipVideoJobMutation>;
export type CreateEpisodeSocialClipVideoJobMutationOptions = Apollo.BaseMutationOptions<CreateEpisodeSocialClipVideoJobMutation, CreateEpisodeSocialClipVideoJobMutationVariables>;
export const CreateEpisodeSocialClipAudioJobDocument = gql`
    mutation CreateEpisodeSocialClipAudioJob($id: ID!, $name: String, $schema: JSON) {
  createEpisodeSocialClipAudioJob(id: $id, name: $name, schema: $schema) {
    id
    state
    job {
      id
      status
      progress
    }
  }
}
    `;
export type CreateEpisodeSocialClipAudioJobMutationFn = Apollo.MutationFunction<CreateEpisodeSocialClipAudioJobMutation, CreateEpisodeSocialClipAudioJobMutationVariables>;

/**
 * __useCreateEpisodeSocialClipAudioJobMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeSocialClipAudioJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeSocialClipAudioJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeSocialClipAudioJobMutation, { data, loading, error }] = useCreateEpisodeSocialClipAudioJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      schema: // value for 'schema'
 *   },
 * });
 */
export function useCreateEpisodeSocialClipAudioJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpisodeSocialClipAudioJobMutation, CreateEpisodeSocialClipAudioJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpisodeSocialClipAudioJobMutation, CreateEpisodeSocialClipAudioJobMutationVariables>(CreateEpisodeSocialClipAudioJobDocument, options);
      }
export type CreateEpisodeSocialClipAudioJobMutationHookResult = ReturnType<typeof useCreateEpisodeSocialClipAudioJobMutation>;
export type CreateEpisodeSocialClipAudioJobMutationResult = Apollo.MutationResult<CreateEpisodeSocialClipAudioJobMutation>;
export type CreateEpisodeSocialClipAudioJobMutationOptions = Apollo.BaseMutationOptions<CreateEpisodeSocialClipAudioJobMutation, CreateEpisodeSocialClipAudioJobMutationVariables>;
export const SaveShowColorSwatchDocument = gql`
    mutation SaveShowColorSwatch($showId: ID!, $color: String!) {
  saveShowColorSwatch(showId: $showId, color: $color) {
    id
    showColorSwatches
  }
}
    `;
export type SaveShowColorSwatchMutationFn = Apollo.MutationFunction<SaveShowColorSwatchMutation, SaveShowColorSwatchMutationVariables>;

/**
 * __useSaveShowColorSwatchMutation__
 *
 * To run a mutation, you first call `useSaveShowColorSwatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveShowColorSwatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveShowColorSwatchMutation, { data, loading, error }] = useSaveShowColorSwatchMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useSaveShowColorSwatchMutation(baseOptions?: Apollo.MutationHookOptions<SaveShowColorSwatchMutation, SaveShowColorSwatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveShowColorSwatchMutation, SaveShowColorSwatchMutationVariables>(SaveShowColorSwatchDocument, options);
      }
export type SaveShowColorSwatchMutationHookResult = ReturnType<typeof useSaveShowColorSwatchMutation>;
export type SaveShowColorSwatchMutationResult = Apollo.MutationResult<SaveShowColorSwatchMutation>;
export type SaveShowColorSwatchMutationOptions = Apollo.BaseMutationOptions<SaveShowColorSwatchMutation, SaveShowColorSwatchMutationVariables>;
export const DeleteShowColorSwatchDocument = gql`
    mutation DeleteShowColorSwatch($showId: ID!, $color: String!) {
  deleteShowColorSwatch(showId: $showId, color: $color) {
    id
    showColorSwatches
  }
}
    `;
export type DeleteShowColorSwatchMutationFn = Apollo.MutationFunction<DeleteShowColorSwatchMutation, DeleteShowColorSwatchMutationVariables>;

/**
 * __useDeleteShowColorSwatchMutation__
 *
 * To run a mutation, you first call `useDeleteShowColorSwatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShowColorSwatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShowColorSwatchMutation, { data, loading, error }] = useDeleteShowColorSwatchMutation({
 *   variables: {
 *      showId: // value for 'showId'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useDeleteShowColorSwatchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShowColorSwatchMutation, DeleteShowColorSwatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShowColorSwatchMutation, DeleteShowColorSwatchMutationVariables>(DeleteShowColorSwatchDocument, options);
      }
export type DeleteShowColorSwatchMutationHookResult = ReturnType<typeof useDeleteShowColorSwatchMutation>;
export type DeleteShowColorSwatchMutationResult = Apollo.MutationResult<DeleteShowColorSwatchMutation>;
export type DeleteShowColorSwatchMutationOptions = Apollo.BaseMutationOptions<DeleteShowColorSwatchMutation, DeleteShowColorSwatchMutationVariables>;
export const HostTokenDocument = gql`
    query hostToken($hostTokenInput: HostInput!) {
  hostToken(input: $hostTokenInput) {
    token
  }
}
    `;

/**
 * __useHostTokenQuery__
 *
 * To run a query within a React component, call `useHostTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostTokenQuery({
 *   variables: {
 *      hostTokenInput: // value for 'hostTokenInput'
 *   },
 * });
 */
export function useHostTokenQuery(baseOptions: Apollo.QueryHookOptions<HostTokenQuery, HostTokenQueryVariables> & ({ variables: HostTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
      }
export function useHostTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
        }
// @ts-ignore
export function useHostTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>): Apollo.UseSuspenseQueryResult<HostTokenQuery, HostTokenQueryVariables>;
export function useHostTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>): Apollo.UseSuspenseQueryResult<HostTokenQuery | undefined, HostTokenQueryVariables>;
export function useHostTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HostTokenQuery, HostTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HostTokenQuery, HostTokenQueryVariables>(HostTokenDocument, options);
        }
export type HostTokenQueryHookResult = ReturnType<typeof useHostTokenQuery>;
export type HostTokenLazyQueryHookResult = ReturnType<typeof useHostTokenLazyQuery>;
export type HostTokenSuspenseQueryHookResult = ReturnType<typeof useHostTokenSuspenseQuery>;
export type HostTokenQueryResult = Apollo.QueryResult<HostTokenQuery, HostTokenQueryVariables>;
export const PublishPageDocument = gql`
    query publishPage($episodeId: ID!, $projectId: ID!) {
  host
  episode(id: $episodeId) {
    id
    guid
    metaData {
      ...MetaData
    }
    file {
      id
      chapters {
        title
        start
      }
      codecInformation {
        format {
          duration
        }
      }
      audioJob {
        id
        status
        progress
      }
      videoJob {
        id
        status
        progress
      }
      transcriptionJob {
        id
        status
        progress
      }
      aiJob {
        id
        status
        progress
      }
      metaDataJob {
        id
        status
        schema
        progress
      }
    }
    version
    videoMode
    artworkUrl
    hasArtwork
    publishedAt
    schedulePublishAt
    host
    shouldSuggestTitle
    shouldSuggestDescription
    shouldIncludeTranscriptInRss
    metaDataNeedsReprocessing
  }
  show(id: $projectId) {
    id
    subdomain
    redirectUrl
    artworkUrl
    showColorSwatches
  }
}
    ${MetaDataFragmentDoc}`;

/**
 * __usePublishPageQuery__
 *
 * To run a query within a React component, call `usePublishPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishPageQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishPageQuery(baseOptions: Apollo.QueryHookOptions<PublishPageQuery, PublishPageQueryVariables> & ({ variables: PublishPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
      }
export function usePublishPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
        }
// @ts-ignore
export function usePublishPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>): Apollo.UseSuspenseQueryResult<PublishPageQuery, PublishPageQueryVariables>;
export function usePublishPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>): Apollo.UseSuspenseQueryResult<PublishPageQuery | undefined, PublishPageQueryVariables>;
export function usePublishPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishPageQuery, PublishPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishPageQuery, PublishPageQueryVariables>(PublishPageDocument, options);
        }
export type PublishPageQueryHookResult = ReturnType<typeof usePublishPageQuery>;
export type PublishPageLazyQueryHookResult = ReturnType<typeof usePublishPageLazyQuery>;
export type PublishPageSuspenseQueryHookResult = ReturnType<typeof usePublishPageSuspenseQuery>;
export type PublishPageQueryResult = Apollo.QueryResult<PublishPageQuery, PublishPageQueryVariables>;
export const AlituHostLoginDocument = gql`
    mutation alituHostLogin {
  alituHostLogin: connectAlituHost {
    success
    show {
      ...ShowFragment
    }
  }
}
    ${ShowFragmentFragmentDoc}`;
export type AlituHostLoginMutationFn = Apollo.MutationFunction<AlituHostLoginMutation, AlituHostLoginMutationVariables>;

/**
 * __useAlituHostLoginMutation__
 *
 * To run a mutation, you first call `useAlituHostLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlituHostLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alituHostLoginMutation, { data, loading, error }] = useAlituHostLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useAlituHostLoginMutation(baseOptions?: Apollo.MutationHookOptions<AlituHostLoginMutation, AlituHostLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlituHostLoginMutation, AlituHostLoginMutationVariables>(AlituHostLoginDocument, options);
      }
export type AlituHostLoginMutationHookResult = ReturnType<typeof useAlituHostLoginMutation>;
export type AlituHostLoginMutationResult = Apollo.MutationResult<AlituHostLoginMutation>;
export type AlituHostLoginMutationOptions = Apollo.BaseMutationOptions<AlituHostLoginMutation, AlituHostLoginMutationVariables>;
export const CaptivateLoginDocument = gql`
    mutation captivateLogin($username: String!, $apiKey: String!) {
  captivateLogin(username: $username, apiKey: $apiKey) {
    token
  }
}
    `;
export type CaptivateLoginMutationFn = Apollo.MutationFunction<CaptivateLoginMutation, CaptivateLoginMutationVariables>;

/**
 * __useCaptivateLoginMutation__
 *
 * To run a mutation, you first call `useCaptivateLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptivateLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captivateLoginMutation, { data, loading, error }] = useCaptivateLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useCaptivateLoginMutation(baseOptions?: Apollo.MutationHookOptions<CaptivateLoginMutation, CaptivateLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptivateLoginMutation, CaptivateLoginMutationVariables>(CaptivateLoginDocument, options);
      }
export type CaptivateLoginMutationHookResult = ReturnType<typeof useCaptivateLoginMutation>;
export type CaptivateLoginMutationResult = Apollo.MutationResult<CaptivateLoginMutation>;
export type CaptivateLoginMutationOptions = Apollo.BaseMutationOptions<CaptivateLoginMutation, CaptivateLoginMutationVariables>;
export const TransistorLoginDocument = gql`
    mutation transistorLogin($token: ID!) {
  transistorLogin(token: $token) {
    isTokenValid
  }
}
    `;
export type TransistorLoginMutationFn = Apollo.MutationFunction<TransistorLoginMutation, TransistorLoginMutationVariables>;

/**
 * __useTransistorLoginMutation__
 *
 * To run a mutation, you first call `useTransistorLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransistorLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transistorLoginMutation, { data, loading, error }] = useTransistorLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useTransistorLoginMutation(baseOptions?: Apollo.MutationHookOptions<TransistorLoginMutation, TransistorLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransistorLoginMutation, TransistorLoginMutationVariables>(TransistorLoginDocument, options);
      }
export type TransistorLoginMutationHookResult = ReturnType<typeof useTransistorLoginMutation>;
export type TransistorLoginMutationResult = Apollo.MutationResult<TransistorLoginMutation>;
export type TransistorLoginMutationOptions = Apollo.BaseMutationOptions<TransistorLoginMutation, TransistorLoginMutationVariables>;
export const BuzzsproutLoginDocument = gql`
    mutation buzzsproutLogin($podcastId: ID!, $token: ID!) {
  buzzsproutLogin(podcastId: $podcastId, token: $token) {
    success
  }
}
    `;
export type BuzzsproutLoginMutationFn = Apollo.MutationFunction<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>;

/**
 * __useBuzzsproutLoginMutation__
 *
 * To run a mutation, you first call `useBuzzsproutLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuzzsproutLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buzzsproutLoginMutation, { data, loading, error }] = useBuzzsproutLoginMutation({
 *   variables: {
 *      podcastId: // value for 'podcastId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBuzzsproutLoginMutation(baseOptions?: Apollo.MutationHookOptions<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>(BuzzsproutLoginDocument, options);
      }
export type BuzzsproutLoginMutationHookResult = ReturnType<typeof useBuzzsproutLoginMutation>;
export type BuzzsproutLoginMutationResult = Apollo.MutationResult<BuzzsproutLoginMutation>;
export type BuzzsproutLoginMutationOptions = Apollo.BaseMutationOptions<BuzzsproutLoginMutation, BuzzsproutLoginMutationVariables>;
export const CastosLoginDocument = gql`
    mutation castosLogin($token: ID!) {
  castosLogin(token: $token) {
    isTokenValid
  }
}
    `;
export type CastosLoginMutationFn = Apollo.MutationFunction<CastosLoginMutation, CastosLoginMutationVariables>;

/**
 * __useCastosLoginMutation__
 *
 * To run a mutation, you first call `useCastosLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCastosLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [castosLoginMutation, { data, loading, error }] = useCastosLoginMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCastosLoginMutation(baseOptions?: Apollo.MutationHookOptions<CastosLoginMutation, CastosLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CastosLoginMutation, CastosLoginMutationVariables>(CastosLoginDocument, options);
      }
export type CastosLoginMutationHookResult = ReturnType<typeof useCastosLoginMutation>;
export type CastosLoginMutationResult = Apollo.MutationResult<CastosLoginMutation>;
export type CastosLoginMutationOptions = Apollo.BaseMutationOptions<CastosLoginMutation, CastosLoginMutationVariables>;
export const CaptivatePublishDocument = gql`
    mutation captivatePublish($episodeId: ID!, $isDraft: Boolean!, $captivateShow: CaptivateShow!) {
  captivatePublish(
    episodeId: $episodeId
    isDraft: $isDraft
    captivateShow: $captivateShow
  ) {
    success
    errorCode
  }
}
    `;
export type CaptivatePublishMutationFn = Apollo.MutationFunction<CaptivatePublishMutation, CaptivatePublishMutationVariables>;

/**
 * __useCaptivatePublishMutation__
 *
 * To run a mutation, you first call `useCaptivatePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptivatePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captivatePublishMutation, { data, loading, error }] = useCaptivatePublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      isDraft: // value for 'isDraft'
 *      captivateShow: // value for 'captivateShow'
 *   },
 * });
 */
export function useCaptivatePublishMutation(baseOptions?: Apollo.MutationHookOptions<CaptivatePublishMutation, CaptivatePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CaptivatePublishMutation, CaptivatePublishMutationVariables>(CaptivatePublishDocument, options);
      }
export type CaptivatePublishMutationHookResult = ReturnType<typeof useCaptivatePublishMutation>;
export type CaptivatePublishMutationResult = Apollo.MutationResult<CaptivatePublishMutation>;
export type CaptivatePublishMutationOptions = Apollo.BaseMutationOptions<CaptivatePublishMutation, CaptivatePublishMutationVariables>;
export const CaptivateShowsDocument = gql`
    query captivateShows {
  shows: captivateShows {
    id
    title
    timeZone
    feedUrl
  }
}
    `;

/**
 * __useCaptivateShowsQuery__
 *
 * To run a query within a React component, call `useCaptivateShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaptivateShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaptivateShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCaptivateShowsQuery(baseOptions?: Apollo.QueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
      }
export function useCaptivateShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
        }
// @ts-ignore
export function useCaptivateShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>): Apollo.UseSuspenseQueryResult<CaptivateShowsQuery, CaptivateShowsQueryVariables>;
export function useCaptivateShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>): Apollo.UseSuspenseQueryResult<CaptivateShowsQuery | undefined, CaptivateShowsQueryVariables>;
export function useCaptivateShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaptivateShowsQuery, CaptivateShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaptivateShowsQuery, CaptivateShowsQueryVariables>(CaptivateShowsDocument, options);
        }
export type CaptivateShowsQueryHookResult = ReturnType<typeof useCaptivateShowsQuery>;
export type CaptivateShowsLazyQueryHookResult = ReturnType<typeof useCaptivateShowsLazyQuery>;
export type CaptivateShowsSuspenseQueryHookResult = ReturnType<typeof useCaptivateShowsSuspenseQuery>;
export type CaptivateShowsQueryResult = Apollo.QueryResult<CaptivateShowsQuery, CaptivateShowsQueryVariables>;
export const CreateVideoJobDocument = gql`
    mutation createVideoJob($episodeId: ID!, $waveform: VideoWaveformInput) {
  createVideoJob(episodeId: $episodeId, waveform: $waveform) {
    id
  }
}
    `;
export type CreateVideoJobMutationFn = Apollo.MutationFunction<CreateVideoJobMutation, CreateVideoJobMutationVariables>;

/**
 * __useCreateVideoJobMutation__
 *
 * To run a mutation, you first call `useCreateVideoJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoJobMutation, { data, loading, error }] = useCreateVideoJobMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      waveform: // value for 'waveform'
 *   },
 * });
 */
export function useCreateVideoJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoJobMutation, CreateVideoJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoJobMutation, CreateVideoJobMutationVariables>(CreateVideoJobDocument, options);
      }
export type CreateVideoJobMutationHookResult = ReturnType<typeof useCreateVideoJobMutation>;
export type CreateVideoJobMutationResult = Apollo.MutationResult<CreateVideoJobMutation>;
export type CreateVideoJobMutationOptions = Apollo.BaseMutationOptions<CreateVideoJobMutation, CreateVideoJobMutationVariables>;
export const CastosPodcastsDocument = gql`
    query castosPodcasts {
  podcasts: castosPodcasts {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useCastosPodcastsQuery__
 *
 * To run a query within a React component, call `useCastosPodcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCastosPodcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCastosPodcastsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCastosPodcastsQuery(baseOptions?: Apollo.QueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
      }
export function useCastosPodcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
        }
// @ts-ignore
export function useCastosPodcastsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>): Apollo.UseSuspenseQueryResult<CastosPodcastsQuery, CastosPodcastsQueryVariables>;
export function useCastosPodcastsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>): Apollo.UseSuspenseQueryResult<CastosPodcastsQuery | undefined, CastosPodcastsQueryVariables>;
export function useCastosPodcastsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CastosPodcastsQuery, CastosPodcastsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CastosPodcastsQuery, CastosPodcastsQueryVariables>(CastosPodcastsDocument, options);
        }
export type CastosPodcastsQueryHookResult = ReturnType<typeof useCastosPodcastsQuery>;
export type CastosPodcastsLazyQueryHookResult = ReturnType<typeof useCastosPodcastsLazyQuery>;
export type CastosPodcastsSuspenseQueryHookResult = ReturnType<typeof useCastosPodcastsSuspenseQuery>;
export type CastosPodcastsQueryResult = Apollo.QueryResult<CastosPodcastsQuery, CastosPodcastsQueryVariables>;
export const CastosPublishDocument = gql`
    mutation castosPublish($episodeId: ID!, $podcastId: ID!) {
  publish: castosPublish(episodeId: $episodeId, podcastId: $podcastId) {
    success
  }
}
    `;
export type CastosPublishMutationFn = Apollo.MutationFunction<CastosPublishMutation, CastosPublishMutationVariables>;

/**
 * __useCastosPublishMutation__
 *
 * To run a mutation, you first call `useCastosPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCastosPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [castosPublishMutation, { data, loading, error }] = useCastosPublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      podcastId: // value for 'podcastId'
 *   },
 * });
 */
export function useCastosPublishMutation(baseOptions?: Apollo.MutationHookOptions<CastosPublishMutation, CastosPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CastosPublishMutation, CastosPublishMutationVariables>(CastosPublishDocument, options);
      }
export type CastosPublishMutationHookResult = ReturnType<typeof useCastosPublishMutation>;
export type CastosPublishMutationResult = Apollo.MutationResult<CastosPublishMutation>;
export type CastosPublishMutationOptions = Apollo.BaseMutationOptions<CastosPublishMutation, CastosPublishMutationVariables>;
export const TransistorShowsDocument = gql`
    query transistorShows {
  shows: transistorShows {
    id
    title
    description
    feedUrl
  }
}
    `;

/**
 * __useTransistorShowsQuery__
 *
 * To run a query within a React component, call `useTransistorShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransistorShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransistorShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransistorShowsQuery(baseOptions?: Apollo.QueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
      }
export function useTransistorShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
        }
// @ts-ignore
export function useTransistorShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>): Apollo.UseSuspenseQueryResult<TransistorShowsQuery, TransistorShowsQueryVariables>;
export function useTransistorShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>): Apollo.UseSuspenseQueryResult<TransistorShowsQuery | undefined, TransistorShowsQueryVariables>;
export function useTransistorShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransistorShowsQuery, TransistorShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransistorShowsQuery, TransistorShowsQueryVariables>(TransistorShowsDocument, options);
        }
export type TransistorShowsQueryHookResult = ReturnType<typeof useTransistorShowsQuery>;
export type TransistorShowsLazyQueryHookResult = ReturnType<typeof useTransistorShowsLazyQuery>;
export type TransistorShowsSuspenseQueryHookResult = ReturnType<typeof useTransistorShowsSuspenseQuery>;
export type TransistorShowsQueryResult = Apollo.QueryResult<TransistorShowsQuery, TransistorShowsQueryVariables>;
export const TransistorPublishDocument = gql`
    mutation transistorPublish($episodeId: ID!, $showId: ID!, $isDraft: Boolean!) {
  publish: transistorPublish(
    episodeId: $episodeId
    showId: $showId
    isDraft: $isDraft
  ) {
    success
  }
}
    `;
export type TransistorPublishMutationFn = Apollo.MutationFunction<TransistorPublishMutation, TransistorPublishMutationVariables>;

/**
 * __useTransistorPublishMutation__
 *
 * To run a mutation, you first call `useTransistorPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransistorPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transistorPublishMutation, { data, loading, error }] = useTransistorPublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      showId: // value for 'showId'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useTransistorPublishMutation(baseOptions?: Apollo.MutationHookOptions<TransistorPublishMutation, TransistorPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransistorPublishMutation, TransistorPublishMutationVariables>(TransistorPublishDocument, options);
      }
export type TransistorPublishMutationHookResult = ReturnType<typeof useTransistorPublishMutation>;
export type TransistorPublishMutationResult = Apollo.MutationResult<TransistorPublishMutation>;
export type TransistorPublishMutationOptions = Apollo.BaseMutationOptions<TransistorPublishMutation, TransistorPublishMutationVariables>;
export const SpreakerShowsDocument = gql`
    query spreakerShows {
  shows: getSpreakerShows {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useSpreakerShowsQuery__
 *
 * To run a query within a React component, call `useSpreakerShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpreakerShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpreakerShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpreakerShowsQuery(baseOptions?: Apollo.QueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
      }
export function useSpreakerShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
        }
// @ts-ignore
export function useSpreakerShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>): Apollo.UseSuspenseQueryResult<SpreakerShowsQuery, SpreakerShowsQueryVariables>;
export function useSpreakerShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>): Apollo.UseSuspenseQueryResult<SpreakerShowsQuery | undefined, SpreakerShowsQueryVariables>;
export function useSpreakerShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpreakerShowsQuery, SpreakerShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpreakerShowsQuery, SpreakerShowsQueryVariables>(SpreakerShowsDocument, options);
        }
export type SpreakerShowsQueryHookResult = ReturnType<typeof useSpreakerShowsQuery>;
export type SpreakerShowsLazyQueryHookResult = ReturnType<typeof useSpreakerShowsLazyQuery>;
export type SpreakerShowsSuspenseQueryHookResult = ReturnType<typeof useSpreakerShowsSuspenseQuery>;
export type SpreakerShowsQueryResult = Apollo.QueryResult<SpreakerShowsQuery, SpreakerShowsQueryVariables>;
export const SpreakerPublishDocument = gql`
    mutation spreakerPublish($episodeId: ID!, $additional: SpreakerAdditionalInput!) {
  publish: spreakerPublish(episodeId: $episodeId, additional: $additional) {
    success
    errorCode
  }
}
    `;
export type SpreakerPublishMutationFn = Apollo.MutationFunction<SpreakerPublishMutation, SpreakerPublishMutationVariables>;

/**
 * __useSpreakerPublishMutation__
 *
 * To run a mutation, you first call `useSpreakerPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpreakerPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [spreakerPublishMutation, { data, loading, error }] = useSpreakerPublishMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      additional: // value for 'additional'
 *   },
 * });
 */
export function useSpreakerPublishMutation(baseOptions?: Apollo.MutationHookOptions<SpreakerPublishMutation, SpreakerPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SpreakerPublishMutation, SpreakerPublishMutationVariables>(SpreakerPublishDocument, options);
      }
export type SpreakerPublishMutationHookResult = ReturnType<typeof useSpreakerPublishMutation>;
export type SpreakerPublishMutationResult = Apollo.MutationResult<SpreakerPublishMutation>;
export type SpreakerPublishMutationOptions = Apollo.BaseMutationOptions<SpreakerPublishMutation, SpreakerPublishMutationVariables>;
export const LibsynShowsDocument = gql`
    query libsynShows {
  shows: getLibsynShows {
    id
    title
    feedUrl
  }
}
    `;

/**
 * __useLibsynShowsQuery__
 *
 * To run a query within a React component, call `useLibsynShowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibsynShowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibsynShowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLibsynShowsQuery(baseOptions?: Apollo.QueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
      }
export function useLibsynShowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
        }
// @ts-ignore
export function useLibsynShowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>): Apollo.UseSuspenseQueryResult<LibsynShowsQuery, LibsynShowsQueryVariables>;
export function useLibsynShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>): Apollo.UseSuspenseQueryResult<LibsynShowsQuery | undefined, LibsynShowsQueryVariables>;
export function useLibsynShowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LibsynShowsQuery, LibsynShowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LibsynShowsQuery, LibsynShowsQueryVariables>(LibsynShowsDocument, options);
        }
export type LibsynShowsQueryHookResult = ReturnType<typeof useLibsynShowsQuery>;
export type LibsynShowsLazyQueryHookResult = ReturnType<typeof useLibsynShowsLazyQuery>;
export type LibsynShowsSuspenseQueryHookResult = ReturnType<typeof useLibsynShowsSuspenseQuery>;
export type LibsynShowsQueryResult = Apollo.QueryResult<LibsynShowsQuery, LibsynShowsQueryVariables>;
export const LibsynPublishDocument = gql`
    mutation libsynPublish($additional: LibsynUploadAdditional!, $episodeId: ID!) {
  publish: libsynPublish(additional: $additional, episodeId: $episodeId) {
    success
    errorCode
  }
}
    `;
export type LibsynPublishMutationFn = Apollo.MutationFunction<LibsynPublishMutation, LibsynPublishMutationVariables>;

/**
 * __useLibsynPublishMutation__
 *
 * To run a mutation, you first call `useLibsynPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLibsynPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [libsynPublishMutation, { data, loading, error }] = useLibsynPublishMutation({
 *   variables: {
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useLibsynPublishMutation(baseOptions?: Apollo.MutationHookOptions<LibsynPublishMutation, LibsynPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LibsynPublishMutation, LibsynPublishMutationVariables>(LibsynPublishDocument, options);
      }
export type LibsynPublishMutationHookResult = ReturnType<typeof useLibsynPublishMutation>;
export type LibsynPublishMutationResult = Apollo.MutationResult<LibsynPublishMutation>;
export type LibsynPublishMutationOptions = Apollo.BaseMutationOptions<LibsynPublishMutation, LibsynPublishMutationVariables>;
export const PodbeanPublishDocument = gql`
    mutation podbeanPublish($additional: PodbeanAdditional!, $episodeId: ID!) {
  publish: podbeanPublish(additional: $additional, episodeId: $episodeId) {
    success
    errorCode
  }
}
    `;
export type PodbeanPublishMutationFn = Apollo.MutationFunction<PodbeanPublishMutation, PodbeanPublishMutationVariables>;

/**
 * __usePodbeanPublishMutation__
 *
 * To run a mutation, you first call `usePodbeanPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePodbeanPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [podbeanPublishMutation, { data, loading, error }] = usePodbeanPublishMutation({
 *   variables: {
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function usePodbeanPublishMutation(baseOptions?: Apollo.MutationHookOptions<PodbeanPublishMutation, PodbeanPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PodbeanPublishMutation, PodbeanPublishMutationVariables>(PodbeanPublishDocument, options);
      }
export type PodbeanPublishMutationHookResult = ReturnType<typeof usePodbeanPublishMutation>;
export type PodbeanPublishMutationResult = Apollo.MutationResult<PodbeanPublishMutation>;
export type PodbeanPublishMutationOptions = Apollo.BaseMutationOptions<PodbeanPublishMutation, PodbeanPublishMutationVariables>;
export const BuzzsproutPublishDocument = gql`
    mutation buzzsproutPublish($additional: AdditionalInput!, $episodeId: ID!) {
  publish: buzzsproutPublish(additional: $additional, episodeId: $episodeId) {
    success
    errorCode
  }
}
    `;
export type BuzzsproutPublishMutationFn = Apollo.MutationFunction<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>;

/**
 * __useBuzzsproutPublishMutation__
 *
 * To run a mutation, you first call `useBuzzsproutPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuzzsproutPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buzzsproutPublishMutation, { data, loading, error }] = useBuzzsproutPublishMutation({
 *   variables: {
 *      additional: // value for 'additional'
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useBuzzsproutPublishMutation(baseOptions?: Apollo.MutationHookOptions<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>(BuzzsproutPublishDocument, options);
      }
export type BuzzsproutPublishMutationHookResult = ReturnType<typeof useBuzzsproutPublishMutation>;
export type BuzzsproutPublishMutationResult = Apollo.MutationResult<BuzzsproutPublishMutation>;
export type BuzzsproutPublishMutationOptions = Apollo.BaseMutationOptions<BuzzsproutPublishMutation, BuzzsproutPublishMutationVariables>;
export const EpisodeJobStatusDocument = gql`
    query episodeJobStatus($id: ID!) {
  episodeJobStatus: episode(id: $id) {
    id
    file {
      id
      audioJob {
        id
        status
        schema
        progress
      }
      videoJob {
        id
        status
        progress
      }
      transcriptionJob {
        id
        status
        progress
      }
      aiJob {
        id
        status
        progress
      }
      metaDataJob {
        id
        status
        progress
      }
    }
  }
}
    `;

/**
 * __useEpisodeJobStatusQuery__
 *
 * To run a query within a React component, call `useEpisodeJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeJobStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEpisodeJobStatusQuery(baseOptions: Apollo.QueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables> & ({ variables: EpisodeJobStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
      }
export function useEpisodeJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
        }
// @ts-ignore
export function useEpisodeJobStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>;
export function useEpisodeJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeJobStatusQuery | undefined, EpisodeJobStatusQueryVariables>;
export function useEpisodeJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>(EpisodeJobStatusDocument, options);
        }
export type EpisodeJobStatusQueryHookResult = ReturnType<typeof useEpisodeJobStatusQuery>;
export type EpisodeJobStatusLazyQueryHookResult = ReturnType<typeof useEpisodeJobStatusLazyQuery>;
export type EpisodeJobStatusSuspenseQueryHookResult = ReturnType<typeof useEpisodeJobStatusSuspenseQuery>;
export type EpisodeJobStatusQueryResult = Apollo.QueryResult<EpisodeJobStatusQuery, EpisodeJobStatusQueryVariables>;
export const PublishToAlituDocument = gql`
    mutation publishToAlitu($episodeId: ID!) {
  alituPublish(episodeId: $episodeId) {
    success
  }
}
    `;
export type PublishToAlituMutationFn = Apollo.MutationFunction<PublishToAlituMutation, PublishToAlituMutationVariables>;

/**
 * __usePublishToAlituMutation__
 *
 * To run a mutation, you first call `usePublishToAlituMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishToAlituMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishToAlituMutation, { data, loading, error }] = usePublishToAlituMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function usePublishToAlituMutation(baseOptions?: Apollo.MutationHookOptions<PublishToAlituMutation, PublishToAlituMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishToAlituMutation, PublishToAlituMutationVariables>(PublishToAlituDocument, options);
      }
export type PublishToAlituMutationHookResult = ReturnType<typeof usePublishToAlituMutation>;
export type PublishToAlituMutationResult = Apollo.MutationResult<PublishToAlituMutation>;
export type PublishToAlituMutationOptions = Apollo.BaseMutationOptions<PublishToAlituMutation, PublishToAlituMutationVariables>;
export const UnpublishFromAlituDocument = gql`
    mutation unpublishFromAlitu($episodeId: ID!) {
  alituUnpublish(episodeId: $episodeId) {
    success
  }
}
    `;
export type UnpublishFromAlituMutationFn = Apollo.MutationFunction<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>;

/**
 * __useUnpublishFromAlituMutation__
 *
 * To run a mutation, you first call `useUnpublishFromAlituMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishFromAlituMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishFromAlituMutation, { data, loading, error }] = useUnpublishFromAlituMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useUnpublishFromAlituMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>(UnpublishFromAlituDocument, options);
      }
export type UnpublishFromAlituMutationHookResult = ReturnType<typeof useUnpublishFromAlituMutation>;
export type UnpublishFromAlituMutationResult = Apollo.MutationResult<UnpublishFromAlituMutation>;
export type UnpublishFromAlituMutationOptions = Apollo.BaseMutationOptions<UnpublishFromAlituMutation, UnpublishFromAlituMutationVariables>;
export const TranscriptionDocument = gql`
    query transcription($fileId: ID!) {
  transcription(fileId: $fileId) {
    id
    fileId
    speakerNames
    createdAt
    status
  }
}
    `;

/**
 * __useTranscriptionQuery__
 *
 * To run a query within a React component, call `useTranscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useTranscriptionQuery(baseOptions: Apollo.QueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables> & ({ variables: TranscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
      }
export function useTranscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
        }
// @ts-ignore
export function useTranscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<TranscriptionQuery, TranscriptionQueryVariables>;
export function useTranscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>): Apollo.UseSuspenseQueryResult<TranscriptionQuery | undefined, TranscriptionQueryVariables>;
export function useTranscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranscriptionQuery, TranscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranscriptionQuery, TranscriptionQueryVariables>(TranscriptionDocument, options);
        }
export type TranscriptionQueryHookResult = ReturnType<typeof useTranscriptionQuery>;
export type TranscriptionLazyQueryHookResult = ReturnType<typeof useTranscriptionLazyQuery>;
export type TranscriptionSuspenseQueryHookResult = ReturnType<typeof useTranscriptionSuspenseQuery>;
export type TranscriptionQueryResult = Apollo.QueryResult<TranscriptionQuery, TranscriptionQueryVariables>;
export const UpdateTranscriptionDocument = gql`
    mutation updateTranscription($fileId: ID!, $speakerNames: [String!]!) {
  updateTranscription(fileId: $fileId, speakerNames: $speakerNames) {
    id
    fileId
    speakerNames
  }
}
    `;
export type UpdateTranscriptionMutationFn = Apollo.MutationFunction<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>;

/**
 * __useUpdateTranscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptionMutation, { data, loading, error }] = useUpdateTranscriptionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      speakerNames: // value for 'speakerNames'
 *   },
 * });
 */
export function useUpdateTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>(UpdateTranscriptionDocument, options);
      }
export type UpdateTranscriptionMutationHookResult = ReturnType<typeof useUpdateTranscriptionMutation>;
export type UpdateTranscriptionMutationResult = Apollo.MutationResult<UpdateTranscriptionMutation>;
export type UpdateTranscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTranscriptionMutation, UpdateTranscriptionMutationVariables>;
export const CustomerDocument = gql`
    query customer {
  customer {
    currency
    address {
      country
      postal_code
    }
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
// @ts-ignore
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerQuery, CustomerQueryVariables>;
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerQuery | undefined, CustomerQueryVariables>;
export function useCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerSuspenseQueryHookResult = ReturnType<typeof useCustomerSuspenseQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CheckSubdomainDocument = gql`
    query checkSubdomain($subdomain: String!) {
  checkSubdomain(subdomain: $subdomain) {
    id
    name
  }
}
    `;

/**
 * __useCheckSubdomainQuery__
 *
 * To run a query within a React component, call `useCheckSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useCheckSubdomainQuery(baseOptions: Apollo.QueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables> & ({ variables: CheckSubdomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
      }
export function useCheckSubdomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
        }
// @ts-ignore
export function useCheckSubdomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>): Apollo.UseSuspenseQueryResult<CheckSubdomainQuery, CheckSubdomainQueryVariables>;
export function useCheckSubdomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>): Apollo.UseSuspenseQueryResult<CheckSubdomainQuery | undefined, CheckSubdomainQueryVariables>;
export function useCheckSubdomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckSubdomainQuery, CheckSubdomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSubdomainQuery, CheckSubdomainQueryVariables>(CheckSubdomainDocument, options);
        }
export type CheckSubdomainQueryHookResult = ReturnType<typeof useCheckSubdomainQuery>;
export type CheckSubdomainLazyQueryHookResult = ReturnType<typeof useCheckSubdomainLazyQuery>;
export type CheckSubdomainSuspenseQueryHookResult = ReturnType<typeof useCheckSubdomainSuspenseQuery>;
export type CheckSubdomainQueryResult = Apollo.QueryResult<CheckSubdomainQuery, CheckSubdomainQueryVariables>;
export const DeleteSubdomainDocument = gql`
    mutation deleteSubdomain($subdomain: String!, $id: ID!) {
  deleteSubdomain(subdomain: $subdomain, id: $id) {
    success
  }
}
    `;
export type DeleteSubdomainMutationFn = Apollo.MutationFunction<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>;

/**
 * __useDeleteSubdomainMutation__
 *
 * To run a mutation, you first call `useDeleteSubdomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubdomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubdomainMutation, { data, loading, error }] = useDeleteSubdomainMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubdomainMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>(DeleteSubdomainDocument, options);
      }
export type DeleteSubdomainMutationHookResult = ReturnType<typeof useDeleteSubdomainMutation>;
export type DeleteSubdomainMutationResult = Apollo.MutationResult<DeleteSubdomainMutation>;
export type DeleteSubdomainMutationOptions = Apollo.BaseMutationOptions<DeleteSubdomainMutation, DeleteSubdomainMutationVariables>;
export const SettingsPageDocument = gql`
    query settingsPage {
  defaultIntroMusic: getDefaultMusic(type: "intro") {
    ...DefaultMusicFields
  }
  defaultOutroMusic: getDefaultMusic(type: "outro") {
    ...DefaultMusicFields
  }
}
    ${DefaultMusicFieldsFragmentDoc}`;

/**
 * __useSettingsPageQuery__
 *
 * To run a query within a React component, call `useSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsPageQuery(baseOptions?: Apollo.QueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
      }
export function useSettingsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
        }
// @ts-ignore
export function useSettingsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsPageQuery, SettingsPageQueryVariables>;
export function useSettingsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsPageQuery | undefined, SettingsPageQueryVariables>;
export function useSettingsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsPageQuery, SettingsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsPageQuery, SettingsPageQueryVariables>(SettingsPageDocument, options);
        }
export type SettingsPageQueryHookResult = ReturnType<typeof useSettingsPageQuery>;
export type SettingsPageLazyQueryHookResult = ReturnType<typeof useSettingsPageLazyQuery>;
export type SettingsPageSuspenseQueryHookResult = ReturnType<typeof useSettingsPageSuspenseQuery>;
export type SettingsPageQueryResult = Apollo.QueryResult<SettingsPageQuery, SettingsPageQueryVariables>;
export const DefaultMusicDocument = gql`
    query defaultMusic {
  defaultIntroMusic: getDefaultMusic(type: "intro") {
    ...DefaultMusicFields
  }
  defaultOutroMusic: getDefaultMusic(type: "outro") {
    ...DefaultMusicFields
  }
}
    ${DefaultMusicFieldsFragmentDoc}`;

/**
 * __useDefaultMusicQuery__
 *
 * To run a query within a React component, call `useDefaultMusicQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultMusicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultMusicQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultMusicQuery(baseOptions?: Apollo.QueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
      }
export function useDefaultMusicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
        }
// @ts-ignore
export function useDefaultMusicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultMusicQuery, DefaultMusicQueryVariables>;
export function useDefaultMusicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultMusicQuery | undefined, DefaultMusicQueryVariables>;
export function useDefaultMusicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultMusicQuery, DefaultMusicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultMusicQuery, DefaultMusicQueryVariables>(DefaultMusicDocument, options);
        }
export type DefaultMusicQueryHookResult = ReturnType<typeof useDefaultMusicQuery>;
export type DefaultMusicLazyQueryHookResult = ReturnType<typeof useDefaultMusicLazyQuery>;
export type DefaultMusicSuspenseQueryHookResult = ReturnType<typeof useDefaultMusicSuspenseQuery>;
export type DefaultMusicQueryResult = Apollo.QueryResult<DefaultMusicQuery, DefaultMusicQueryVariables>;
export const UpdatePodcastDocument = gql`
    mutation updatePodcast($id: ID!, $podcast: PodcastInput!, $adobeArtwork: Boolean, $shouldRegenerateRssFeed: Boolean) {
  updatePodcast(
    id: $id
    podcast: $podcast
    adobeArtwork: $adobeArtwork
    shouldRegenerateRssFeed: $shouldRegenerateRssFeed
  ) {
    id
    name
    description
    categories {
      category
      subcategory
      thirdCategory
    }
    language
    feedLimit
    isExplicit
    type
    email
    hostName
    timeZone
    lockFeed
    statsUrlPrefix
    copyright
    artworkUrl
    subdomain
    links {
      apple
      spotify
      alituBadge
      facebookPage
      facebookGroup
      twitter
      instagram
      linkedin
      youtube
      website
      pandora
      iHeartRadio
      deezer
      funding
    }
    bitratePreference
    waveformPreference
    transcriptionPreferences {
      language
    }
    autoZoomPreference
    autoCenterPreference
    processingSettings {
      voiceAutoEq
      bgNoiseRemoval
      removeBreathings
    }
    thirdPartyRssFeed
    txt
    license {
      slug
      url
    }
    location {
      title
      country
      type
    }
    updateFrequency
  }
}
    `;
export type UpdatePodcastMutationFn = Apollo.MutationFunction<UpdatePodcastMutation, UpdatePodcastMutationVariables>;

/**
 * __useUpdatePodcastMutation__
 *
 * To run a mutation, you first call `useUpdatePodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodcastMutation, { data, loading, error }] = useUpdatePodcastMutation({
 *   variables: {
 *      id: // value for 'id'
 *      podcast: // value for 'podcast'
 *      adobeArtwork: // value for 'adobeArtwork'
 *      shouldRegenerateRssFeed: // value for 'shouldRegenerateRssFeed'
 *   },
 * });
 */
export function useUpdatePodcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodcastMutation, UpdatePodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodcastMutation, UpdatePodcastMutationVariables>(UpdatePodcastDocument, options);
      }
export type UpdatePodcastMutationHookResult = ReturnType<typeof useUpdatePodcastMutation>;
export type UpdatePodcastMutationResult = Apollo.MutationResult<UpdatePodcastMutation>;
export type UpdatePodcastMutationOptions = Apollo.BaseMutationOptions<UpdatePodcastMutation, UpdatePodcastMutationVariables>;
export const SetDefaultMusicDocument = gql`
    mutation setDefaultMusic($id: ID!, $newData: UpdateFile, $removeData: JSON) {
  updateFile(id: $id, newData: $newData, removeData: $removeData)
}
    `;
export type SetDefaultMusicMutationFn = Apollo.MutationFunction<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>;

/**
 * __useSetDefaultMusicMutation__
 *
 * To run a mutation, you first call `useSetDefaultMusicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMusicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMusicMutation, { data, loading, error }] = useSetDefaultMusicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newData: // value for 'newData'
 *      removeData: // value for 'removeData'
 *   },
 * });
 */
export function useSetDefaultMusicMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>(SetDefaultMusicDocument, options);
      }
export type SetDefaultMusicMutationHookResult = ReturnType<typeof useSetDefaultMusicMutation>;
export type SetDefaultMusicMutationResult = Apollo.MutationResult<SetDefaultMusicMutation>;
export type SetDefaultMusicMutationOptions = Apollo.BaseMutationOptions<SetDefaultMusicMutation, SetDefaultMusicMutationVariables>;
export const ImportPodcastRssDocument = gql`
    mutation importPodcastRss($rssFeedUrl: String!) {
  importPodcastRss(rssFeedUrl: $rssFeedUrl) {
    success
    url {
      rss
    }
  }
}
    `;
export type ImportPodcastRssMutationFn = Apollo.MutationFunction<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>;

/**
 * __useImportPodcastRssMutation__
 *
 * To run a mutation, you first call `useImportPodcastRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPodcastRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPodcastRssMutation, { data, loading, error }] = useImportPodcastRssMutation({
 *   variables: {
 *      rssFeedUrl: // value for 'rssFeedUrl'
 *   },
 * });
 */
export function useImportPodcastRssMutation(baseOptions?: Apollo.MutationHookOptions<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>(ImportPodcastRssDocument, options);
      }
export type ImportPodcastRssMutationHookResult = ReturnType<typeof useImportPodcastRssMutation>;
export type ImportPodcastRssMutationResult = Apollo.MutationResult<ImportPodcastRssMutation>;
export type ImportPodcastRssMutationOptions = Apollo.BaseMutationOptions<ImportPodcastRssMutation, ImportPodcastRssMutationVariables>;
export const RedirectRssDocument = gql`
    mutation redirectRss($url: String!) {
  redirectRss(rssFeedUrl: $url) {
    success
  }
}
    `;
export type RedirectRssMutationFn = Apollo.MutationFunction<RedirectRssMutation, RedirectRssMutationVariables>;

/**
 * __useRedirectRssMutation__
 *
 * To run a mutation, you first call `useRedirectRssMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedirectRssMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redirectRssMutation, { data, loading, error }] = useRedirectRssMutation({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useRedirectRssMutation(baseOptions?: Apollo.MutationHookOptions<RedirectRssMutation, RedirectRssMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedirectRssMutation, RedirectRssMutationVariables>(RedirectRssDocument, options);
      }
export type RedirectRssMutationHookResult = ReturnType<typeof useRedirectRssMutation>;
export type RedirectRssMutationResult = Apollo.MutationResult<RedirectRssMutation>;
export type RedirectRssMutationOptions = Apollo.BaseMutationOptions<RedirectRssMutation, RedirectRssMutationVariables>;
export const FetchHostDocument = gql`
    query fetchHost {
  host
}
    `;

/**
 * __useFetchHostQuery__
 *
 * To run a query within a React component, call `useFetchHostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHostQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchHostQuery(baseOptions?: Apollo.QueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
      }
export function useFetchHostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
        }
// @ts-ignore
export function useFetchHostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>): Apollo.UseSuspenseQueryResult<FetchHostQuery, FetchHostQueryVariables>;
export function useFetchHostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>): Apollo.UseSuspenseQueryResult<FetchHostQuery | undefined, FetchHostQueryVariables>;
export function useFetchHostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchHostQuery, FetchHostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchHostQuery, FetchHostQueryVariables>(FetchHostDocument, options);
        }
export type FetchHostQueryHookResult = ReturnType<typeof useFetchHostQuery>;
export type FetchHostLazyQueryHookResult = ReturnType<typeof useFetchHostLazyQuery>;
export type FetchHostSuspenseQueryHookResult = ReturnType<typeof useFetchHostSuspenseQuery>;
export type FetchHostQueryResult = Apollo.QueryResult<FetchHostQuery, FetchHostQueryVariables>;
export const DeleteHostTokenDocument = gql`
    mutation deleteHostToken($input: HostInput!) {
  deleteHostToken(input: $input) {
    ...ShowFragment
  }
}
    ${ShowFragmentFragmentDoc}`;
export type DeleteHostTokenMutationFn = Apollo.MutationFunction<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>;

/**
 * __useDeleteHostTokenMutation__
 *
 * To run a mutation, you first call `useDeleteHostTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHostTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHostTokenMutation, { data, loading, error }] = useDeleteHostTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHostTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>(DeleteHostTokenDocument, options);
      }
export type DeleteHostTokenMutationHookResult = ReturnType<typeof useDeleteHostTokenMutation>;
export type DeleteHostTokenMutationResult = Apollo.MutationResult<DeleteHostTokenMutation>;
export type DeleteHostTokenMutationOptions = Apollo.BaseMutationOptions<DeleteHostTokenMutation, DeleteHostTokenMutationVariables>;
export const GetTranscriptionUsageAndLimitDocument = gql`
    query getTranscriptionUsageAndLimit {
  getTranscriptionUsageAndLimit {
    usage
    limit
  }
}
    `;

/**
 * __useGetTranscriptionUsageAndLimitQuery__
 *
 * To run a query within a React component, call `useGetTranscriptionUsageAndLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptionUsageAndLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranscriptionUsageAndLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranscriptionUsageAndLimitQuery(baseOptions?: Apollo.QueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
      }
export function useGetTranscriptionUsageAndLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
        }
// @ts-ignore
export function useGetTranscriptionUsageAndLimitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>;
export function useGetTranscriptionUsageAndLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranscriptionUsageAndLimitQuery | undefined, GetTranscriptionUsageAndLimitQueryVariables>;
export function useGetTranscriptionUsageAndLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>(GetTranscriptionUsageAndLimitDocument, options);
        }
export type GetTranscriptionUsageAndLimitQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitQuery>;
export type GetTranscriptionUsageAndLimitLazyQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitLazyQuery>;
export type GetTranscriptionUsageAndLimitSuspenseQueryHookResult = ReturnType<typeof useGetTranscriptionUsageAndLimitSuspenseQuery>;
export type GetTranscriptionUsageAndLimitQueryResult = Apollo.QueryResult<GetTranscriptionUsageAndLimitQuery, GetTranscriptionUsageAndLimitQueryVariables>;
export const StartPodcastImportDocument = gql`
    mutation startPodcastImport($rssFeedUrl: String!) {
  startPodcastImport(rssFeedUrl: $rssFeedUrl) {
    ...ShowImportFields
  }
}
    ${ShowImportFieldsFragmentDoc}`;
export type StartPodcastImportMutationFn = Apollo.MutationFunction<StartPodcastImportMutation, StartPodcastImportMutationVariables>;

/**
 * __useStartPodcastImportMutation__
 *
 * To run a mutation, you first call `useStartPodcastImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPodcastImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPodcastImportMutation, { data, loading, error }] = useStartPodcastImportMutation({
 *   variables: {
 *      rssFeedUrl: // value for 'rssFeedUrl'
 *   },
 * });
 */
export function useStartPodcastImportMutation(baseOptions?: Apollo.MutationHookOptions<StartPodcastImportMutation, StartPodcastImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPodcastImportMutation, StartPodcastImportMutationVariables>(StartPodcastImportDocument, options);
      }
export type StartPodcastImportMutationHookResult = ReturnType<typeof useStartPodcastImportMutation>;
export type StartPodcastImportMutationResult = Apollo.MutationResult<StartPodcastImportMutation>;
export type StartPodcastImportMutationOptions = Apollo.BaseMutationOptions<StartPodcastImportMutation, StartPodcastImportMutationVariables>;
export const ActiveShowImportDocument = gql`
    query activeShowImport {
  activeShowImport {
    ...ShowImportFields
  }
}
    ${ShowImportFieldsFragmentDoc}`;

/**
 * __useActiveShowImportQuery__
 *
 * To run a query within a React component, call `useActiveShowImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveShowImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveShowImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveShowImportQuery(baseOptions?: Apollo.QueryHookOptions<ActiveShowImportQuery, ActiveShowImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveShowImportQuery, ActiveShowImportQueryVariables>(ActiveShowImportDocument, options);
      }
export function useActiveShowImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveShowImportQuery, ActiveShowImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveShowImportQuery, ActiveShowImportQueryVariables>(ActiveShowImportDocument, options);
        }
// @ts-ignore
export function useActiveShowImportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveShowImportQuery, ActiveShowImportQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveShowImportQuery, ActiveShowImportQueryVariables>;
export function useActiveShowImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveShowImportQuery, ActiveShowImportQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveShowImportQuery | undefined, ActiveShowImportQueryVariables>;
export function useActiveShowImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveShowImportQuery, ActiveShowImportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveShowImportQuery, ActiveShowImportQueryVariables>(ActiveShowImportDocument, options);
        }
export type ActiveShowImportQueryHookResult = ReturnType<typeof useActiveShowImportQuery>;
export type ActiveShowImportLazyQueryHookResult = ReturnType<typeof useActiveShowImportLazyQuery>;
export type ActiveShowImportSuspenseQueryHookResult = ReturnType<typeof useActiveShowImportSuspenseQuery>;
export type ActiveShowImportQueryResult = Apollo.QueryResult<ActiveShowImportQuery, ActiveShowImportQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($token: String!, $email: String!, $password: String!, $name: String!, $emailOptIn: Boolean!, $marketingData: JSON, $gclid: String, $gbraid: String, $wbraid: String, $tempaAttribution: JSON) {
  createUser(
    token: $token
    email: $email
    password: $password
    name: $name
    emailOptIn: $emailOptIn
    marketingData: $marketingData
    gclid: $gclid
    gbraid: $gbraid
    wbraid: $wbraid
    tempaAttribution: $tempaAttribution
  ) {
    user {
      ...UserFragment
    }
    show {
      ...ShowFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${ShowFragmentFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      emailOptIn: // value for 'emailOptIn'
 *      marketingData: // value for 'marketingData'
 *      gclid: // value for 'gclid'
 *      gbraid: // value for 'gbraid'
 *      wbraid: // value for 'wbraid'
 *      tempaAttribution: // value for 'tempaAttribution'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation createCustomer($company: Company, $promoCode: String, $address: StripeAddressParam, $plan: String!, $hostingPlan: String, $paymentMethod: String, $celloUcc: String, $stripeTestClock: String) {
  createCustomer(
    promoCode: $promoCode
    company: $company
    address: $address
    plan: $plan
    hostingPlan: $hostingPlan
    paymentMethod: $paymentMethod
    celloUcc: $celloUcc
    stripeTestClock: $stripeTestClock
  ) {
    clientSecret
    setupIntentId
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      company: // value for 'company'
 *      promoCode: // value for 'promoCode'
 *      address: // value for 'address'
 *      plan: // value for 'plan'
 *      hostingPlan: // value for 'hostingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *      celloUcc: // value for 'celloUcc'
 *      stripeTestClock: // value for 'stripeTestClock'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation createSubscription($paymentMethod: String, $plan: String!, $hostingPlan: String, $isEuropeanUnion: Boolean!, $company: Company, $withTrial: Boolean, $promoCode: String, $address: StripeAddressParam) {
  createSubscription(
    paymentMethod: $paymentMethod
    plan: $plan
    hostingPlan: $hostingPlan
    isEuropeanUnion: $isEuropeanUnion
    company: $company
    withTrial: $withTrial
    promoCode: $promoCode
    address: $address
  ) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
    ...SubscriptionInvoiceFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}
${SubscriptionInvoiceFragmentFragmentDoc}`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *      plan: // value for 'plan'
 *      hostingPlan: // value for 'hostingPlan'
 *      isEuropeanUnion: // value for 'isEuropeanUnion'
 *      company: // value for 'company'
 *      withTrial: // value for 'withTrial'
 *      promoCode: // value for 'promoCode'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CreateSubscriptionFromSetupIntentDocument = gql`
    mutation createSubscriptionFromSetupIntent($setupIntentId: String!) {
  createSubscriptionFromSetupIntent(setupIntentId: $setupIntentId) {
    ...SubscriptionFragment
    ...SubscriptionDiscountFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${SubscriptionDiscountFragmentFragmentDoc}`;
export type CreateSubscriptionFromSetupIntentMutationFn = Apollo.MutationFunction<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>;

/**
 * __useCreateSubscriptionFromSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionFromSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionFromSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionFromSetupIntentMutation, { data, loading, error }] = useCreateSubscriptionFromSetupIntentMutation({
 *   variables: {
 *      setupIntentId: // value for 'setupIntentId'
 *   },
 * });
 */
export function useCreateSubscriptionFromSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>(CreateSubscriptionFromSetupIntentDocument, options);
      }
export type CreateSubscriptionFromSetupIntentMutationHookResult = ReturnType<typeof useCreateSubscriptionFromSetupIntentMutation>;
export type CreateSubscriptionFromSetupIntentMutationResult = Apollo.MutationResult<CreateSubscriptionFromSetupIntentMutation>;
export type CreateSubscriptionFromSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionFromSetupIntentMutation, CreateSubscriptionFromSetupIntentMutationVariables>;
export const TaxPercentageDocument = gql`
    query taxPercentage($countryCode: String!, $vatNumber: String) {
  tax(countryCode: $countryCode, vatNumber: $vatNumber) {
    percentage
  }
}
    `;

/**
 * __useTaxPercentageQuery__
 *
 * To run a query within a React component, call `useTaxPercentageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxPercentageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxPercentageQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      vatNumber: // value for 'vatNumber'
 *   },
 * });
 */
export function useTaxPercentageQuery(baseOptions: Apollo.QueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables> & ({ variables: TaxPercentageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
      }
export function useTaxPercentageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
        }
// @ts-ignore
export function useTaxPercentageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>): Apollo.UseSuspenseQueryResult<TaxPercentageQuery, TaxPercentageQueryVariables>;
export function useTaxPercentageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>): Apollo.UseSuspenseQueryResult<TaxPercentageQuery | undefined, TaxPercentageQueryVariables>;
export function useTaxPercentageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxPercentageQuery, TaxPercentageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxPercentageQuery, TaxPercentageQueryVariables>(TaxPercentageDocument, options);
        }
export type TaxPercentageQueryHookResult = ReturnType<typeof useTaxPercentageQuery>;
export type TaxPercentageLazyQueryHookResult = ReturnType<typeof useTaxPercentageLazyQuery>;
export type TaxPercentageSuspenseQueryHookResult = ReturnType<typeof useTaxPercentageSuspenseQuery>;
export type TaxPercentageQueryResult = Apollo.QueryResult<TaxPercentageQuery, TaxPercentageQueryVariables>;
export const CountriesDocument = gql`
    query countries {
  countries {
    name
    alpha2Code
    regionalBlocs {
      name
    }
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
// @ts-ignore
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): Apollo.UseSuspenseQueryResult<CountriesQuery, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>): Apollo.UseSuspenseQueryResult<CountriesQuery | undefined, CountriesQueryVariables>;
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const PromoCodeDocument = gql`
    query promoCode($promoCode: String!, $planType: String!, $currency: String) {
  promoCode(promoCode: $promoCode, planType: $planType, currency: $currency) {
    id
    percent_off
    amount_off
    terms
    duration
    trial_days
    interval
  }
}
    `;

/**
 * __usePromoCodeQuery__
 *
 * To run a query within a React component, call `usePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *      planType: // value for 'planType'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function usePromoCodeQuery(baseOptions: Apollo.QueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables> & ({ variables: PromoCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
      }
export function usePromoCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
        }
// @ts-ignore
export function usePromoCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>): Apollo.UseSuspenseQueryResult<PromoCodeQuery, PromoCodeQueryVariables>;
export function usePromoCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>): Apollo.UseSuspenseQueryResult<PromoCodeQuery | undefined, PromoCodeQueryVariables>;
export function usePromoCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromoCodeQuery, PromoCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoCodeQuery, PromoCodeQueryVariables>(PromoCodeDocument, options);
        }
export type PromoCodeQueryHookResult = ReturnType<typeof usePromoCodeQuery>;
export type PromoCodeLazyQueryHookResult = ReturnType<typeof usePromoCodeLazyQuery>;
export type PromoCodeSuspenseQueryHookResult = ReturnType<typeof usePromoCodeSuspenseQuery>;
export type PromoCodeQueryResult = Apollo.QueryResult<PromoCodeQuery, PromoCodeQueryVariables>;
export const SubscriptionPriceDocument = gql`
    query subscriptionPrice($countryCode: String!, $planType: String!, $hostingPlan: String) {
  subscriptionPrice(
    countryCode: $countryCode
    planType: $planType
    hostingPlan: $hostingPlan
  ) {
    price
    currency
    symbol
  }
}
    `;

/**
 * __useSubscriptionPriceQuery__
 *
 * To run a query within a React component, call `useSubscriptionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPriceQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      planType: // value for 'planType'
 *      hostingPlan: // value for 'hostingPlan'
 *   },
 * });
 */
export function useSubscriptionPriceQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables> & ({ variables: SubscriptionPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
      }
export function useSubscriptionPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
        }
// @ts-ignore
export function useSubscriptionPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>;
export function useSubscriptionPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>): Apollo.UseSuspenseQueryResult<SubscriptionPriceQuery | undefined, SubscriptionPriceQueryVariables>;
export function useSubscriptionPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>(SubscriptionPriceDocument, options);
        }
export type SubscriptionPriceQueryHookResult = ReturnType<typeof useSubscriptionPriceQuery>;
export type SubscriptionPriceLazyQueryHookResult = ReturnType<typeof useSubscriptionPriceLazyQuery>;
export type SubscriptionPriceSuspenseQueryHookResult = ReturnType<typeof useSubscriptionPriceSuspenseQuery>;
export type SubscriptionPriceQueryResult = Apollo.QueryResult<SubscriptionPriceQuery, SubscriptionPriceQueryVariables>;
export const StatisticsPageDocument = gql`
    query statisticsPage($showId: ID!) {
  show(id: $showId) {
    artworkUrl
    links {
      spotify
    }
  }
}
    `;

/**
 * __useStatisticsPageQuery__
 *
 * To run a query within a React component, call `useStatisticsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticsPageQuery({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useStatisticsPageQuery(baseOptions: Apollo.QueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables> & ({ variables: StatisticsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
      }
export function useStatisticsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
        }
// @ts-ignore
export function useStatisticsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>): Apollo.UseSuspenseQueryResult<StatisticsPageQuery, StatisticsPageQueryVariables>;
export function useStatisticsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>): Apollo.UseSuspenseQueryResult<StatisticsPageQuery | undefined, StatisticsPageQueryVariables>;
export function useStatisticsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StatisticsPageQuery, StatisticsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StatisticsPageQuery, StatisticsPageQueryVariables>(StatisticsPageDocument, options);
        }
export type StatisticsPageQueryHookResult = ReturnType<typeof useStatisticsPageQuery>;
export type StatisticsPageLazyQueryHookResult = ReturnType<typeof useStatisticsPageLazyQuery>;
export type StatisticsPageSuspenseQueryHookResult = ReturnType<typeof useStatisticsPageSuspenseQuery>;
export type StatisticsPageQueryResult = Apollo.QueryResult<StatisticsPageQuery, StatisticsPageQueryVariables>;
export const GetPodcastStatsDocument = gql`
    query getPodcastStats {
  getPodcastStats {
    downloadsToday
    downloadsYesterday
    downloadsLastWeek
    downloadsLastMonth
    downloadsLastQuarter
    downloadsAllTime
  }
}
    `;

/**
 * __useGetPodcastStatsQuery__
 *
 * To run a query within a React component, call `useGetPodcastStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPodcastStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
      }
export function useGetPodcastStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
        }
// @ts-ignore
export function useGetPodcastStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>;
export function useGetPodcastStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPodcastStatsQuery | undefined, GetPodcastStatsQueryVariables>;
export function useGetPodcastStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>(GetPodcastStatsDocument, options);
        }
export type GetPodcastStatsQueryHookResult = ReturnType<typeof useGetPodcastStatsQuery>;
export type GetPodcastStatsLazyQueryHookResult = ReturnType<typeof useGetPodcastStatsLazyQuery>;
export type GetPodcastStatsSuspenseQueryHookResult = ReturnType<typeof useGetPodcastStatsSuspenseQuery>;
export type GetPodcastStatsQueryResult = Apollo.QueryResult<GetPodcastStatsQuery, GetPodcastStatsQueryVariables>;
export const GetPodcastAveragesStatsDocument = gql`
    query getPodcastAveragesStats($period: String) {
  getPodcastAveragesStats(period: $period) {
    dailyAverage
    weeklyAverage
    monthlyAverage
  }
}
    `;

/**
 * __useGetPodcastAveragesStatsQuery__
 *
 * To run a query within a React component, call `useGetPodcastAveragesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastAveragesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastAveragesStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetPodcastAveragesStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
      }
export function useGetPodcastAveragesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
        }
// @ts-ignore
export function useGetPodcastAveragesStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>;
export function useGetPodcastAveragesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPodcastAveragesStatsQuery | undefined, GetPodcastAveragesStatsQueryVariables>;
export function useGetPodcastAveragesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>(GetPodcastAveragesStatsDocument, options);
        }
export type GetPodcastAveragesStatsQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsQuery>;
export type GetPodcastAveragesStatsLazyQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsLazyQuery>;
export type GetPodcastAveragesStatsSuspenseQueryHookResult = ReturnType<typeof useGetPodcastAveragesStatsSuspenseQuery>;
export type GetPodcastAveragesStatsQueryResult = Apollo.QueryResult<GetPodcastAveragesStatsQuery, GetPodcastAveragesStatsQueryVariables>;
export const GetEpisodeDownloadsOverviewStatsDocument = gql`
    query getEpisodeDownloadsOverviewStats($episodeId: ID!) {
  getEpisodeDownloadsOverviewStats(episodeId: $episodeId) {
    downloadsToday
    downloadsYesterday
    downloadsLastWeek
    downloadsLastMonth
    downloadsLastQuarter
    downloadsForever
  }
}
    `;

/**
 * __useGetEpisodeDownloadsOverviewStatsQuery__
 *
 * To run a query within a React component, call `useGetEpisodeDownloadsOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeDownloadsOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeDownloadsOverviewStatsQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGetEpisodeDownloadsOverviewStatsQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables> & ({ variables: GetEpisodeDownloadsOverviewStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
      }
export function useGetEpisodeDownloadsOverviewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
        }
// @ts-ignore
export function useGetEpisodeDownloadsOverviewStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>;
export function useGetEpisodeDownloadsOverviewStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEpisodeDownloadsOverviewStatsQuery | undefined, GetEpisodeDownloadsOverviewStatsQueryVariables>;
export function useGetEpisodeDownloadsOverviewStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>(GetEpisodeDownloadsOverviewStatsDocument, options);
        }
export type GetEpisodeDownloadsOverviewStatsQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsQuery>;
export type GetEpisodeDownloadsOverviewStatsLazyQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsLazyQuery>;
export type GetEpisodeDownloadsOverviewStatsSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeDownloadsOverviewStatsSuspenseQuery>;
export type GetEpisodeDownloadsOverviewStatsQueryResult = Apollo.QueryResult<GetEpisodeDownloadsOverviewStatsQuery, GetEpisodeDownloadsOverviewStatsQueryVariables>;
export const GetOsStatsDocument = gql`
    query getOSStats($period: String) {
  getOSStats(period: $period) {
    androidDownloads
    windowsDownloads
    macosDownloads
    iosDownloads
    others
  }
}
    `;

/**
 * __useGetOsStatsQuery__
 *
 * To run a query within a React component, call `useGetOsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOsStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetOsStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
      }
export function useGetOsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
        }
// @ts-ignore
export function useGetOsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOsStatsQuery, GetOsStatsQueryVariables>;
export function useGetOsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOsStatsQuery | undefined, GetOsStatsQueryVariables>;
export function useGetOsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOsStatsQuery, GetOsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOsStatsQuery, GetOsStatsQueryVariables>(GetOsStatsDocument, options);
        }
export type GetOsStatsQueryHookResult = ReturnType<typeof useGetOsStatsQuery>;
export type GetOsStatsLazyQueryHookResult = ReturnType<typeof useGetOsStatsLazyQuery>;
export type GetOsStatsSuspenseQueryHookResult = ReturnType<typeof useGetOsStatsSuspenseQuery>;
export type GetOsStatsQueryResult = Apollo.QueryResult<GetOsStatsQuery, GetOsStatsQueryVariables>;
export const GetDevicesStatsDocument = gql`
    query getDevicesStats($period: String) {
  getDevicesStats(period: $period) {
    mobileDownloads
    allDownloads
  }
}
    `;

/**
 * __useGetDevicesStatsQuery__
 *
 * To run a query within a React component, call `useGetDevicesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevicesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevicesStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetDevicesStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
      }
export function useGetDevicesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
        }
// @ts-ignore
export function useGetDevicesStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>;
export function useGetDevicesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDevicesStatsQuery | undefined, GetDevicesStatsQueryVariables>;
export function useGetDevicesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>(GetDevicesStatsDocument, options);
        }
export type GetDevicesStatsQueryHookResult = ReturnType<typeof useGetDevicesStatsQuery>;
export type GetDevicesStatsLazyQueryHookResult = ReturnType<typeof useGetDevicesStatsLazyQuery>;
export type GetDevicesStatsSuspenseQueryHookResult = ReturnType<typeof useGetDevicesStatsSuspenseQuery>;
export type GetDevicesStatsQueryResult = Apollo.QueryResult<GetDevicesStatsQuery, GetDevicesStatsQueryVariables>;
export const GetCountriesStatsDocument = gql`
    query getCountriesStats($period: String) {
  getCountriesStats(period: $period) {
    countriesStats
  }
}
    `;

/**
 * __useGetCountriesStatsQuery__
 *
 * To run a query within a React component, call `useGetCountriesStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesStatsQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetCountriesStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
      }
export function useGetCountriesStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
        }
// @ts-ignore
export function useGetCountriesStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>;
export function useGetCountriesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCountriesStatsQuery | undefined, GetCountriesStatsQueryVariables>;
export function useGetCountriesStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>(GetCountriesStatsDocument, options);
        }
export type GetCountriesStatsQueryHookResult = ReturnType<typeof useGetCountriesStatsQuery>;
export type GetCountriesStatsLazyQueryHookResult = ReturnType<typeof useGetCountriesStatsLazyQuery>;
export type GetCountriesStatsSuspenseQueryHookResult = ReturnType<typeof useGetCountriesStatsSuspenseQuery>;
export type GetCountriesStatsQueryResult = Apollo.QueryResult<GetCountriesStatsQuery, GetCountriesStatsQueryVariables>;
export const GetShowDetailsStatsDocument = gql`
    query getShowDetailsStats($limit: Int!, $offset: Int!, $order: String!) {
  getShowDetailsStats(limit: $limit, offset: $offset, order: $order) {
    total
    episodeStats {
      episodeId
      name
      episodeNumber
      deletedAt
      today
      yesterday
      week
      month
      quarter
      forever
    }
  }
}
    `;

/**
 * __useGetShowDetailsStatsQuery__
 *
 * To run a query within a React component, call `useGetShowDetailsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowDetailsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowDetailsStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetShowDetailsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables> & ({ variables: GetShowDetailsStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
      }
export function useGetShowDetailsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
        }
// @ts-ignore
export function useGetShowDetailsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>;
export function useGetShowDetailsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetShowDetailsStatsQuery | undefined, GetShowDetailsStatsQueryVariables>;
export function useGetShowDetailsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>(GetShowDetailsStatsDocument, options);
        }
export type GetShowDetailsStatsQueryHookResult = ReturnType<typeof useGetShowDetailsStatsQuery>;
export type GetShowDetailsStatsLazyQueryHookResult = ReturnType<typeof useGetShowDetailsStatsLazyQuery>;
export type GetShowDetailsStatsSuspenseQueryHookResult = ReturnType<typeof useGetShowDetailsStatsSuspenseQuery>;
export type GetShowDetailsStatsQueryResult = Apollo.QueryResult<GetShowDetailsStatsQuery, GetShowDetailsStatsQueryVariables>;
export const GetAppsStatsDocument = gql`
    query getAppsStats($start: String) {
  getAppsStats(start: $start) {
    appName
    downloads
    percentage
  }
}
    `;

/**
 * __useGetAppsStatsQuery__
 *
 * To run a query within a React component, call `useGetAppsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppsStatsQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useGetAppsStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
      }
export function useGetAppsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
        }
// @ts-ignore
export function useGetAppsStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppsStatsQuery, GetAppsStatsQueryVariables>;
export function useGetAppsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppsStatsQuery | undefined, GetAppsStatsQueryVariables>;
export function useGetAppsStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppsStatsQuery, GetAppsStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppsStatsQuery, GetAppsStatsQueryVariables>(GetAppsStatsDocument, options);
        }
export type GetAppsStatsQueryHookResult = ReturnType<typeof useGetAppsStatsQuery>;
export type GetAppsStatsLazyQueryHookResult = ReturnType<typeof useGetAppsStatsLazyQuery>;
export type GetAppsStatsSuspenseQueryHookResult = ReturnType<typeof useGetAppsStatsSuspenseQuery>;
export type GetAppsStatsQueryResult = Apollo.QueryResult<GetAppsStatsQuery, GetAppsStatsQueryVariables>;
export const UniversalFilesDocument = gql`
    query universalFiles($offset: Int, $limit: Int) {
  universalFiles(offset: $offset, limit: $limit) {
    total
    categories {
      name
      previewFile
      files {
        id
        name
        duration
        users
        isAddedToLibrary
      }
    }
  }
}
    `;

/**
 * __useUniversalFilesQuery__
 *
 * To run a query within a React component, call `useUniversalFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalFilesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUniversalFilesQuery(baseOptions?: Apollo.QueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
      }
export function useUniversalFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
        }
// @ts-ignore
export function useUniversalFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>): Apollo.UseSuspenseQueryResult<UniversalFilesQuery, UniversalFilesQueryVariables>;
export function useUniversalFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>): Apollo.UseSuspenseQueryResult<UniversalFilesQuery | undefined, UniversalFilesQueryVariables>;
export function useUniversalFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UniversalFilesQuery, UniversalFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniversalFilesQuery, UniversalFilesQueryVariables>(UniversalFilesDocument, options);
        }
export type UniversalFilesQueryHookResult = ReturnType<typeof useUniversalFilesQuery>;
export type UniversalFilesLazyQueryHookResult = ReturnType<typeof useUniversalFilesLazyQuery>;
export type UniversalFilesSuspenseQueryHookResult = ReturnType<typeof useUniversalFilesSuspenseQuery>;
export type UniversalFilesQueryResult = Apollo.QueryResult<UniversalFilesQuery, UniversalFilesQueryVariables>;
export const LinkFileDocument = gql`
    mutation linkFile($id: ID!) {
  linkFile(id: $id)
}
    `;
export type LinkFileMutationFn = Apollo.MutationFunction<LinkFileMutation, LinkFileMutationVariables>;

/**
 * __useLinkFileMutation__
 *
 * To run a mutation, you first call `useLinkFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFileMutation, { data, loading, error }] = useLinkFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLinkFileMutation(baseOptions?: Apollo.MutationHookOptions<LinkFileMutation, LinkFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkFileMutation, LinkFileMutationVariables>(LinkFileDocument, options);
      }
export type LinkFileMutationHookResult = ReturnType<typeof useLinkFileMutation>;
export type LinkFileMutationResult = Apollo.MutationResult<LinkFileMutation>;
export type LinkFileMutationOptions = Apollo.BaseMutationOptions<LinkFileMutation, LinkFileMutationVariables>;
export const UnlinkFileDocument = gql`
    mutation unlinkFile($id: ID!) {
  unlinkFile(id: $id)
}
    `;
export type UnlinkFileMutationFn = Apollo.MutationFunction<UnlinkFileMutation, UnlinkFileMutationVariables>;

/**
 * __useUnlinkFileMutation__
 *
 * To run a mutation, you first call `useUnlinkFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkFileMutation, { data, loading, error }] = useUnlinkFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlinkFileMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkFileMutation, UnlinkFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkFileMutation, UnlinkFileMutationVariables>(UnlinkFileDocument, options);
      }
export type UnlinkFileMutationHookResult = ReturnType<typeof useUnlinkFileMutation>;
export type UnlinkFileMutationResult = Apollo.MutationResult<UnlinkFileMutation>;
export type UnlinkFileMutationOptions = Apollo.BaseMutationOptions<UnlinkFileMutation, UnlinkFileMutationVariables>;